// This file was converted from JS to TS and therefore, has per-line allowances for "any" types. Please do
// not add additional "any" types and please update any "any" types to the correct type if you are updating
// existing code

import {clamp} from '@benchling/js-utils';
import {datadogRum} from '@datadog/browser-rum';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import reactUpdate from 'immutability-helper';
import $ from 'jquery';
import moment from 'moment';
import React, {ClassicComponentClass} from 'react';
// @ts-expect-error
import PureRenderMixin from 'react-addons-pure-render-mixin';
import ReactDOM from 'react-dom';
import isEqual from 'react-fast-compare';
import _ from 'underscore';
import {v4 as uuidv4} from 'uuid';

import EntryActions from 'actions/EntryActions';
import * as OnboardingActions from 'actions/OnboardingActions';
import * as analytics from 'analytics/Analytics';
import {assert, assertAndContinue} from 'Asserts';
import {Permissions} from 'auth/PermissionConstants';
import InsertNoteLinkedCanvasModal from 'benchling-apps/interactivity/note-linked-canvas/InsertNoteLinkedCanvasModal';
import BenchlingConfig from 'BenchlingConfig';
import {sum} from 'BenchlingUtil';
import {Notation} from 'biojs/BioConstants';
import BufferOptions from 'buffers/BufferOptions';
import BufferOptionsItem from 'buffers/BufferOptionsItem';
import {MarvinChemicalFormat} from 'chemistry/marvinjs-wrappers/MarvinJSConstants';
import ChemicalSketcherModal from 'chemistry/molecules/ChemicalSketcherModal';
import {ResizableContainer, ResizablePanel} from 'components/ResizablePanel';
import {FixedPlateModalType} from 'constants/analytics-products/SamplesAnalyticsConstants';
import {
  ActionMethod,
  ActionOrigin,
  ANALYTICS_MODULE,
  COMMON_ANALYTICS_ACTIONS,
  ELN_ANALYTICS_ACTIONS,
  LEGACY_WORKFLOWS_ANALYTICS_ACTIONS,
  RESULTS_ANALYTICS_ACTIONS,
} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import OnboardingConstants from 'constants/OnboardingConstants';
import {TagSchema} from 'constants/RegistryConstants';
import {BatchSchema, GridType} from 'constants/SampleConstants';
import {User} from 'constants/UserConstants';
import * as context from 'Context';
import * as ExternalFileDAO from 'dao/ExternalFileDAO';
import ExternalFileUpload from 'external-files/ExternalFileUpload';
import {RegistryLabelingStrategy, SearchSection} from 'graphql-client/__generated/graphqlGlobalTypes';
import {TagSchemaItemType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isBrowser} from 'lib/Browser';
import AIContentInsertModal from 'notebook/ai-tools/AIContentInsertModal';
import addStructuredTableRowsUsingAI, {
  AddStructuredTableRowsUsingAIResult,
  SUPPORTED_TABLE_KINDS_FOR_AI_DATA_ENTRY,
} from 'notebook/ai-tools/flexible-data-entry/addStructuredTableRowsUsingAI';
import getNotePartsFromNotebookContentMessage from 'notebook/ai-tools/getNotePartsFromNotebookContentMessage';
import {GenerateDocumentContentMessage} from 'notebook/ai-tools/NotebookAIToolsConstants';
import openAICheckerPanel from 'notebook/ai-tools/openAICheckerPanel';
import {CanvasRenderer, CanvasTitleRenderer} from 'notebook/canvas/CanvasConstants';
import * as DataTableUtil from 'notebook/data-tables/DataTableUtil';
import LegacyDataTableInsertModal from 'notebook/data-tables/LegacyDataTableInsertModal';
import {StructuredTableDict} from 'notebook/documents/DocumentConstants';
import DocumentStore from 'notebook/documents/DocumentStore';
import {IndexSlice, SectionConfiguration, Selector} from 'notebook/ELNConstants';
import DaySeparator from 'notebook/entries/core-ui/DaySeparator';
import * as EntryDayOps from 'notebook/entries/EntryDayOps';
import {InsertEntryDayModal} from 'notebook/entries/InsertEntryDayModal';
import InsertSubtemplateModal from 'notebook/entry-templates/InsertSubtemplateModal';
import SubtemplateDAO from 'notebook/entry-templates/SubtemplateDAO';
import TemplateStore from 'notebook/entry-templates/TemplateStore';
import TemplateUtil from 'notebook/entry-templates/TemplateUtil';
import * as NoteLinkedAppCanvasUtil from 'notebook/integrations/benchling-apps/NoteLinkedAppCanvasUtil';
import AttachModal from 'notebook/integrations/molbio/AttachModal';
import NotebookAnnotateFillPlateModal from 'notebook/integrations/plate-maps/NotebookAnnotateFillPlateModal';
import {getAllPlateDesignNames} from 'notebook/integrations/plate-maps/plate-design/NoteLinkedPlateDesignUtil';
import {getAllPlateRecordNames} from 'notebook/integrations/plate-maps/plate-record/NoteLinkedPlateRecordUtil';
import ParameterStructuredTableParameterSelectionModal from 'notebook/integrations/procedures/add-parameters-to-table/ParameterStructuredTableParameterSelectionModal';
import {
  ParameterStructuredTableMode,
  ParameterStructuredTableModeToName,
} from 'notebook/integrations/procedures/ParameterStructuredTableConstants';
import {getTableSchemasFromParameterInfos} from 'notebook/integrations/procedures/ProceduresUtil';
import {RegistrationTableInsertType} from 'notebook/integrations/registry/RegistrationTableConstants';
import ResultsTableInsertModal from 'notebook/integrations/results/ResultsTableInsertModal';
import RunInsertModal from 'notebook/integrations/runs/RunInsertModal';
import {InventoryTableInsertionTableType} from 'notebook/integrations/samples/InventoryStructuredTableMode';
import CaptionEditableClass from 'notebook/mediocre/base-plugin/CaptionEditable';
import {getChangedStructuredTableUuids} from 'notebook/mediocre/core-ui/convertStructuredTableForPaste';
import Editor, {EditorMixinInterfaceBase, InternalEditorProps} from 'notebook/mediocre/core-ui/Editor';
import {EditorProps, SelectionPartition, StoreDependencyMap} from 'notebook/mediocre/EditorTypes';
import FormatState from 'notebook/mediocre/formatted-text/FormatState';
// @ts-expect-error
import formatters from 'notebook/mediocre/formatted-text/formatters';
import FormattersConstants, {Format} from 'notebook/mediocre/formatted-text/FormattersConstants';
import {
  EditLinkModal,
  formatText,
  getEditingLinkState,
} from 'notebook/mediocre/formatted-text/FormatTextUtil';
import PositionedLinkPopover from 'notebook/mediocre/hyperlinks/PositionedLinkPopover';
import * as MediocreConstants from 'notebook/mediocre/MediocreConstants';
import {LinkSearchDefaultQueryMessage} from 'notebook/mediocre/mentions/LinkSearchDropdown';
import PositionedLinkSearchDropdown from 'notebook/mediocre/mentions/PositionedLinkSearchDropdown';
import SlashSearchDropdown from 'notebook/mediocre/mentions/SlashSearchDropdown';
import trackInternalLink from 'notebook/mediocre/mentions/trackInternalLink';
import {isHeadlessChrome, maybeUpdatePrintWarningForContentWidth} from 'notebook/mediocre/print/PrintUtil';
import {MetadataForRestore} from 'notebook/mediocre/selection/block/MultiSelectListUtil';
import SelectionReader, {HyperlinkState, SignState} from 'notebook/mediocre/selection/text/SelectionReader';
// @ts-expect-error
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import InsertSymbolModalClass from 'notebook/mediocre/symbols/InsertSymbolModal';
import StaticFormatToolbarClass from 'notebook/mediocre/toolbars/StaticFormatToolbar';
import fetchLiveDataOnEntryMount from 'notebook/mediocre/util/FetchLiveDataOnEntryMountUtil';
import {createChemicalStructureBlob} from 'notebook/notes/attachments/molecules/MoleculeUtil';
import * as NoteLinkedFileDAO from 'notebook/notes/attachments/NoteLinkedFileDAO';
import * as NoteLinkedFileUtil from 'notebook/notes/attachments/NoteLinkedFileUtil';
import {EditorPropertiesContextInterface} from 'notebook/notes/core-ui/NoteContext';
import NoteToolbar, {
  DropdownFormat,
  getInsertGroupDropdownSections,
} from 'notebook/notes/core-ui/NoteToolbar';
import TableOfContents from 'notebook/notes/core-ui/TableOfContents';
import TitleEditor, {TitleEditorCID} from 'notebook/notes/core-ui/TitleEditor';
import {makeDefaultItem, makeFilePlaceholderItem, makeItemFromWyciwypPart} from 'notebook/notes/CreateOps';
import NoteCatcher from 'notebook/notes/drag-and-drop/NoteCatcher';
import getEntryPersistentStorage, {EntrySectionStateInterface} from 'notebook/notes/EntryPersistentStorage';
import {FromServerNoteLinkedGroup, NoteLinkedGroupKind} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import {NOTE_LINKED_GROUP_PLUGIN} from 'notebook/notes/groups/NoteLinkedGroupPlugin';
import * as NoteLinkedGroupStoreTransforms from 'notebook/notes/groups/util/NoteLinkedGroupStoreTransforms';
import {ListType, MAX_INDENTATION} from 'notebook/notes/lists/ListConstants';
import NoteConstants, {
  CidIdMap,
  NOTE_EDITOR_MIN_HEIGHT,
  PRINT_OPTION,
  TIMESTAMP_WIDTH,
} from 'notebook/notes/NoteConstants';
import NoteProtectionIndicatorToggle from 'notebook/notes/NoteProtectionIndicatorToggle';
import * as NoteStoreTransforms from 'notebook/notes/NoteStoreTransforms';
import {makeTextBoxItem} from 'notebook/notes/plugins/fill-in-text-box/FillInTextBoxUtils';
import NOTE_EDITOR_PLUGINS from 'notebook/notes/plugins/NoteEditorPlugins';
import {PLUGINS_BY_FILE_TYPE} from 'notebook/notes/previews/PreviewPluginFactory';
import getUncollapsedNoteParts from 'notebook/notes/sections/getUncollapsedNoteParts';
import renderSections from 'notebook/notes/sections/renderSections';
import {NotebookPerformanceMonitorModal} from 'notebook/performance/NotebookPerformanceMonitorModal';
import {
  NotebookPerformanceMonitorToggle,
  showNotebookPerformanceMonitorToggle,
} from 'notebook/performance/NotebookPerformanceMonitorToggle';
import ManageSelectorsModalClass, {
  ManageSelectorsModalProps,
} from 'notebook/plain-tables/selectors/ManageSelectorsModal';
import {resolveSelectorsFromPastedItems} from 'notebook/plain-tables/selectors/SelectorConflictResolver';
import SelectorDAO from 'notebook/plain-tables/selectors/SelectorDAO';
import LegacyRegistrationTableInsertModal from 'notebook/registration-tables/LegacyRegistrationTableInsertModal';
import {getRegistrationTableName} from 'notebook/registration-tables/RegistrationTableName';
import * as RegistrationTableUtil from 'notebook/registration-tables/RegistrationTableUtil';
import InventoryTableInsertModal from 'notebook/structured-tables/components/modals/InventoryTableInsertModal';
import LookupTableInsertModal from 'notebook/structured-tables/components/modals/LookupTableInsertModal';
import MixturePrepGroupInsertModal from 'notebook/structured-tables/components/modals/MixturePrepGroupInsertModal';
import RegistrationTableInsertModal, {
  ImplementedStaticSchemaInterfaceGQL,
} from 'notebook/structured-tables/components/modals/RegistrationTableInsertModal';
import TransferTableInsertModal from 'notebook/structured-tables/components/modals/TransferTableInsertModal';
import {StructuredTableFolderOption} from 'notebook/structured-tables/components/useSelectFolderOptionForTable';
import GridCreationTableInsertModal from 'notebook/structured-tables/GridCreationTableInsertModal';
import {StructuredTableMapping} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingConstants';
import {StructuredTableMappingsGlobalState} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingsState';
import updateStructuredTableMappingUuids from 'notebook/structured-tables/structured-table-mappings/updateStructuredTableMappingUuids';
import {
  LEGACY_STRUCTURED_TABLE_CONFIG_TO_TEMPLATE_CREATION_EVENTS,
  LEGACY_STRUCTURED_TABLE_TO_ENTRY_CREATION_EVENTS,
} from 'notebook/structured-tables/StructuredTableAnalyticsEvents';
import {
  StructuredTable,
  StructuredTableAdapter,
  StructuredTableKind,
} from 'notebook/structured-tables/StructuredTableConstants';
import {STRUCTURED_TABLE_PLUGIN} from 'notebook/structured-tables/StructuredTablePlugin';
import addRowsToTable from 'notebook/structured-tables/util/addRowsToTable';
import {getAllStructuredTablesFromNoteParts} from 'notebook/structured-tables/util/getAllStructuredTablesInNote';
import {StructuredTableInsertionContextValue} from 'notebook/structured-tables/util/StructuredTableInsertionContext';
import * as StructuredTableStoreTransforms from 'notebook/structured-tables/util/StructuredTableStoreTransforms';
import excess from 'notebook/tables/excess';
import {FullTableMap} from 'notebook/tables/excess/Evaluator';
import withSpreadsheetEvaluation from 'notebook/tables/spreadsheets/withSpreadsheetEvaluation';
// @ts-expect-error
import WithSpreadsheetEvaluationUserMixin from 'notebook/tables/spreadsheets/WithSpreadsheetEvaluationUserMixin';
import * as TableConstants from 'notebook/tables/TableConstants';
import {TableIndex} from 'notebook/tables/TableConstants';
import {NoteRuntimeSnapshot} from 'notebook/tables/TableStoreTransforms';
import TemplateCollectionUtil from 'notebook/template-collections/TemplateCollectionUtil';
import LegacyTransferTableInsertModal from 'notebook/transfer-tables/LegacyTransferTableInsertModal';
import * as TransferTableActions from 'notebook/transfer-tables/TransferTableActions';
import {TransferTableColumnGroup} from 'notebook/transfer-tables/TransferTableConstants';
import * as TransferTableUtil from 'notebook/transfer-tables/TransferTableUtil';
import {getEntryOrFileIdKey, getFileAnalyticsMetadata} from 'notebook/util/analytics/FileAnalyticsUtils';
import {getNumberOfRowsInNotePart} from 'notebook/util/analytics/getNumberOfRowsInNotePart';
import {getNumberOfStructuredTablesInNotePart} from 'notebook/util/analytics/getNumberOfStructuredTablesInNotePart';
import {getNumberOfEvaluableCellsInNote} from 'notebook/util/analytics/TableAnalyticsUtils';
import {getNotePartIndexFromEntryIndex, NotePartIndex} from 'notebook/util/EntryNoteIndexUtil';
// @ts-expect-error
import EntryUtil from 'notebook/util/EntryUtil';
import {
  NoteDay,
  FromServerNoteLinkedFile,
  NoteLinkedObjectType,
  NotePart,
  Note,
  AnyStructuredTable,
  NoteLinkedFile,
} from 'notebook/util/NoteUtilConstants';
import notifications from 'notifications';
import EntryNUEModule from 'onboarding/EntryNUEModule';
import {ProcedureStepConfigEditorContextValue} from 'procedures/design/step-config/ProcedureStepConfigEditorContext';
import {ProcedureStepGroupType} from 'procedures/ProcedureDomainTypes';
import DocumentEditorLockUtil from 'realtime/util/DocumentEditorLockUtil';
import {AssayRunSchema} from 'results/assay-schemas/AssaySchemaConstants';
import * as NoteLinkedAssayDataUtil from 'runs/NoteLinkedAssayDataUtil';
import {InitiatingPlateDesignStateWithNotePart} from 'samples/plate-maps/annotate-fill-plate-modal/AnnotateFillPlateModalConstants';
import CreatePlateTemplateModal from 'samples/plate-maps/create-plate-template-modal/CreatePlateTemplateModal';
import {Schema} from 'schemas/SchemaConstants';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';
import InsertSearchModal from 'search/saved-searches/InsertSearchModal';
import {SavedSearch} from 'search/saved-searches/SavedSearchUtil';
import {SearchParams} from 'search/SearchConstants';
import DisplayOptions from 'settings/visibility-options/DisplayOptions';
import {VisibilityOptions} from 'settings/visibility-options/VisibilityOptions';
import EntityStore from 'stores/EntityStore';
// @ts-expect-error
import EntryStore from 'stores/EntryStore';
import {LinkedItem} from 'ui-library/attach-dropdown/AttachDropdownConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {DatetimePickerContext} from 'ui-library/inputs/DatetimePicker';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import ModalAnchor from 'ui-library/ModalAnchor';
import * as ModalContainer from 'ui-library/ModalContainer';
import PositionedPopover from 'ui-library/PositionedPopover';
import APIUtil from 'util/APIUtil';
import * as DateUtil from 'util/DateUtil';
import * as ImportUtil from 'util/ImportUtil';
import omitKey from 'util/omitKey';
import {withLoadingScreen} from 'util/Promises';
import throttle from 'util/throttle';
import {ElementKeyboardEvent} from 'util/Types';

import CollectibleBanner from './CollectibleBanner';
import {HashNavigationManager} from './HashNavigationManager';

const {CODE_TAB, TAB} = MediocreConstants;
const {BULLET, NUMBER, CHECKBOX_UNCHECKED, CHECKBOX_CHECKED} = ListType;

const {
  TEXT,
  NOTE_FILL_IN_TEXT_BOX,
  TABLE,
  CODE,
  NOTE_LINKED_OBJECT,
  HEADER_1,
  HEADER_2,
  SUBHEADER_1,
  PARAGRAPH,
  PLATE_CREATION_TABLE,
  BOX_CREATION_TABLE,
  MIXTURE_PREP_GROUP,
  FIXED_PLATE_EDITOR,
  AI_CONTENT,
  AI_CHECKS,
  AI_DATA_ENTRY,
} = NoteConstants;

const EMPTY_INDEX_SLICE = {start: Infinity, end: -Infinity};

const ONBOARDING_ENTRY_NAMES = ['Untitled Entry', 'Example Entry', 'My First Entry'];

const HIGHLIGHT_TEXT_EDITOR_WIDTH = 430;

const getNoteReadableDate = _.memoize((date: moment.MomentInput) =>
  DateUtil.readableTime(date, {showYear: true, showTime: false, showWeekday: true})
);

const getTemplateReadableDate = _.memoize(
  (date: moment.MomentInput) => `Day ${TemplateUtil.isoDateToTemplateDay(date)}`
);

function convertDateSliceToIndexSlice(
  dateSlice: {end: number; start: number} | null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  days: Array<any>
): {end: number; start: number} | null {
  if (dateSlice == null) {
    return null;
  }

  if (days.find((d: {date: number}) => d.date < dateSlice.end) == null) {
    return EMPTY_INDEX_SLICE;
  }

  const startDay = days.find((d: {date: number}) => dateSlice.start <= d.date);
  if (startDay == null) {
    return EMPTY_INDEX_SLICE;
  }

  const end = days.find((d: {date: number}) => dateSlice.end <= d.date)?.index ?? Infinity;
  return {
    start: startDay.index,
    end,
  };
}

export interface NoteEditorContainerProps {
  cid?: string;
  afterEntry?: React.ReactNode;
  banner?: React.ReactNode;
  beforeEntry?: React.ReactNode;
  editorIcon?: JSX.Element;
  fullScreen?: boolean;
  fullHeight?: boolean;
  hideTitle?: boolean;
  humanId?: string | null;
  templateVersionId?: number;
  templateUrl?: string;
  templateVersionTimestamp?: string;
  note: Note;
  parentType: string;
  updateNote?: (
    note: Note,
    opts?: {performTableEvaluation?: boolean},
    structuredTableMappings?: Array<StructuredTableMapping>
  ) => void;
  registerObjects: (fileIdOrCidIdMap: string | CidIdMap, cidIdMap?: CidIdMap) => void;
  getIdFromCid: (cid: string) => string | number | undefined;
  getNoteRuntimeSnapshot?: (props: NoteEditorContainerProps) => NoteRuntimeSnapshot;
  cidIdMap?: object;
  preview?: {followLink?: boolean; showOpenLink?: boolean};
  displayOptions?: VisibilityOptions;
  showTableOfContents: boolean;
  showPrintMargins: boolean;
  printLayout: boolean;
  dateSlice?: {end: number; start: number} | null;
  indexSlice?: {start: number; end: number};
  collaboratorIds?: Array<string>;
  title?: string;
  fileId: string;
  locked: boolean;
  lockedFromExternalChange?: boolean;
  restoreState: (
    e: ElementKeyboardEvent,
    selectionRestoreData: MetadataForRestore<TableIndex> | {selection: SelectionRestoreData}
  ) => boolean;
  undoState: (selectionRestoreData: {selection: SelectionRestoreData}) => void;
  redoState: (selectionRestoreData: {selection: SelectionRestoreData}) => void;
  storeState: (
    selectionRestoreData?: MetadataForRestore<TableIndex> | {selection: SelectionRestoreData} | null
  ) => void;
  undoStoreState: () => void;
  requestSelection?: (
    selectionRestoreData?: MetadataForRestore<TableIndex> | {selection: SelectionRestoreData}
  ) => void;
  disableFormatting?: boolean;
  disableMaximizedTables?: boolean;
  permissions?: Permissions;
  showTimestamps?: boolean;
  spellCheck: boolean;
  viewer?: boolean;
  printHandler?: (format: PRINT_OPTION, indexSlice?: IndexSlice | null) => void;
  printOptions?: Array<string>;
  metadataForRestore?: MetadataForRestore<TableIndex> | {selection: SelectionRestoreData} | null;
  isConfig?: boolean;
  renderCanvas?: CanvasRenderer;
  renderCanvasTitle?: CanvasTitleRenderer;
  onLoad?: () => void;
  tablesToInsertOnCreation?: Array<StructuredTableDict>;
  customInsertableTables?: Array<string>;
  isVirtualizationEnabled?: boolean;
  isViewingPublishedVersion?: boolean;
  fileType?: ModelTypeConstants | null;
  titleBadge?: React.ReactNode;
  updateTitle?: (title: string) => void;
  minimalToolbar?: boolean;
  dirty?: boolean;
  focusedTableProvenanceUuid?: string | null;
  focusedTableViewMode?: string;
}

export interface NoteEditorProps extends Partial<InternalEditorProps>, Partial<NoteEditorContainerProps> {
  // These are unique to NoteEditorProps and not in InternalEditorProps
  fullScreen?: boolean;
  afterEntry?: React.ReactNode;
  beforeEntry?: React.ReactNode;
  hideTitle?: boolean;
  parentType?: string;
  showTableOfContents?: boolean;
  showPrintMargins?: boolean;
  printLayout?: boolean;
  fullHeight?: boolean;
  minimalToolbar?: boolean;
  isVirtualizationEnabled?: boolean;
  title?: string;
  sectionConfiguration?: SectionConfiguration;
  isConfig?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderCanvas?: (props: any) => JSX.Element;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderCanvasTitle?: (props: any) => JSX.Element;
  procedureStepConfigEditorContext?: ProcedureStepConfigEditorContextValue;
  disableFormatting?: boolean;
  disableMaximizedTables?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setStructuredTableMappings?: (mappings: any) => void;
  onLoad?: () => void;
  customInsertableTables?: Array<string>;
  isViewingPublishedVersion?: boolean;
  updateTitle?: (title: string) => void;
  titleBadge?: React.ReactNode;
  templateVersionId?: number;
  templateUrl?: string;
  templateVersionTimestamp?: string;
  extraUsedTableNames: () => Array<string>;
  getAllStoreDependenciesFromSpreadsheetRoot: (spreadsheetRoot: Array<NotePart>) => StoreDependencyMap;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getContent: (item: NotePart) => any;
  getSpreadsheetTableName: (item: NotePart) => string;
  getItems: (root: Note) => Array<NotePart>;
  getRoot: () => Note;
  getSpreadsheetEvalCacheKey: () => string;
  getType: (item: NotePart) => string;
  getCid: (item: NotePart) => string;
  findIndexForTableProvenanceUuid: (root: Note, uuid: string) => number;
  getProvenanceId: (item: NotePart) => number | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  itemsAccessor: (op: any) => any;
  makeFullTableMap: (props: NoteEditorContainerProps) => FullTableMap;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectorsFromProps: (props: NoteEditorContainerProps) => Array<any>;
  updateRoot: (
    root: Note,
    opts?: {
      performTableEvaluation?: boolean;
      updatedItemPartIndexes?: Array<number>;
      canIncrementalSave?: boolean;
    }
  ) => void;
  spreadsheetRoot: (props: NoteEditorContainerProps) => Array<NotePart>;
  spreadsheetTypes: Array<string>;
  structuredTableInsertionContext: StructuredTableInsertionContextValue;
  editorIcon?: JSX.Element;
  editorPropertiesContext: EditorPropertiesContextInterface;
}

interface NoteEditorState {
  // Selection and formatting states
  selected: {
    index?: number;
    subIndex?: string;
    hasNonEmptyTextSelection?: boolean;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formatState: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nonEmptySelectionState: any | null;

  // Text input and search states
  atSignState: SignState | null;
  slashSignState: SignState | null;
  hyperlinkState: HyperlinkState | null;

  // Editor layout states
  editorWidth: number;
  containerWidth?: number;
  containerHeight?: number;

  // Modal visibility states
  showInsertLinkModal: boolean;
  showManageSelectorsModal: boolean;
  showNotebookPerformanceModal: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  savedSearchInsertModalState: any | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subtemplateInsertModalState: any | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entryDayInsertModalState: any | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resultsTableInsertModalState: any | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  runInsertModalState: any | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editingLinkState: any | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chemicalStructureModalState: any | null;
  fixedPlateEditorModalState: {
    index: number;
    initiatingPlateDesignState?: InitiatingPlateDesignStateWithNotePart;
    isFixedPlateEditorModalOpen: boolean;
    eventGroupId: string;
  } | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createPlateTemplateModalState: any | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  aiContentModalState: any | null;
  registrationTableModalState: {
    index: number;
    type: string;
  } | null;
  inventoryTableModalState: {
    index: number;
    type: string;
  } | null;
  gridCreationModalState: {
    index: number;
    gridType: GridType;
  } | null;
  appCanvasInsertModalState: {
    open: boolean;
    index?: number;
  } | null;

  // Table and insertion states
  lookupTableInsertionInfo: {
    index: number | null;
    isLookupTableModalOpen: boolean;
  } | null;
  parameterTableInsertionInfo: {
    index: number;
    mode: ParameterStructuredTableMode;
  } | null;
  focusedTableProvenanceUuid?: string | null;
  focusedTableViewMode?: string | null;

  // Symbol and selector states
  initialSelectorId: string | null;
  insertingSymbolState: null | {
    index: number;
    partition: SelectionPartition;
    formats?: Format;
  };

  // Section and version states
  openVersionId: string | null;
  fileSectionState: EntrySectionStateInterface;
  latestFileSectionState: Record<string, {isOpen: boolean}>;
  forceLiveness: number;

  // Attachment states
  insertIndex?: number | null;
  highlightIndex?: number | null;
  attachIndex?: number | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attachSelection?: any;

  // Mixture prep group modal state
  mixturePrepGroupModalState: {
    index: number;
    type: string;
  } | null;

  // Multi-selection indices
  multiStartIndex?: number;
  multiEndIndex?: number;
}

interface Day {
  index: number;
  date?: string;
  cid: string;
  title?: string;
  provenanceUuid?: string;
}

interface DayCache {
  days?: Array<Day>;
  daysByIndex?: Record<number, Day>;
}

interface NoteEditorInterface
  extends Partial<ClassicComponentClass<NoteEditorProps>>,
    Partial<React.Component<NoteEditorProps, Partial<NoteEditorState>>>,
    Partial<EditorMixinInterfaceBase> {
  toggleManageSelectorsModal: (
    prevState: Partial<NoteEditorState>,
    curState: Partial<NoteEditorState>,
    manageSelectorsModalProps: ManageSelectorsModalProps
  ) => void;
  toggleNotebookPerformanceModal: (
    prevState: Partial<NoteEditorState>,
    curState: Partial<NoteEditorState>
  ) => void;
  openManageSelectorsModal: (initialSelectorId?: string) => void;
  openNotebookPerformanceModal: () => void;
  closeManageSelectorsModal: () => void;
  closeNotebookPerformanceModal: () => void;
  openInsertSymbolModal: (index: number, partition: SelectionPartition, formats?: Format) => void;
  _closeSymbolModal: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _insertSymbol: (symbol: any) => void;
  renderInsertSymbolModal: () => JSX.Element;
  editorName: () => string;
  multiSelectKey: () => string;
  defaultInsertType: string;
  textType: string;
  tableType: string;
  codeType: string;
  headerType: string;
  descType: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCreator: (item: NotePart) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getModifiedAt: (item: NotePart) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getListType: (item: NotePart) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getHeaderType: (item: NotePart) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headerTypeAccessor: (op: any) => {headerType: any};
  canItemHaveHeader: (item: NotePart) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  withUpdatedListStyle: (item: NotePart, {indentation, listType}: any) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getIndentation: (item: NotePart) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  makeItem: (type: any) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  makeItemFromWyciwypPart: any;
  isItemTextual: (item: NotePart) => boolean;
  itemHasText: (item: NotePart) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getExtraTypingPerfMetadata: () => any;
  requiresTableEvaluationOnUpdate: (item: NotePart) => boolean;
  getInitialState: () => NoteEditorState;
  openSequenceFeatureModal: (index: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertItemHandler: (index: number, type?: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replaceItems: (index: number, deleteCount: any, ...items: Array<any>) => boolean;
  deleteRangeHandler: ({start, end}: {start: number; end: number}) => void;
  finalizeItemWidth: (index: number, itemWidth: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertDay: (notePartIndex: number, title: any) => void;
  insertGivenDay: (notePartIndex: number, date: string, title: string) => void;
  deleteDay: (cid: string, e?: {stopPropagation: () => void}) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateDay: (cid: string, newTitle: any, newDate: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateTitle: (cid: string, newTitle: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateColor: (cid: string, newColor: any) => void;
  createFilePlaceholderForTask: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {taskId, fileUploadDeferred}: {taskId: string; fileUploadDeferred: any},
    item?: NotePart | null
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parseItemsFromFile: (file: any) => Promise<{items: [any]}>;
  defaultItemType: () => string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyDownHook: (index: number, e: {which: number; target: any; preventDefault: () => void}) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _convertToList: (index: number, afterText: any, afterFormats: any, listType: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  alignmentFormatHandler: (index: number, alignment: any) => void;
  importantFormatRangeHandler: (start: number, end: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headerFormatRangeHandler: (start: number, end: number, headerType: any) => void;
  cycleHeaderType: (headerType: string) => string;
  cycleHeaderFormatRangeHandler: (start: number, end: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rangeHeaderTypes: (noteParts: Array<any>) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  checkHandler: (index: number, newCheckedValue: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isRangeListType: (start: any, end: any, ...listTypes: Array<any>) => boolean;
  noteListRangeHandler: (start: number, end: number, listTypeOriginal: ListType) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateFormattedText: ({formats, text, start, end}: any, index: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  textItemFormatHandler: (index: number, {format, data, partition}: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _toolbarFormatHandler: (format: string, data?: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _toolbarInsertItemHandler: (type: any) => void;
  _toolbarMouseOverHandler: (fmt: string) => void;
  _toolbarMouseOutHandler: () => void;
  _openSavedSearchInsertModal: (index: number, partition: SelectionPartition, formats?: Format) => void;
  _insertSavedSearch: (savedSearch: SavedSearch) => void;
  _closeSavedSearchInsertModal: () => void;
  renderSavedSearchInsertModal: () => JSX.Element;
  _openSubtemplateInsertModal: (index: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _submitSubtemplateInsertModal: (subtemplateId: any) => void;
  _closeSubtemplateInsertModal: () => void;
  renderSubtemplateInsertModal: () => JSX.Element;
  _openEntryDayInsertModal: (index: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _submitEntryDayInsertModal: (title: any, date: any) => void;
  _closeEntryDayInsertModal: () => void;
  renderEntryDayInsertModal: () => JSX.Element;
  _getDatesBetweenIndex: (index: number) => {previousDate: string; nextDate: string};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openResultsTableInsertModal: (index: number, type: any) => void;
  _closeResultsTableInsertModal: () => void;
  _openRunInsertModal: (index: number) => void;
  _closeRunInsertModal: () => void;
  openInsertLinkModal: (
    formats: Format,
    partition: {before: string; selected: string; after: string},
    editingFormatIndex: number
  ) => void;
  closeInsertLinkModal: () => void;
  _insertEmptyNoteLinkedAssayData: (assayRunSchema: AssayRunSchema) => void;
  _getStructuredTableAnalyticsParams: (
    structuredTable: Omit<StructuredTable<unknown, unknown>, 'cid'> | null,
    extraAnalyticsParams?: {}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => any;
  _getLegacyStructuredTableAnalyticsParams: (
    // This is the old pre-StructuredTable structured tables, e.g. Legacy RegistrationTable, etc.
    structuredTable?: {provenanceUuid: string},
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extraAnalyticsParams?: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => any;
  _fireStructuredTableInsertionAnalyticsEvent: (
    structuredTable: Omit<StructuredTable<unknown, unknown>, 'cid'>,
    structuredTableKindOrNoteLinkedGroupKind: StructuredTableKind | NoteLinkedGroupKind,
    isLegacyStructuredTable: boolean,
    extraAnalyticsParams?: {}
  ) => void;
  _inStageEntryOrTemplate: () => boolean;
  _insertStructuredTable: (
    index: number,
    kind: StructuredTableKind | NoteLinkedGroupKind,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tableNameBase: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schemasAndColumnGroups: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    metadata: any,
    selectorsById: {[selectorId: string]: SchemaFieldSelector},
    extraAnalyticsParams?: {}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _insertLegacyDataTableConfig: ({dataTableConfig, cidIdMap}: {dataTableConfig: any; cidIdMap: any}) => void;
  renderResultsTableInsertModal: () => JSX.Element | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _insertFromResultsStructuredTableInsertModal: ({schema, metadata, selectorsById}: any) => void;
  renderRunInsertModal: () => JSX.Element | null;
  _openChemicalStructureInsertModal: (index: number) => void;
  _closeChemicalStructureInsertModal: () => void;
  _insertFromChemicalStructureModal: (sketcherModalOutput: {
    sketcherValue: string;
    filename: string;
    saveFormat: MarvinChemicalFormat;
  }) => Promise<void>;
  renderChemicalStructureInsertModal: () => JSX.Element | null;
  isDocument: () => boolean;
  openFixedPlateEditorModal: (
    index: number,
    initiatingPlateDesignState?: InitiatingPlateDesignStateWithNotePart
  ) => void;
  _closeFixedPlateEditorModal: () => void;
  _insertFromFixedPlateEditorModal: () => void;
  renderFixedPlateEditorModal: () => JSX.Element | null;
  _openCreatePlateTemplateModal: (index: number) => void;
  _closeCreatePlateTemplateModal: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _insertFromCreatePlateTemplateModal: (createPlateTemplateModalOutput: any) => void;
  renderCreatePlateTemplateModal: () => JSX.Element | null;
  _openAIContentInsertModal: (index: number) => void;
  _closeAIContentInsertModal: () => void;
  _insertFromAIContentInsertModal: ({message}: {message: GenerateDocumentContentMessage}) => void;
  _openAICheckerPanel: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openRegistrationTableInsertModal: (index: number, type: any) => void;
  _closeRegistrationTableInsertModal: () => void;
  _insertFromRegistrationTableInsertModal: ({
    schema,
    insertType,
    labelingStrategy,
    selectorsById,
    implementedSchemaInterfaces,
    tagSchemaItemType,
    notation,
    customSyntaxName,
    folderOption,
    folderId,
  }: {
    schema: TagSchema;
    insertType: RegistrationTableInsertType;
    labelingStrategy: RegistryLabelingStrategy;
    selectorsById: {[selectorId: string]: SchemaFieldSelector};
    implementedSchemaInterfaces: Array<ImplementedStaticSchemaInterfaceGQL>;
    tagSchemaItemType: TagSchemaItemType;
    notation: Notation | null;
    customSyntaxName?: string | null;
    folderOption?: StructuredTableFolderOption;
    folderId?: string;
  }) => void;
  _insertFromLegacyRegistrationTableInsertModal: ({
    tagSchema,
    tableType,
    labelingStrategy,
    selectorsById,
  }: {
    tagSchema: TagSchema;
    batchSchema: BatchSchema | null;
    tableType: string;
    labelingStrategy: string | null;
    selectorsById: {[selectorId: string]: SchemaFieldSelector};
  }) => void;
  renderAIContentInsertModal: () => JSX.Element | null;
  renderRegistrationTableInsertModal: () => JSX.Element | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openInventoryTableInsertModal: (index: number, type: any) => void;
  _closeInventoryTableInsertModal: () => void;
  _insertFromLegacyTransferTableInsertModal: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {containerSchema, parentStorableIsGrid}: any,
    selectorsById: {[selectorId: string]: SchemaFieldSelector}
  ) => Promise<void>;
  _insertFromTransferTableInsertModal: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {metadata, destinationContainerSchema, destinationPlateSchema}: any,
    selectorsById: {[selectorId: string]: SchemaFieldSelector}
  ) => void;
  _insertUpdateContainersTableFromInventoryTableInsertModal: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {metadata, storableSchema, plateWellSchema}: any,
    selectorsById: {[selectorId: string]: SchemaFieldSelector}
  ) => void;
  _insertFromInventoryTableInsertModal: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    insertionConfiguration: {[x: string]: any; tableType: any},
    selectorsById: {[selectorId: string]: SchemaFieldSelector}
  ) => void;
  renderInventoryTableInsertModal: () => JSX.Element | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openGridCreationTableInsertModal: (index: number, gridType: any) => void;
  _closeGridCreationTableInsertModal: (index?: number) => void;
  _insertFromGridCreationTableInsertModal: ({
    schema,
    shouldAutogenerateBarcode,
    requireCustomName,
    selectorsById,
  }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schema: any;
    shouldAutogenerateBarcode: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    requireCustomName: any;
    selectorsById: {[selectorId: string]: SchemaFieldSelector};
  }) => void;
  renderGridCreationTableInsertModal: () => JSX.Element | null;
  _openAppCanvasInsertModal: (index: number) => void;
  _closeAppCanvasInsertModal: () => void;
  _insertNoteLinkedAppCanvas: (appInstallationApiId: string, featureId: string) => void;
  renderAppCanvasInsertModal: () => JSX.Element | null;
  _openLookupTableInsertModal: (index: number) => void;
  _closeLookupTableInsertModal: (index?: number) => void;
  _insertFromLookupTableInsertModal: ({
    schema,
    selectorsById,
  }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schema: any;
    selectorsById: {[selectorId: string]: SchemaFieldSelector};
  }) => void;
  renderLookupTableInsertModal: () => JSX.Element | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openParameterTableInsertModal: (index: number, mode: any) => void;
  _closeParameterTableInsertModal: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _insertFromParameterTableInsertModal: ({parameters}: {parameters: any}) => void;
  renderParameterTableInsertModal: () => JSX.Element | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openMixturePrepGroupInsertModal: (index: number, type: any) => void;
  _closeMixturePrepGroupInsertModal: () => void;
  _insertFromMixturePrepGroupInsertModal: (
    schema: BatchSchema | Schema,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    labelingStrategy: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parentLinkMixtureFieldId: any,
    selectorsById: {[selectorId: string]: SchemaFieldSelector}
  ) => void;
  renderMixturePrepGroupInsertModal: () => JSX.Element | null;
  formatHandler: (
    {
      index,
      subIndex,
      startOffset,
      endOffset,
    }: {index?: number; subIndex?: string; startOffset?: number; endOffset?: number},
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e: {partition?: SelectionPartition; format?: string; data?: any}
  ) => void;
  _insertTableOrWellPlate: (index: number, rows: number, cols: number, isWellPlate: boolean) => void;
  insertTableWithDimensions: (rows: number, cols: number) => void;
  insertWellPlateWithDimensions: (rows: number, cols: number) => void;
  deleteItem: (index: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  moveHandler: (index: number, e: {up: any; beginning: any}) => void;
  titleMoveHandler: ({up, beginning}: {up: boolean; beginning: boolean}) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getComputedTables: (root: Note) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getValidationErrorSnapshot: () => any;
  isVirtualizationSupported: () => boolean;
  _catcherSetInsertIndex: (index: number) => void;
  _catcherInsertFile: (index: number, linkedItem: LinkedItem) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertPlaceholders: (index: number, taskIdAndDeferreds: Array<any>) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _catcherInsertFilePlaceholder: (index: number, taskIdAndDeferreds: any) => void;
  onMouseDownCatcher: (e: {
    target: string | Element | Text | null;
    preventDefault: () => void;
    pageY: number;
  }) => boolean | void;
  _editorSizerThrottledHandleResize: () => void;
  _editorSizerHandleResize: () => void;
  onSetFocusedTable: (
    focusedTableProvenanceUuid: string | null,
    focusedTableViewMode: TableConstants.FocusedTableViewMode
  ) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _updateFileSectionState: (prevOpenVersionId: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _getVersionId: (fileId: any, fileType: any) => any;
  _getNoteEditorContainer: () => Element | null;
  _saveEditorScrollPosition: () => void;
  _restoreEditorScrollPosition: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _scrollToNotePart: (provenanceUuid: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDocumentVersionCid: () => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getTextForDate: (date: any) => string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _renderBeforeEditable: (index: number, startIndex: any) => JSX.Element | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _handleSectionToggle: (index: number, isOpen: any, puuid: string | number) => void;
  _isDayOnly: () => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSearchableItems: (note: Note) => any;
  postProcessRenderedItems: (
    indexSlice: {start: number; end: number},
    renderedItems: Array<JSX.Element>
  ) => Array<React.ReactElement>;
  _shouldAllowInsertSavedSearch: () => boolean;
  _shouldAllowInsertSubtemplate: () => boolean;
  _shouldAllowInsertDay: () => boolean;
  _shouldAllowInsertSection: () => boolean;
  _isViewingOldVersion: () => boolean;
  setProtected: (isProtected: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getToolBarProps: () => any;
  renderToolbar: () => JSX.Element;
  _showCollectibleBanner: () => boolean;
  renderCollectibleBanner: () => JSX.Element;
  _getSelectedIndexSlice: () => {start: number; end: number} | null;
  selectionPrintHandler: (type: PRINT_OPTION) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChangeSelected: (value: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChangeFormatState: (value: any) => void;
  handleChangeAtSignState: (value: SignState | null) => void;
  handleChangeSlashSignState: (slashSignState: SignState | null) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChangeHyperlinkState: (value: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChangeNonEmptySelectionState: (value: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSlashSelect: (id: any) => void;
  render: () => JSX.Element;
  renderFocusedEditor: () => JSX.Element;
  renderEditorContainer: () => JSX.Element;
  renderModals: () => JSX.Element;
  renderOnboardingModule: () => JSX.Element | undefined;
  getElementByScrollId: (cid: string) => HTMLElement | null;
  renderEditorSlice: () => React.ReactNode;
  formatAtIndexHandler: (
    index: number,
    args: {
      format: string;
      partition: SelectionPartition;
    }
  ) => void;
  itemDetachHandler: (index: number, e: {stopPropagation: () => void}) => void;
  _savedEditorScrollTop: number | null;
  scrollContainerNode: HTMLDivElement | null;
  setScrollContainerRef: (node: HTMLDivElement) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  plugins: Array<any>;
  setNoteLinkedFileFromS3Location: (cid: string, s3Location: string) => Promise<void>;
  withAttachedItem: (
    currentItem: NotePart,
    type: string,
    itemId: string | number | null,
    linkedItem: LinkedItem,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    param?: {externalFileExcerpt?: any}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  uploadAndAttachToItem: (index: number, file: any) => void;
  replacePlaceholderWithBenchlingItem: (index: number, item: LinkedItem) => void;
  insertSubtemplate: (
    subtemplateId: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    indexOverride: any
  ) => void;
  getRoot?: () => Note;
  insertNoteLinkedFileFromS3Location: (index: number, s3Location: string) => Promise<void>;
  setImageFromS3Location: (
    cid: string,
    previewS3Location: string,
    itemWidth: number,
    name: string
  ) => Promise<void>;
  getSelectedRange?: (index: number) => {start: number; end: number} | null;
  isProtectedAgainstEdit: () => boolean;
  isLockedWithEditWarn: () => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _colorHandler?: (color: any) => void;
  noteSplitHandler: (
    index: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e: {before: string; after: string; selected: string; afterPoint?: any; shiftKey?: boolean}
  ) => void;
  closeAttachFeatureModal: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  noteAttachItemHandler: (index: number, type: any, itemId: any, item: NotePart) => void;
  closeSlashSearchDropdown: () => void;
  insertInternalLink: (
    id: number | string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    linkedItem: any,
    internalLink?: MediocreConstants.InternalLink
  ) => void;
  tabHandler: (
    index: number,
    e: {
      partition: SelectionPartition;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      shiftKey: any;
    }
  ) => void;
  closeLinkSearchDropdown: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateItemCode: (index: number, code: any) => void;
  codeUpdateHandler: (
    index: number,
    {
      text,
    }: {
      text: string;
    }
  ) => void;
  inputBoxCursorHandler: (index: number, {position}: {position: string}) => void;
  _codeInsertHandler: (
    index: number,
    e: {before: string; after: string},
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    toInsert: string | Array<any>
  ) => void;
  codeSplitHandler: (index: number, e: {before: string; after: string}) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _textInsertHandler: (index: number, e: any, toInsert: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  textSplitHandler: (index: number, e: any) => void;
  setAttachFeatureIndex: (index: number | null) => void;
  insertExcerptsHandler: (
    index: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    excerpts: Array<any>,
    {
      replace,
    }: {
      replace?: boolean | undefined;
    }
  ) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  context?: any;
  setState?: (state: Partial<NoteEditorState>) => void;
  state?: NoteEditorState;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  forceUpdate?: any;
  props?: NoteEditorProps;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refs?: any;
  setUpdatedNoteLinkedFile: (index: number, newNoteLinkedFile: FromServerNoteLinkedFile) => Promise<void>;
  storeStateForNoteLinkedObject: (notePart: NotePart) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateNoteLinkedObject: (index: number, updates: any) => void;
  _getAIDataEntryStructuredTableNoteParts: () => Array<{
    notePart: NotePart;
    index: number;
    table: StructuredTable<unknown, unknown>;
    adapter: StructuredTableAdapter<unknown, unknown>;
  }>;
  _addAIDataEntryRows: (
    result: AddStructuredTableRowsUsingAIResult | null,
    structuredTable?: StructuredTable<unknown, unknown>
  ) => void;
  addAIDataEntryRowsUsingAI: (
    initialPromptText?: string,
    initialSelectedTableName?: string,
    structuredTable?: StructuredTable<unknown, unknown>,
    result?: AddStructuredTableRowsUsingAIResult | null
  ) => Promise<void>;
  replaceExistingNoteLinkedObject: (
    cid: string,
    noteLinkedObject: NoteLinkedFile | FromServerNoteLinkedFile,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options?: {itemWidth?: any}
  ) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replacePlaceholderWithFile: (index: number, taskIdsAndDeferreds: string | Array<any>) => void;
  hasMultiSelection?: () => boolean;
  getIndex?: (cid: string) => number;
  tabRangeHandler: ({start, end, shiftKey}: {start: number; end: number; shiftKey: boolean}) => void;
  insertNoteLinkedObject: (index: number, noteLinkedObject: NotePart | null | undefined) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputBoxDeleteHandler: (index: number, param: any | null) => void;
  captionSplitHandler: (index: number, e: {shiftKey?: boolean; before?: string; after?: string}) => void;
  codeTabHandler: (
    index: number,
    e: {shiftKey?: boolean; before?: string; after?: string; partition?: {before: string; after: string}}
  ) => void;
  statics: {
    getRenderedDayOfNotePart: (index: number, startIndex: number, days: Array<Day>) => Day | null | undefined;
  };
  mixins: [WithSpreadsheetEvaluationUserMixin, PureRenderMixin];
}

export const NoteEditor = Editor.createClass<NoteEditorProps, Partial<NoteEditorState>, NoteEditorInterface>({
  // Scroll position of the NoteEditor to restore after collapsing a maximized table.
  _savedEditorScrollTop: null,
  scrollContainerNode: null,

  setScrollContainerRef(node: HTMLDivElement) {
    this.scrollContainerNode = node;
  },

  statics: {
    /**
     * Returns the day of the current note part if it is the first of the day or if index is startIndex,
     * otherwise null / undefined.
     *
     * It caches an indexed days structure to speed up consecutive calls.
     */
    getRenderedDayOfNotePart: ((_cache: DayCache = {}) =>
      function (index: number, startIndex: number, days: Array<Day>): Day | null | undefined {
        if (days !== _cache.days) {
          _cache.daysByIndex = _.indexBy(days, 'index');
          _cache.days = days;
        }
        if (startIndex > 0 && index === startIndex) {
          return EntryUtil.getDayOfNotePart(index, days);
        } else {
          return _cache.daysByIndex?.[index];
        }
      })({}),
  },

  mixins: [WithSpreadsheetEvaluationUserMixin, PureRenderMixin],

  plugins: NOTE_EDITOR_PLUGINS,

  displayName: 'NoteEditor',

  getDefaultProps() {
    return {
      editorKey: 'notes',
      fullScreen: true,
    } as NoteEditorProps;
  },

  getInitialState() {
    const fileId = this.props!.fileId;
    const days = this.props!.note!.days!;

    const initialState = {
      selected: {},
      formatState: FormatState.readFormats(),
      atSignState: null,
      hyperlinkState: null,
      editorWidth: 700,
      showInsertLinkModal: false,
      showManageSelectorsModal: false,
      showNotebookPerformanceModal: false,
      initialSelectorId: null,
      insertingSymbolState: null,
      forceLiveness: 0,
      slashSignState: null,
      nonEmptySelectionState: null,
      openVersionId: this._getVersionId(this.props!.fileId!, this.props!.fileType),
      fileSectionState: {},
      latestFileSectionState: {},
      savedSearchInsertModalState: null,
      subtemplateInsertModalState: null,
      entryDayInsertModalState: null,
      resultsTableInsertModalState: null,
      runInsertModalState: null,
      chemicalStructureModalState: null,
      fixedPlateEditorModalState: null,
      createPlateTemplateModalState: null,
      aiContentModalState: null,
      registrationTableModalState: null,
      inventoryTableModalState: null,
      gridCreationModalState: null,
      appCanvasInsertModalState: null,
      lookupTableInsertionInfo: null,
      parameterTableInsertionInfo: null,
      mixturePrepGroupModalState: null,
      editingLinkState: null,
    };

    if (BenchlingConfig.ELN_ENABLE_ENTRY_SECTIONS && !this._isViewingOldVersion() && fileId && days) {
      const initialFileSectionState = getEntryPersistentStorage().getFileSectionState(fileId, days);
      initialState.fileSectionState = initialFileSectionState;
      initialState.latestFileSectionState = initialFileSectionState;
    }

    return initialState;
  },

  toggleManageSelectorsModal(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    prevState: {showManageSelectorsModal: any},
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    curState: {showManageSelectorsModal: any},
    manageSelectorsModalProps: ManageSelectorsModalProps
  ) {
    if (curState.showManageSelectorsModal) {
      ModalContainer.open(
        ManageSelectorsModalClass,
        <ManageSelectorsModalClass {...manageSelectorsModalProps} />
      );
    } else if (prevState.showManageSelectorsModal && !curState.showManageSelectorsModal) {
      this.closeManageSelectorsModal();
    }
  },

  toggleNotebookPerformanceModal(
    prevState: {showNotebookPerformanceModal: boolean},
    curState: {showNotebookPerformanceModal: boolean}
  ) {
    if (curState.showNotebookPerformanceModal) {
      ModalContainer.open(
        NotebookPerformanceMonitorModal,
        <NotebookPerformanceMonitorModal
          note={this.props!.note!}
          onRequestClose={this.closeNotebookPerformanceModal}
        />
      );
      const fileIdKey = getEntryOrFileIdKey(this.props?.fileId);
      analytics.trackEvent(ELN_ANALYTICS_ACTIONS.OPENED_NOTEBOOK_PERFORMANCE_MONITOR, {
        type: APIUtil.apiIdToType(this.props!.fileId!),
        [fileIdKey]: this.props!.fileId!,
      });
    } else if (prevState.showNotebookPerformanceModal && !curState.showNotebookPerformanceModal) {
      this.closeNotebookPerformanceModal();
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openManageSelectorsModal(initialSelectorId: any) {
    this.setState?.({showManageSelectorsModal: true, initialSelectorId});
  },

  openNotebookPerformanceModal() {
    this.setState?.({showNotebookPerformanceModal: true});
  },

  closeManageSelectorsModal() {
    this.setState?.({showManageSelectorsModal: false, initialSelectorId: null});
    ModalContainer.close(ManageSelectorsModalClass);
  },

  closeNotebookPerformanceModal() {
    this.setState?.({showNotebookPerformanceModal: false});
    ModalContainer.close(NotebookPerformanceMonitorModal);
  },

  openInsertSymbolModal(index: number, partition: SelectionPartition, formats?: Format) {
    this.setState?.({insertingSymbolState: {index, partition, formats}});
  },

  _closeSymbolModal() {
    this.setState?.({insertingSymbolState: null});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _insertSymbol(symbol: any) {
    assert(this.state!.insertingSymbolState != null, 'Expected insertingSymbolState to be set');
    const {formats, partition, index} = this.state!.insertingSymbolState;
    const {formats: newFormats, text, end} = formatters.replaceText(formats, partition, symbol);
    // After insert, place cursor at end of range.
    this.updateFormattedText({text, start: end, end, formats: newFormats}, index);
    analytics.track('editor', 'inserted_symbol', {symbol});
  },

  renderInsertSymbolModal() {
    return (
      <ModalAnchor open={this.state!.insertingSymbolState != null}>
        <InsertSymbolModalClass
          onRequestClose={this._closeSymbolModal}
          onRequestSubmit={this._insertSymbol}
        />
      </ModalAnchor>
    );
  },

  // Required by Editor
  editorName() {
    return 'note';
  },
  multiSelectKey() {
    return 'note';
  },
  defaultInsertType: TEXT,
  textType: TEXT,
  tableType: TABLE,
  codeType: CODE,
  headerType: TEXT,
  descType: TEXT,
  getCreator(item: {creator?: User}) {
    return item.creator;
  },
  getModifiedAt(item: NotePart) {
    return item.modified_at;
  },
  getListType(item: {listType: string | null}) {
    return item.listType;
  },
  getHeaderType(item: {headerType: string | null}) {
    return item.headerType;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headerTypeAccessor(op: any) {
    return {headerType: op};
  },
  canItemHaveHeader(item: {type: string}) {
    return item.type === TEXT;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  withUpdatedListStyle(item: NotePart, {indentation, listType}: any) {
    return {...item, indentation, listType};
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getIndentation(item: {indentation: any}) {
    return item.indentation;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  makeItem(type: any) {
    return makeDefaultItem(type);
  },
  makeItemFromWyciwypPart,
  // In this case, 'text' means formatted text (e.g. paragraph text and caption text), but not
  // other text attributes like code. 'Textual' means that the item is predominantly text
  isItemTextual(item: NotePart) {
    return [TEXT].includes(this.props!.getType?.(item) ?? '');
  },
  itemHasText(item: NotePart) {
    return ![
      CODE,
      ModelTypeConstants.DATA_TABLE,
      ModelTypeConstants.DATA_TABLE_CONFIG,
      ModelTypeConstants.NOTE_LINKED_ASSAY_DATA,
      ModelTypeConstants.NOTE_LINKED_CHART,
      ModelTypeConstants.NOTE_LINKED_GROUP,
      ModelTypeConstants.NOTE_LINKED_PLATE_RECORD,
      ModelTypeConstants.REGISTRATION_TABLE,
      ModelTypeConstants.REGISTRATION_TABLE_CONFIG,
      ModelTypeConstants.STRUCTURED_TABLE,
      ModelTypeConstants.TRANSFER_TABLE,
      ModelTypeConstants.TRANSFER_TABLE_CONFIG,
    ].includes(this.props!.getType?.(item) ?? '');
  },
  getExtraTypingPerfMetadata() {
    const root = this.props!.getRoot();
    const items = this.props!.getItems(root);
    const itemCounts = _.countBy(items, (item) => `num_${item.type}`);
    const totalRows = sum(items, (item: NotePart) => getNumberOfRowsInNotePart(item, this.props!.fileId!));
    const numberOfStrucuturedTables = sum(items, (item: NotePart) =>
      getNumberOfStructuredTablesInNotePart(item)
    );
    const tableCellCount = getNumberOfEvaluableCellsInNote(root);
    return {
      // Count entry days if they exist -- e.g. they do not exist in the NoteEditor in the Description tab.
      num_days: root.days?.length,
      num_items: items.length,
      num_strucutured_tables: numberOfStrucuturedTables,
      num_total_rows: totalRows,
      num_evaluable_cells: tableCellCount,
      ...itemCounts,
    };
  },

  requiresTableEvaluationOnUpdate(item: NotePart) {
    return [
      TABLE,
      ModelTypeConstants.DATA_TABLE,
      ModelTypeConstants.DATA_TABLE_CONFIG,
      ModelTypeConstants.NOTE_LINKED_ASSAY_DATA,
      ModelTypeConstants.REGISTRATION_TABLE,
      ModelTypeConstants.REGISTRATION_TABLE_CONFIG,
      ModelTypeConstants.STRUCTURED_TABLE,
      ModelTypeConstants.TRANSFER_TABLE,
      ModelTypeConstants.TRANSFER_TABLE_CONFIG,
    ].includes(this.props!.getType(item));
  },

  makeEditorProps(props: Partial<NoteEditorProps>) {
    return {
      ...this.makeEditorPropsBase?.(props),
      disableFormatting: props.disableFormatting,
      disableMaximizedTables: props.disableMaximizedTables, // For QuickEditModal
      permissions: props.permissions,
      showTimestamps: props.showTimestamps,
      spellCheck: props.spellCheck,
      preview: props.preview,
      registerObjects: props.registerObjects,
      getIdFromCid: props.getIdFromCid,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      isProtected: (props.note as any)?.isProtected,
      dirty: props.dirty,
      setStructuredTableMappings: this.props!.setStructuredTableMappings,
      addAIDataEntryRowsUsingAI: this.addAIDataEntryRowsUsingAI,
    } as EditorProps<NotePart>;
  },

  openSequenceFeatureModal(index: number) {
    // index can be -1 to insert at the beginning
    this.setAttachFeatureIndex(index);
  },

  insertItemHandler(index: number, type: string | null = null) {
    if (type == null) {
      type = this.defaultItemType();
    }
    let currentIndentation = 0;
    // index can be -1 to insert at the beginning
    if (0 <= index && index <= this.lastIndex!()) {
      currentIndentation = this.getIndentation(this.atIndex!(index));
    }
    const item = {
      ...this.createDefaultableItem!(type),
      indentation: currentIndentation,
    };

    if (type === 'text') {
      this.itemInsertHandler?.(index, item);
    } else {
      // Insert an extra line of text so the user can insert content between components
      const extraLine = this.createDefaultableItem!('text');
      this.itemInsertHandler?.(index, item, extraLine);
    }
  },

  /**
   * Replace `deleteCount` items starting at `index` with `items`.
   * Returns a boolean indicating if the replace was successful.
   *
   * Before invoking, the caller is expected to call `storeState(...)`.
   * After invoking, if `replaceItems` returns:
   *  - true: the caller should now call `requestSelection(...)`
   *  - false: the caller should abort any downstream logic
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replaceItems(index: number, deleteCount: any, ...items: Array<any>) {
    if (!this.isReplaceItemsAllowedOrWarn!(index, deleteCount, ...items)) {
      return false;
    }

    let newRoot = reactUpdate(
      this.props!.getRoot(),
      this.props!.itemsAccessor({$splice: [[index, deleteCount, ...items]]})
    );
    if (this.props!.renderCanvas) {
      // When rendering in different canvases, note parts may be re-ordered and we need to ensure that we filter
      // out duplicates and only maintain the most recently updated copy of the note part
      const newItemCidToIndex: {[cid: string]: number} = {};
      items.forEach(({cid}, itemIndex) => {
        newItemCidToIndex[cid] = index + itemIndex;
      });
      newRoot.noteParts = newRoot.noteParts.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item: {cid: string}, itemIndex: any) =>
          !newItemCidToIndex[item.cid] || newItemCidToIndex[item.cid] === itemIndex
      );
    }
    if (newRoot.days != null) {
      const previousCids = this.props!.getRoot()
        .noteParts.slice(index, index + deleteCount)
        .map(({cid}: {cid: string}) => cid);
      const newCids = items.map(({cid}) => cid);
      // If we format across days (or toggle important, etc.), we don't want to merge them
      // into the same day.
      if (!isEqual(previousCids, newCids)) {
        newRoot = EntryDayOps.updateDaysForReplace(newRoot, index, index + deleteCount, items.length);
      }
    }

    const performTableEvaluation =
      items.some((item) => this.requiresTableEvaluationOnUpdate(item)) ||
      this.props!.getRoot()
        .noteParts.slice(index, index + deleteCount)
        .some((item: NotePart) => this.requiresTableEvaluationOnUpdate(item));

    this.props!.updateRoot?.(newRoot, {
      performTableEvaluation,
    });
    return true;
  },

  // If we started at the top of a day, and deleted the entire day, we want to
  // put the cursor in the newly created note part for that day.
  deleteRangeHandler({start, end}: {start: number; end: number}) {
    const root = this.props!.getRoot();
    // eslint-disable-next-line no-restricted-syntax
    const startDayIndex = _.findIndex(root.days!, {index: start});

    // Not the start of a day
    if (startDayIndex === -1) {
      this.deleteRangeHandlerDefault?.({start, end});
      return;
    }

    const nextDay = root.days![startDayIndex + 1];
    const nextDayNotePartIndex = (nextDay != null ? nextDay.index : undefined) || this.lastIndex!();

    // Doesn't delete an entire day
    if (end + 1 < nextDayNotePartIndex) {
      this.deleteRangeHandlerDefault?.({start, end});
      return;
    }

    const item = this.createDefaultableItem!(this.defaultInsertType);
    const selection = this.selectionInit!(item);
    if (!this.replaceItems(start, end - start + 1, item)) {
      return;
    }
    this.clearMultiSelect?.();
    this.props!.requestSelection!(selection);
  },

  finalizeItemWidth(index: number, itemWidth: number) {
    this.props!.storeState!();
    const content = this.props!.getContent(this.atIndex!(index));
    this.itemUpdateHandler!(index, {...content, itemWidth});
  },

  insertDay(notePartIndex: number, title: string) {
    this.props!.storeState!({selection: selutil.getSelectionIndices()});
    let newRoot: Note | null = null;
    context.using({warnOnSanitizeNote: true}, this, function () {
      newRoot = EntryDayOps.insertDay(
        // @ts-expect-error
        this.props.getRoot(),
        notePartIndex,
        // @ts-expect-error
        APIUtil.apiIdToType(this.props.fileId),
        // @ts-expect-error
        this.getTextForDate,
        title
      );
    });
    this.props!.updateRoot?.(newRoot!, {performTableEvaluation: false});
    const newDayIndex = _.sortedIndex(
      this.props!.note?.days ?? [],
      {index: notePartIndex} as NoteDay,
      (day) => day.index
    );
    const newDay = newRoot!.days![newDayIndex];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.props!.sectionConfiguration as any)?.allows?.collapse) {
      getEntryPersistentStorage().insertDay(this.props!.fileId!, newDay);

      const updatedFileSectionState = getEntryPersistentStorage().getFileSectionState(
        this.props!.fileId!,
        this.props!.note!.days!
      );

      this.setState?.({
        fileSectionState: updatedFileSectionState,
      });
    }

    const selection = this.selectionAtStart!(newRoot!.noteParts[notePartIndex]);
    OnboardingActions.completeOnboardingTask(
      OnboardingConstants.MODULES.ENTRY,
      OnboardingConstants.INSERT_DAY
    );
    const fileIdKey = getEntryOrFileIdKey(this.props?.fileId);
    analytics.track('lab_notebook', 'edited_entry', {
      [fileIdKey]: this.props!.fileId!,
      is_tutorial_entry: ONBOARDING_ENTRY_NAMES.indexOf(this.props!.title!) !== -1,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      is_entry_creator: (this.props!.note!.creator as any).handle === EntityStore.currentUser().handle,
      action: 'added_day',
    });
    this.props!.requestSelection?.(selection);
  },

  insertGivenDay(notePartIndex: number, date: string, title: string) {
    this.props!.storeState!({selection: selutil.getSelectionIndices()});
    let newRoot: Note | null = null;
    context.using({warnOnSanitizeNote: true}, this, function () {
      newRoot = EntryDayOps.insertGivenDay(
        // @ts-expect-error
        this.props.getRoot(),
        notePartIndex,
        // @ts-expect-error
        APIUtil.apiIdToType(this.props.fileId),
        // @ts-expect-error
        this.getTextForDate,
        date,
        title
      );
    });
    this.props!.updateRoot?.(newRoot!, {performTableEvaluation: false});
    const newDayIndex = _.sortedIndex(
      this.props!.note!.days!,
      {index: notePartIndex} as NoteDay,
      (day) => day.index
    );
    const newDay = newRoot!.days![newDayIndex];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.props!.sectionConfiguration as any)?.allows?.collapse) {
      getEntryPersistentStorage().insertDay(this.props!.fileId!, newDay);

      const updatedFileSectionState = getEntryPersistentStorage().getFileSectionState(
        this.props!.fileId!,
        this.props!.note!.days!
      );

      this.setState?.({
        fileSectionState: updatedFileSectionState,
      });
    }

    const selection = this.selectionAtStart!(newRoot!.noteParts[notePartIndex]);
    OnboardingActions.completeOnboardingTask(
      OnboardingConstants.MODULES.ENTRY,
      OnboardingConstants.INSERT_DAY
    );
    const fileIdKey = getEntryOrFileIdKey(this.props?.fileId);
    analytics.track('lab_notebook', 'edited_entry', {
      [fileIdKey]: this.props!.fileId!,
      is_tutorial_entry: ONBOARDING_ENTRY_NAMES.indexOf(this.props!.title!) !== -1,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      is_entry_creator: (this.props!.note!.creator as any).handle === EntityStore.currentUser().handle,
      action: 'added_day',
    });
    this.props!.requestSelection?.(selection);
  },

  deleteDay(cid: string, e?: {stopPropagation: () => void}) {
    // prevent the click from propagating to the section's expand/collapse toggle
    e?.stopPropagation();

    const day: NoteDay | undefined = _.findWhere(this.props!.getRoot().days!, {cid});
    const firstNotePart = this.atIndex!(day!.index);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.props!.sectionConfiguration as any)?.allows?.collapse) {
      getEntryPersistentStorage().deleteDay(this.props!.fileId!, day!);
      const updatedFileSectionState = getEntryPersistentStorage().getFileSectionState(
        this.props!.fileId!,
        this.props!.note!.days!
      );

      this.setState?.({
        fileSectionState: updatedFileSectionState,
      });
    }

    // There's currently a bug in SelectionStore which prevents us from doing both @props.storeState and
    // @props.reqeustSelection without creating two distinct selections. See T2358.
    let selection = this.selectionAtEnd!(firstNotePart);
    this.props!.requestSelection?.(selection);
    selection = _.clone(selection);
    this.props!.storeState!(selection);

    let newRoot: Note | null = null;
    context.using({warnOnSanitizeNote: true}, this, function () {
      // @ts-expect-error
      newRoot = EntryDayOps.deleteDay(this.props.getRoot(), cid);
    });
    this.props!.updateRoot?.(newRoot!, {performTableEvaluation: false});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateDay(cid: string, newTitle: any, newDate: any) {
    const day: NoteDay | undefined = _.findWhere(this.props!.getRoot().days!, {cid});
    const firstNotePart = this.atIndex!(day!.index);

    // As above, see T2358.
    let selection = this.selectionAtEnd!(firstNotePart);
    this.props!.requestSelection?.(selection);
    selection = _.clone(selection);
    this.props!.storeState!(selection);

    let newRoot: Note | null = null;
    context.using({warnOnSanitizeNote: true}, this, function () {
      newRoot = EntryDayOps.updateDay(
        // @ts-expect-error
        this.props.getRoot(),
        cid,
        newTitle,
        newDate,
        // @ts-expect-error
        this.getTextForDate,
        // @ts-expect-error
        APIUtil.apiIdToType(this.props.fileId),
        // @ts-expect-error
        this._isDayOnly()
      );
    });
    this.props!.updateRoot?.(newRoot!, {performTableEvaluation: false});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateTitle(cid: string, newTitle: any) {
    const day: NoteDay | undefined = _.findWhere(this.props!.getRoot().days!, {cid});
    const firstNotePart = this.atIndex!(day!.index);

    // As above, see T2358.
    let selection = this.selectionAtEnd!(firstNotePart);
    this.props!.requestSelection?.(selection);
    selection = _.clone(selection);
    this.props!.storeState!(selection);

    let newRoot: Note | null = null;
    context.using({warnOnSanitizeNote: true}, this, function () {
      newRoot = EntryDayOps.updateTitle(
        // @ts-expect-error
        this.props.getRoot(),
        cid,
        newTitle,
        // @ts-expect-error
        APIUtil.apiIdToType(this.props.fileId)
      );
    });
    this.props!.updateRoot?.(newRoot!, {performTableEvaluation: false});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateColor(cid: string, newColor: any) {
    const day: NoteDay | undefined = this.props!.getRoot().days!.find(
      (dayIter: {cid: string}) => dayIter.cid === cid
    );
    const firstNotePart = this.atIndex!(day!.index);

    // As above, see T2358.
    let selection = this.selectionAtEnd!(firstNotePart);
    this.props!.requestSelection?.(selection);
    selection = _.clone(selection);
    this.props!.storeState!(selection);

    let newRoot: Note | null = null;
    context.using({warnOnSanitizeNote: true}, this, function () {
      // @ts-expect-error
      newRoot = EntryDayOps.updateColor(this.props.getRoot(), cid, newColor);
    });
    this.props!.updateRoot?.(newRoot!, {performTableEvaluation: false});
  },

  createFilePlaceholderForTask(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {taskId, fileUploadDeferred}: {taskId: string; fileUploadDeferred: any},
    item: NotePart | null = null
  ) {
    if (item != null) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      item = {...omitKey(item, 'task'), taskId, item_id: null, item: null, placeholder: true} as any;
    } else {
      item = makeFilePlaceholderItem(taskId);
    }

    const updateNoteParts = (fn: (notePart: NotePart & {taskId?: string}) => NotePart): void => {
      // In the time it takes for the file to be uploaded, it is possible that the note is no longer
      // editable, e.g. if lockedFromExternalChange
      if (this.props!.locked) {
        return;
      }
      if (!this._isMounted) {
        notifications.error(
          'Your file was uploaded, but there was an error attaching the file to your document. Please make sure to keep the document tab open when uploading an attachment.'
        );
        return;
      }
      const root = reactUpdate(
        this.props!.getRoot(),
        this.props!.itemsAccessor({
          $apply(noteParts: Array<NotePart>) {
            return noteParts.map((notePart: NotePart & {taskId?: string}) => {
              if (notePart.taskId === taskId) {
                return fn(notePart);
              } else {
                return notePart;
              }
            });
          },
        })
      );
      this.props!.updateRoot?.(root);
    };

    // New note parts for the file upload may not have propagrated to root, so we _.defer the callbacks.
    _.defer(() => {
      fileUploadDeferred
        .done((res: LinkedItem) => {
          const cid = _.uniqueId('note-linked-object-');
          this.props!.registerObjects?.(_.object([cid], [res.id]));
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (res as any).cid = cid;

          // Replace the placeholder with the actual preview.
          updateNoteParts((notePart: NotePart) =>
            this.withAttachedItem(notePart, NOTE_LINKED_OBJECT, res.id!, res)
          );
        })
        .fail(() => {
          // Turn the component into a general placeholder.
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          updateNoteParts((notePart: any) => {
            notePart = _.clone(notePart);
            delete notePart.task;
            delete notePart.taskId;
            return notePart;
          });
        });
    });
    return item;
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parseItemsFromFile(file: any) {
    const [{taskId, fileUploadDeferred}] = ExternalFileUpload.createTaskAndUploadFiles(this.props!.fileId!, [
      file,
    ]);
    const item = this.createFilePlaceholderForTask({taskId, fileUploadDeferred});
    return Promise.resolve({items: [item]});
  },

  defaultItemType() {
    return TEXT;
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyDownHook(index: number, e: {which: number; target: any; preventDefault: () => void}) {
    if (
      (BenchlingConfig.ENABLE_SLASH_MACRO_FOR_NOTEBOOK &&
        this.refs?.attachSlashDropdown?.queryKeydownHandler?.(e)) ||
      this.refs?.attachDropdown?.queryKeydownHandler?.(e)
    ) {
      return true;
    }

    if (e.which === 32) {
      // space
      const notePart = this.atIndex!(index);
      const partition = selutil.partitionSelection({target: e.target});
      // Shortcuts for converting to a list
      if (
        partition != null &&
        notePart.listType == null &&
        !formatters.hasPointFormatting(partition.beforeFormats)
      ) {
        const {before: beforeText, after: afterText, selected: selectedText} = partition;
        const afterFormats =
          partition.afterFormats ??
          formatters.splitFormats(notePart.formats, beforeText.length + selectedText.length).after;

        // Line is whitespace followed by `1.` or `1)`
        if (beforeText.match(/^\s*1[.)]$/)) {
          e.preventDefault();
          this.props!.storeState!({selection: selutil.getSelectionIndices()});
          this._convertToList(index, afterText, afterFormats, NUMBER);
          return true;
          // Line is whitespace followed by `-` or `*`
        } else if (beforeText.match(/^\s*[-*]$/)) {
          e.preventDefault();
          this.props!.storeState!({selection: selutil.getSelectionIndices()});
          this._convertToList(index, afterText, afterFormats, BULLET);
          return true;
          // Line is whitespace followed by `[]`
        } else if (beforeText.match(/^\s*\[\]$/)) {
          e.preventDefault();
          this.props!.storeState!({selection: selutil.getSelectionIndices()});
          this._convertToList(index, afterText, afterFormats, CHECKBOX_UNCHECKED);
          return true;
        }
      }
    }
    return false;
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _convertToList(index: number, afterText: any, afterFormats: any, listType: any) {
    const item = this.atIndex!(index);
    const indentation = Math.min(MAX_INDENTATION, this.getIndentation(item) + 1);
    const newItem = {...item, listType, indentation, text: afterText, formats: afterFormats};
    this.replaceItems(index, 1, newItem);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  alignmentFormatHandler(index: number, alignment: any) {
    const item = this.atIndex!(index);
    const cid = this.props!.getCid(item);
    const content = {...this.props!.getContent(item)!, alignment};
    this.props!.storeState!(null);
    this.props!.requestSelection?.({
      selection: {
        cid: CaptionEditableClass.getAttachmentCid(cid),
        start: 0,
        end: 0,
      },
    });
    this.itemUpdateHandler!(index, content);
  },

  importantFormatRangeHandler(start: number, end: number) {
    assert(start <= end, 'Start must be less than or equal to end.');
    const items = this.subList!(start, end);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newImportant = items.some((item: {important: any}) => !item.important);
    const noteParts = items.map((item: NotePart) => ({
      ...item,
      important: newImportant,
    }));
    this.replaceItems(start, end - start + 1, ...noteParts);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headerFormatRangeHandler(start: number, end: number, headerType: any) {
    assert(start <= end, 'Start must be less than or equal to end.');
    let noteParts = this.subList!(start, end);
    noteParts = noteParts.map((item: NotePart) => {
      if (!this.canItemHaveHeader(item)) {
        return item;
      }
      return reactUpdate(item, {formats: {bold: {$set: []}}, ...this.headerTypeAccessor({$set: headerType})});
    });

    this.replaceItems(start, end - start + 1, ...noteParts);
  },

  cycleHeaderType(headerType: string) {
    if (headerType === PARAGRAPH) {
      return HEADER_1;
    } else if (headerType === HEADER_1) {
      return HEADER_2;
    } else if (headerType === HEADER_2) {
      return SUBHEADER_1;
    } else if (headerType === SUBHEADER_1) {
      return PARAGRAPH;
    } else {
      assertAndContinue(false, `Unrecognized header type: ${headerType}.`);
      return headerType;
    }
  },

  cycleHeaderFormatRangeHandler(start: number, end: number) {
    assert(start <= end, 'Start must be less than or equal to end.');
    let noteParts = this.subList!(start, end);
    noteParts = noteParts.map((item: NotePart) => {
      if (!this.canItemHaveHeader(item)) {
        return item;
      }

      const newHeaderType = this.cycleHeaderType(this.getHeaderType(item));

      return reactUpdate(item, {
        formats: {bold: {$set: []}},
        ...this.headerTypeAccessor({$set: newHeaderType}),
      });
    });

    this.replaceItems(start, end - start + 1, ...noteParts);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rangeHeaderTypes(noteParts: Array<any>) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const headerTypes = noteParts.map((part: any) => this.getHeaderType(part));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!headerTypes.every((headerType: any) => headerType === headerTypes[0])) {
      return null;
    }
    return headerTypes[0];
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  checkHandler(index: number, newCheckedValue: any) {
    this.props!.storeState!({selection: selutil.getSelectionIndices()});
    const item = this.atIndex!(index);
    const listType = newCheckedValue ? CHECKBOX_CHECKED : CHECKBOX_UNCHECKED;
    const newItem = {...item, listType};
    this.replaceItems(index, 1, newItem);
  },

  // Returns true if
  //   1) there is atleast one text element
  //   2) all text elements in the range have the given list type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isRangeListType(start: any, end: any, ...listTypes: Array<any>) {
    const textItems = this.subList!(start, end).filter(
      (item: NotePart) => this.props!.getType(item) === TEXT
    );
    if (textItems.length === 0) {
      return false;
    }
    return textItems.every((item: NotePart) => listTypes.includes(this.getListType(item)));
  },

  noteListRangeHandler(start: number, end: number, listTypeOriginal: ListType) {
    assert(start <= end, 'Start must be less than or equal to end.');
    const items = this.subList!(start, end);
    let indentShift = 1;
    let listTypes = [listTypeOriginal];
    let listType: ListType | null = listTypeOriginal;
    // We remove the checkboxes if they are present in any toggle state.
    if ([CHECKBOX_CHECKED, CHECKBOX_UNCHECKED].includes(listTypeOriginal)) {
      listTypes = [CHECKBOX_CHECKED, CHECKBOX_UNCHECKED];
    }

    if (this.isRangeListType(start, end, ...listTypes)) {
      listType = null;
      indentShift = -1;
    }
    const noteParts = items.map((item: NotePart) => {
      if (this.props!.getType(item) !== TEXT) {
        return item;
      }
      // If we're changing from one list type to another (number->bullet, number->number, etc.),
      // then we don't want to change the indentation
      const shift = listType != null && this.getListType(item) != null ? 0 : indentShift;
      const indentation = Math.min(MAX_INDENTATION, this.getIndentation(item) + shift);
      return this.withUpdatedListStyle(item, {listType, indentation});
    });

    this.replaceItems(start, end - start + 1, ...noteParts);
    if (listType === CHECKBOX_UNCHECKED) {
      const fileIdKey = getEntryOrFileIdKey(this.props?.fileId);
      analytics.track('lab_notebook', 'edited_entry', {
        [fileIdKey]: this.props!.fileId!,
        is_tutorial_entry: ONBOARDING_ENTRY_NAMES.indexOf(this.props!.title!) !== -1,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        is_entry_creator: (this.props!.note!.creator as any).handle === EntityStore.currentUser().handle,
        action: 'added_checkbox',
      });
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateFormattedText({formats, text, start, end}: any, index: number) {
    const item = this.atIndex!(index);
    ({start, end} = formatters.getSelectionIndicesFromFormatIndices(formats, start, end));
    this.props!.requestSelection?.({selection: {start, end, cid: item.cid}});
    this.updateItemText!(index, {text, formats});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  textItemFormatHandler(index: number, {format, data, partition}: any) {
    const item = this.atIndex!(index);
    this.props!.getCid(item);
    formatText(
      this.getText!(item).formats,
      {format, data, partition},
      index,
      this.openInsertLinkModal,
      this.updateFormattedText
    );
  },

  // For FormatToolbar

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _toolbarFormatHandler(format: string, data: any) {
    const partition = StaticFormatToolbarClass.getPartition(
      ReactDOM.findDOMNode(this.refs.editor),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.state!.selected as any
    );
    const e = {format, data, partition};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.formatHandler(this.state!.selected, e as any);
    this._toolbarMouseOutHandler();
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _toolbarInsertItemHandler(type: any) {
    const {index} = this.state!.selected;
    this.insertItemHandler(index!, type);
  },

  _toolbarMouseOverHandler(fmt: string) {
    const ATTACH_FMTS = [
      'table',
      'day',
      'attach',
      ModelTypeConstants.DATA_TABLE,
      ModelTypeConstants.DATA_TABLE_CONFIG,
      ModelTypeConstants.NOTE_LINKED_ASSAY_DATA,
      ModelTypeConstants.REGISTRATION_TABLE,
      ModelTypeConstants.TRANSFER_TABLE,
    ];
    const {index, subIndex} = this.state!.selected;
    if (['left', 'center', 'right', 'important'].includes(fmt)) {
      this.setState?.({highlightIndex: index});
    } else if (fmt === 'delete' && subIndex !== 'item') {
      this.setState?.({highlightIndex: index});
    } else if (ATTACH_FMTS.includes(fmt)) {
      this.setState?.({insertIndex: index});
    }
  },

  _toolbarMouseOutHandler() {
    this.setState?.({highlightIndex: null, insertIndex: null});
  },

  _openSavedSearchInsertModal(index: number, partition: SelectionPartition, formats?: Format) {
    this.setState?.({savedSearchInsertModalState: {index, partition, formats}});
  },

  _insertSavedSearch(savedSearch: SavedSearch) {
    const {formats, partition, index} = this.state!.savedSearchInsertModalState;
    const internalLink = {
      id: savedSearch.id,
      name: savedSearch.name,
      savedSearchData: {
        id: savedSearch.id,
        fileId: this.props!.fileId!,
        searchParams: savedSearch.searchParams,
        section: savedSearch.section,
        name: savedSearch.name,
        description: savedSearch.description,
        ownerName: savedSearch.ownerJson.name,
        modifiedAt: savedSearch.modifiedAt,
      },
    };
    const {
      formats: newFormats,
      text,
      end,
    } = formatters.replaceWithInternalLink(formats, partition, internalLink, index);
    // After insert, place cursor at end of range.
    this.updateFormattedText({text, start: end, end, formats: newFormats}, index);
  },

  _closeSavedSearchInsertModal() {
    this.setState?.({savedSearchInsertModalState: null});
  },

  renderSavedSearchInsertModal() {
    return (
      <ModalAnchor open={this.state!.savedSearchInsertModalState != null}>
        {this.state!.savedSearchInsertModalState != null ? (
          <InsertSearchModal
            searchSection={SearchSection.GLOBAL}
            closeModal={this._closeSavedSearchInsertModal}
            submitModal={this._insertSavedSearch}
            onSearch={() => {}}
            searchParams={null as unknown as SearchParams} // TODO: Allow null search params
            fileId={this.props!.fileId!}
          />
        ) : undefined}
      </ModalAnchor>
    );
  },

  _openSubtemplateInsertModal(index: number) {
    this.setState?.({subtemplateInsertModalState: {index}});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _submitSubtemplateInsertModal(subtemplateId: any) {
    const index = this.state!.subtemplateInsertModalState.index;
    this.insertSubtemplate(subtemplateId, index);
    this._closeSubtemplateInsertModal();
  },

  _closeSubtemplateInsertModal() {
    this.setState?.({subtemplateInsertModalState: null});
  },

  renderSubtemplateInsertModal() {
    return (
      <ModalAnchor open={this.state!.subtemplateInsertModalState != null}>
        {this.state!.subtemplateInsertModalState != null ? (
          <InsertSubtemplateModal
            onRequestClose={this._closeSubtemplateInsertModal}
            onRequestSubmit={this._submitSubtemplateInsertModal}
          />
        ) : undefined}
      </ModalAnchor>
    );
  },

  // TODO(BNCH-92968) Refactor names here as well
  _openEntryDayInsertModal(index: number) {
    this.setState?.({entryDayInsertModalState: {index, title: 'Untitled'}});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _submitEntryDayInsertModal(title: any, date: any) {
    if (!this.state!.entryDayInsertModalState.isUpdate) {
      const index = this.state!.entryDayInsertModalState.index;
      this.insertGivenDay(index, date, title);
    } else {
      this.updateDay(this.state!.entryDayInsertModalState.cid, title, date);
    }
    this._closeEntryDayInsertModal();
  },

  _closeEntryDayInsertModal() {
    this.setState?.({entryDayInsertModalState: null});
  },

  renderEntryDayInsertModal() {
    return (
      <ModalAnchor open={this.state!.entryDayInsertModalState != null}>
        {this.state!.entryDayInsertModalState != null ? (
          <InsertEntryDayModal
            isUpdate={this.state!.entryDayInsertModalState.isUpdate}
            onRequestClose={this._closeEntryDayInsertModal}
            onRequestSubmit={this._submitEntryDayInsertModal}
            title={this.state!.entryDayInsertModalState.title}
            date={this.state!.entryDayInsertModalState.date}
            forTemplate={APIUtil.isEntryOrSubOrWorkflowTemplate(this.props!.fileId!)}
            getDateBoundaries={this._getDatesBetweenIndex}
            sectionConfiguration={this.props!.sectionConfiguration!}
            index={this.state!.entryDayInsertModalState.index}
          />
        ) : undefined}
      </ModalAnchor>
    );
  },

  _getDatesBetweenIndex(index: number) {
    let previousDate;
    let nextDate;
    if (index == null) {
      ({previousDate, nextDate} = this.state!.entryDayInsertModalState);
    } else {
      const note = this.getRoot!();
      ({previousDate, nextDate} = EntryDayOps.getPreviousAndNextDateFromIndex({
        // @ts-expect-error(2322): Days only exist on EntryNote but this is generic to all notes
        note,
        notePartIndex: index,
      }));
    }
    return {
      previousDate: previousDate ? moment(previousDate).format('YYYY-MM-DD') : '',
      nextDate: nextDate ? moment(nextDate).format('YYYY-MM-DD') : '',
    };
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openResultsTableInsertModal(index: number, type: any) {
    this.setState?.({resultsTableInsertModalState: {index, type}});
  },

  _closeResultsTableInsertModal() {
    this.setState?.({resultsTableInsertModalState: null});
  },

  _openRunInsertModal(index: number) {
    this.setState?.({runInsertModalState: {index}});
  },

  _closeRunInsertModal() {
    this.setState?.({runInsertModalState: null});
  },

  openInsertLinkModal(
    formats: Format,
    partition: {before: string; selected: string; after: string},
    editingFormatIndex: number
  ) {
    this.setState?.({
      showInsertLinkModal: true,
      // Everything we need once the user clicks save on the edit link modal.
      editingLinkState: getEditingLinkState(formats, partition, editingFormatIndex),
    });
  },

  closeInsertLinkModal() {
    this.setState?.({editingLinkState: null, showInsertLinkModal: false});
  },

  _insertEmptyNoteLinkedAssayData(assayRunSchema: AssayRunSchema) {
    const item = NoteLinkedAssayDataUtil.createEmptyNoteLinkedAssayData(assayRunSchema);
    const newItem = reactUpdate(
      makeDefaultItem(NOTE_LINKED_OBJECT),
      this.props!.setContent!(ModelTypeConstants.NOTE_LINKED_ASSAY_DATA, {item})
    );

    this.itemInsertHandler?.(this.state!.runInsertModalState.index, newItem);
    analytics.trackEvent(
      RESULTS_ANALYTICS_ACTIONS.ATTACHED_ASSAY_DATA_IN_ENTRY,
      this._getLegacyStructuredTableAnalyticsParams()
    );

    this._closeRunInsertModal();
  },

  _getStructuredTableAnalyticsParams(
    structuredTable: AnyStructuredTable | null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extraAnalyticsParams: any = {}
  ) {
    assertAndContinue(
      structuredTable != null,
      'Expected structuredTable to be defined for analytics payload'
    );
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tableSchemasApiIds = structuredTable?.schemas?.map((schema: {id: any}) => schema.id);
    const numRows = structuredTable?.rows.length;
    const numCols = structuredTable?.columns.length;
    const fileIdKey = getEntryOrFileIdKey(this.props?.fileId);
    return {
      [fileIdKey]: this.props!.fileId!,
      is_config: this.props!.isConfig || APIUtil.isConfigurationDocument(this.props!.fileId!),
      action_origin: ActionOrigin.NOTEBOOK,
      structured_table_kind: structuredTable?.kind,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      structured_table_mode: (structuredTable?.metadata as any)?.mode,
      structured_table_metadata: JSON.stringify(structuredTable?.metadata ?? null),
      structured_table_provenance_uuid: structuredTable?.provenanceUuid,
      structured_table_schema_ids: tableSchemasApiIds,
      structured_table_num_rows: numRows,
      structured_table_num_columns: numCols,
      ...extraAnalyticsParams,
    };
  },

  _getLegacyStructuredTableAnalyticsParams(
    // This is the old pre-StructuredTable structured tables, e.g. Legacy RegistrationTable, etc.
    structuredTable?: {provenanceUuid: string},
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extraAnalyticsParams: any = {}
  ) {
    const isWorkflow =
      APIUtil.isStageEntry(this.props!.fileId!) ||
      ModelTypeConstants.WORKFLOW_TEMPLATE === this.props!.fileType;
    return {
      entry_id: [ModelTypeConstants.ENTRY, ModelTypeConstants.STAGE_ENTRY].includes(this.props!.fileType!)
        ? this.props!.fileId
        : null,
      template_id: APIUtil.isEntryOrSubOrWorkflowTemplateFileType(this.props!.fileType!)
        ? this.props!.fileId
        : null,
      action_origin: !isWorkflow ? 'notebook' : undefined,
      ...(structuredTable != null ? {structured_table_provenance_uuid: structuredTable.provenanceUuid} : {}),
      ...extraAnalyticsParams,
      // TODO(BNCH-53366): Include template_collection_id.
    };
  },

  _fireStructuredTableInsertionAnalyticsEvent(
    structuredTable: Omit<StructuredTable<unknown, unknown>, 'cid'>,
    structuredTableKindOrNoteLinkedGroupKind: StructuredTableKind | NoteLinkedGroupKind,
    isLegacyStructuredTable: boolean,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extraAnalyticsParams: any = {}
  ) {
    if (isLegacyStructuredTable) {
      const event = (
        APIUtil.isEntryOrSubOrWorkflowTemplate(this.props!.fileId!)
          ? LEGACY_STRUCTURED_TABLE_CONFIG_TO_TEMPLATE_CREATION_EVENTS
          : LEGACY_STRUCTURED_TABLE_TO_ENTRY_CREATION_EVENTS
      )[
        structuredTableKindOrNoteLinkedGroupKind as keyof typeof LEGACY_STRUCTURED_TABLE_TO_ENTRY_CREATION_EVENTS
      ];

      if (
        assertAndContinue(
          event != null,
          `No analytics event for legacy structured table kind ${structuredTableKindOrNoteLinkedGroupKind}`
        )
      ) {
        analytics.trackEvent(
          event,
          this._getLegacyStructuredTableAnalyticsParams(structuredTable, extraAnalyticsParams)
        );
      }
      return;
    }

    assert(structuredTable != null, 'structuredTable must be defined');

    analytics.trackEvent(
      ELN_ANALYTICS_ACTIONS.CREATED_STRUCTURED_TABLE,
      this._getStructuredTableAnalyticsParams(structuredTable, extraAnalyticsParams)
    );
  },

  _inStageEntryOrTemplate() {
    const inStageEntryOrTemplate =
      APIUtil.isStageEntry(this.props!.fileId!) || APIUtil.isStageEntryTemplate(this.props!.fileId!);
    return inStageEntryOrTemplate;
  },

  _insertStructuredTable(
    index: number,
    kind: StructuredTableKind | NoteLinkedGroupKind,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tableNameBase: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schemasAndColumnGroups: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    metadata: any,
    selectorsById: {[selectorId: string]: SchemaFieldSelector},
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extraAnalyticsParams: any = {}
  ) {
    const name = excess.util.uniqueTableName(this.props!.usedTableNames!(), `${tableNameBase} `);
    const structuredTable = STRUCTURED_TABLE_PLUGIN.get(kind).createTable({
      name,
      schemas: schemasAndColumnGroups,
      entryId: this.props!.fileId!,
      metadata,
      selectorsById,
      isConfig: this.props!.isConfig,
      structuredTableInsertionContext: this.props!.structuredTableInsertionContext,
    });
    const cidIdMap: CidIdMap = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    StructuredTableStoreTransforms.prepareForStore(structuredTable as any, cidIdMap);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.props!.registerObjects?.(cidIdMap as any);
    const newItem = reactUpdate(
      makeDefaultItem(NOTE_LINKED_OBJECT),
      this.props!.setContent!(ModelTypeConstants.STRUCTURED_TABLE, {item: structuredTable})
    );
    this.itemInsertHandler?.(index, newItem);
    this._fireStructuredTableInsertionAnalyticsEvent(structuredTable, kind, false, extraAnalyticsParams);
    return structuredTable;
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _insertLegacyDataTableConfig({dataTableConfig, cidIdMap}: {dataTableConfig: any; cidIdMap: any}) {
    this.props!.registerObjects?.(cidIdMap);

    // Ensure the config has a unique name across all tables.
    dataTableConfig = DataTableUtil.updateDataTableConfigName(dataTableConfig, (name) =>
      excess.util.uniqueTableName(this.props!.usedTableNames!(), `${dataTableConfig.name} `)
    );

    let newItem = makeDefaultItem(NOTE_LINKED_OBJECT);
    if (this.state!.resultsTableInsertModalState.type === ModelTypeConstants.DATA_TABLE) {
      newItem = reactUpdate(
        newItem,
        this.props!.setContent!(ModelTypeConstants.DATA_TABLE, {
          item: DataTableUtil.createDataTable(dataTableConfig),
        })
      );
    } else {
      // DATA_TABLE_CONFIG
      assert(
        this.state!.resultsTableInsertModalState.type === ModelTypeConstants.DATA_TABLE_CONFIG,
        'Invalid type'
      );

      newItem = reactUpdate(
        newItem,
        this.props!.setContent!(ModelTypeConstants.DATA_TABLE, {
          item: {
            ...dataTableConfig,
            // The published dataTableConfig already has a provenanceUuid, but in the template we're inserting into,
            // we need each table to have a unique provenanceUuid. So we need to regenerate it.
            provenanceUuid: uuidv4(),
            // Create a new DTC rather than patching the published DTC.
            // Otherwise there will be a warning about provenanceUuid being immutable
            cid: _.uniqueId('dtc'),
          },
        })
      );
    }

    this.itemInsertHandler?.(this.state!.resultsTableInsertModalState.index, newItem);
    analytics.deprecatedTrackEvent(RESULTS_ANALYTICS_ACTIONS.INSERTED_DATA_TABLE, {
      entry_id: this.props!.fileId!,
    });
    const entryType = APIUtil.apiIdToType(this.props!.fileId!);
    // @ts-expect-error(2322): `newItem.item` should be ServerNotePartItem
    this._fireStructuredTableInsertionAnalyticsEvent(newItem.item, StructuredTableKind.RESULTS, true);
    if (entryType === ModelTypeConstants.STAGE_ENTRY) {
      analytics.deprecatedTrackEvent(LEGACY_WORKFLOWS_ANALYTICS_ACTIONS.CREATED_DATA_TABLE_IN_ENTRY);
    } else if (entryType === ModelTypeConstants.STAGE_CONFIGURATION) {
      analytics.deprecatedTrackEvent(LEGACY_WORKFLOWS_ANALYTICS_ACTIONS.CREATED_DATA_TABLE_CONFIG);
    }
    this._closeResultsTableInsertModal();
  },

  renderResultsTableInsertModal() {
    if (!this.state!.resultsTableInsertModalState) {
      return null;
    }

    const shouldUseStructuredTable =
      BenchlingConfig.ELN_ENABLE_INSERT_NEW_RESULTS_TABLE && !this._inStageEntryOrTemplate();

    return (
      <ModalAnchor open={true}>
        {shouldUseStructuredTable ? (
          <ResultsTableInsertModal
            onRequestSubmit={this._insertFromResultsStructuredTableInsertModal}
            onRequestClose={this._closeResultsTableInsertModal}
          />
        ) : (
          <LegacyDataTableInsertModal
            fileId={this.props!.fileId!}
            type={this.state!.resultsTableInsertModalState.type}
            onInsertDataTableConfig={this._insertLegacyDataTableConfig}
            onRequestClose={this._closeResultsTableInsertModal}
          />
        )}
      </ModalAnchor>
    );
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _insertFromResultsStructuredTableInsertModal({schema, metadata, selectorsById}: any) {
    const {index} = this.state!.resultsTableInsertModalState;
    this._insertStructuredTable(
      index,
      StructuredTableKind.RESULTS,
      schema.name,
      [{...schema, columnGroup: null}],
      metadata,
      selectorsById,
      {
        action_method: ActionMethod.NOTEBOOK_INSERT_MENU,
      }
    );

    this._closeResultsTableInsertModal();
  },

  renderRunInsertModal() {
    return (
      <ModalAnchor open={this.state!.runInsertModalState != null}>
        {this.state!.runInsertModalState != null ? (
          <RunInsertModal
            onInsertAssayRunSchema={this._insertEmptyNoteLinkedAssayData}
            onRequestClose={this._closeRunInsertModal}
          />
        ) : undefined}
      </ModalAnchor>
    );
  },

  _openChemicalStructureInsertModal(index: number) {
    this.setState?.({chemicalStructureModalState: {index, isChemicalStructureModalOpen: true}});
  },

  _closeChemicalStructureInsertModal() {
    this.setState?.({
      chemicalStructureModalState: null,
    });
  },

  async _insertFromChemicalStructureModal(sketcherModalOutput: {
    sketcherValue: string;
    filename: string;
    saveFormat: MarvinChemicalFormat;
  }) {
    if (sketcherModalOutput) {
      const index = this.state!.chemicalStructureModalState.index;
      const chemicalBlob = createChemicalStructureBlob(
        sketcherModalOutput.sketcherValue,
        sketcherModalOutput.filename,
        sketcherModalOutput.saveFormat
      );
      const file = new File([chemicalBlob], chemicalBlob.name!, {
        type: chemicalBlob.type,
      });
      await ImportUtil.upload(file).then((s3location) =>
        this.insertNoteLinkedFileFromS3Location(index, s3location!)
      );
    }
    this._closeChemicalStructureInsertModal();
  },

  renderChemicalStructureInsertModal() {
    if (!this.state!.chemicalStructureModalState?.isChemicalStructureModalOpen) {
      return null;
    }
    return (
      <ModalAnchor open={true}>
        <ChemicalSketcherModal
          onRequestSubmit={this._insertFromChemicalStructureModal}
          onRequestClose={this._closeChemicalStructureInsertModal}
          showAttachmentPointBanner={false}
        />
      </ModalAnchor>
    );
  },

  isDocument() {
    return APIUtil.isDocument(this.props!.fileId!);
  },

  openFixedPlateEditorModal(
    index: number,
    initiatingPlateDesignState?: InitiatingPlateDesignStateWithNotePart
  ) {
    const eventGroupId = analytics.makeAnalyticsEventId();
    analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.OPENED_MODAL, ANALYTICS_MODULE.SAMPLES, {
      actionOrigin: this.isDocument() ? ActionOrigin.WORKSHEET : ActionOrigin.NOTEBOOK,
      modalType: FixedPlateModalType.FIXED_PLATE_EDITOR,
      eventGroupId,
    });
    this.setState?.({
      fixedPlateEditorModalState: {
        index,
        initiatingPlateDesignState,
        isFixedPlateEditorModalOpen: true,
        eventGroupId,
      },
    });
  },

  _closeFixedPlateEditorModal() {
    analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.CLOSED_MODAL, ANALYTICS_MODULE.SAMPLES, {
      actionOrigin: this.isDocument() ? ActionOrigin.WORKSHEET : ActionOrigin.NOTEBOOK,
      modalType: FixedPlateModalType.FIXED_PLATE_EDITOR,
      eventGroupId: this.state!.fixedPlateEditorModalState?.eventGroupId,
    });
    this.setState?.({fixedPlateEditorModalState: null});
  },

  _insertFromFixedPlateEditorModal() {
    this._closeFixedPlateEditorModal();
  },

  renderFixedPlateEditorModal() {
    if (!this.state!.fixedPlateEditorModalState?.isFixedPlateEditorModalOpen) {
      return null;
    }

    let notePartIndex: NotePartIndex | null = null;
    // Subtemplates lack entry days, causing getNotePartIndexFromEntryIndex to throw an error.
    // As creation of plate records is not supported within subtemplates, notePartIndex can be null for
    // subtemplates since it only determines the insertion point for the newly created plate records.
    if (!APIUtil.isSubtemplate(this.props!.fileId!)) {
      const {entryDayIndex, notePartLocation} = getNotePartIndexFromEntryIndex(
        Math.min(this.state!.fixedPlateEditorModalState.index, this.props!.note!.noteParts.length - 1),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.props!.note as any
      );
      // Insert the plate map _after_ the current index, but within the same entry day.
      notePartIndex = {
        entryDayIndex,
        notePartLocation: notePartLocation + 1,
      };
    }

    const eventGroupId = this.state!.fixedPlateEditorModalState?.eventGroupId;

    return (
      <NotebookAnnotateFillPlateModal
        onRequestSubmit={this._insertFromFixedPlateEditorModal}
        onRequestClose={this._closeFixedPlateEditorModal}
        fileId={this.props!.fileId!}
        plateRecordNames={getAllPlateRecordNames(this.props!.note!)}
        plateDesignNames={getAllPlateDesignNames(this.props!.note!)}
        note={this.props!.note!}
        notePartIndex={notePartIndex}
        eventGroupId={eventGroupId}
        upsertNotePart={(notePart) => {
          const existingIndex = this.getIndex!(notePart.cid);
          if (existingIndex !== -1) {
            this.replaceItems(existingIndex, 1, notePart);
          } else {
            this.itemInsertHandler?.(this.state!.fixedPlateEditorModalState!.index, notePart);
          }
        }}
        initiatingPlateDesignState={this.state!.fixedPlateEditorModalState?.initiatingPlateDesignState}
        locked={this.props!.locked!}
      />
    );
  },

  _openCreatePlateTemplateModal(index: number) {
    this.setState?.({createPlateTemplateModalState: {index, isCreatePlateTemplateModalOpen: true}});
  },

  _closeCreatePlateTemplateModal() {
    this.setState?.({createPlateTemplateModalState: null});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _insertFromCreatePlateTemplateModal(createPlateTemplateModalOutput: any) {
    // eslint-disable-next-line no-console
    console.log('TODO: Use modal output to insert a plate template note part.');
    this._closeCreatePlateTemplateModal();
  },

  renderCreatePlateTemplateModal() {
    if (!this.state!.createPlateTemplateModalState?.isCreatePlateTemplateModalOpen) {
      return null;
    }
    return (
      <ModalAnchor open={true}>
        <CreatePlateTemplateModal
          onRequestSubmit={this._insertFromCreatePlateTemplateModal}
          onRequestClose={this._closeCreatePlateTemplateModal}
        />
      </ModalAnchor>
    );
  },

  _openAIContentInsertModal(index: number) {
    this.setState?.({aiContentModalState: {index}});
  },

  _closeAIContentInsertModal() {
    this.setState?.({aiContentModalState: null});
  },

  _insertFromAIContentInsertModal({message}: {message: GenerateDocumentContentMessage}) {
    const {index} = this.state!.aiContentModalState;
    this.itemInsertHandler?.(index, ...getNotePartsFromNotebookContentMessage(message));
    this._closeAIContentInsertModal();
  },

  _openAICheckerPanel() {
    openAICheckerPanel(this.props!.fileId!, 'note-editor');
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openRegistrationTableInsertModal(index: number, type: any) {
    this.setState?.({registrationTableModalState: {index, type}});
  },

  _closeRegistrationTableInsertModal() {
    this.setState?.({registrationTableModalState: null});
  },

  _insertFromRegistrationTableInsertModal({
    schema,
    insertType,
    labelingStrategy,
    selectorsById,
    implementedSchemaInterfaces,
    tagSchemaItemType,
    notation,
    customSyntaxName,
    folderOption,
    folderId,
  }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schema: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    insertType: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    labelingStrategy: any;
    selectorsById: {[selectorId: string]: SchemaFieldSelector};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    implementedSchemaInterfaces: any;
    tagSchemaItemType: TagSchemaItemType;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    notation: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    customSyntaxName: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    folderOption: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    folderId: any;
  }) {
    const {index} = this.state!.registrationTableModalState!;
    const metadata = {
      insertType,
      labelingStrategy,
      notation,
      customSyntaxName,
      folderOption,
      folderId,
      implementedSchemaInterfaces,
      tagSchemaItemType,
    };
    this._insertStructuredTable(
      index,
      StructuredTableKind.REGISTRATION,
      schema.name,
      [{...schema, columnGroup: null}],
      metadata,
      selectorsById,
      {
        action_method: ActionMethod.NOTEBOOK_INSERT_MENU,
      }
    );
    this._closeRegistrationTableInsertModal();
  },

  _insertFromLegacyRegistrationTableInsertModal({
    tagSchema,
    tableType,
    labelingStrategy,
    selectorsById,
  }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tagSchema: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tableType: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    labelingStrategy: any;
    selectorsById: {[selectorId: string]: SchemaFieldSelector};
  }) {
    const {index, type} = this.state!.registrationTableModalState!;
    const name = excess.util.uniqueTableName(
      this.props!.usedTableNames!(),
      `${getRegistrationTableName({tableType, tagSchema})} `
    );
    if (type === ModelTypeConstants.REGISTRATION_TABLE) {
      this._closeRegistrationTableInsertModal();
      EntryActions.createRegistrationTable(name, tagSchema.id, tableType, labelingStrategy, {
        success: (registrationTable) => {
          const cidIdMap: CidIdMap = {};
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          RegistrationTableUtil.prepareForStore(registrationTable as any, cidIdMap);
          let newItem = makeDefaultItem(NOTE_LINKED_OBJECT);
          newItem = reactUpdate(
            newItem,
            this.props!.setContent!(ModelTypeConstants.REGISTRATION_TABLE, {item: registrationTable})
          );
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.props!.registerObjects?.(cidIdMap as any);
          this.itemInsertHandler?.(index, newItem);
        },
        fileId: this.props!.fileId!,
      });
    } else {
      assert(type === ModelTypeConstants.REGISTRATION_TABLE_CONFIG, 'Unexpected registration table type');
      const registrationTableConfig = RegistrationTableUtil.createLegacyRegistrationTableConfig(
        name,
        tagSchema,
        tableType,
        labelingStrategy,
        this.props!.fileId!,
        selectorsById
      );
      let newItem = makeDefaultItem(NOTE_LINKED_OBJECT);
      newItem = reactUpdate(
        newItem,
        this.props!.setContent!(ModelTypeConstants.REGISTRATION_TABLE_CONFIG, {item: registrationTableConfig})
      );

      this.itemInsertHandler?.(index, newItem);
      this._closeRegistrationTableInsertModal();
    }
  },

  renderAIContentInsertModal() {
    return (
      <ModalAnchor open={this.state!.aiContentModalState != null}>
        {this.state!.aiContentModalState ? (
          <AIContentInsertModal
            entryId={this.props!.fileId!}
            notePartIndex={this.state!.aiContentModalState.index}
            onRequestSubmit={this._insertFromAIContentInsertModal}
            onRequestClose={this._closeAIContentInsertModal}
          />
        ) : null}
      </ModalAnchor>
    );
  },

  renderRegistrationTableInsertModal() {
    // We don't support the new Registration table in Workflows yet
    const registrationTableInsertModal =
      BenchlingConfig.ELN_ENABLE_INSERT_NEW_REG_TABLE && !this._inStageEntryOrTemplate() ? (
        <RegistrationTableInsertModal
          onRequestSubmit={this._insertFromRegistrationTableInsertModal}
          onLegacyRequestSubmit={this._insertFromLegacyRegistrationTableInsertModal}
          onRequestClose={this._closeRegistrationTableInsertModal}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          adapter={STRUCTURED_TABLE_PLUGIN.get(StructuredTableKind.REGISTRATION) as any}
          structuredTableInsertionContext={this.props!.structuredTableInsertionContext}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          {...({} as any)} // Done to make TypeScript happy. Remaining props are injected by QueryingRegistrationTableInsertModal
        />
      ) : (
        <LegacyRegistrationTableInsertModal
          onRequestSubmit={this._insertFromLegacyRegistrationTableInsertModal}
          onRequestClose={this._closeRegistrationTableInsertModal}
        />
      );
    return (
      <ModalAnchor open={this.state!.registrationTableModalState != null}>
        {this.state!.registrationTableModalState != null && registrationTableInsertModal}
      </ModalAnchor>
    );
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openInventoryTableInsertModal(index: number, type: any) {
    this.setState?.({inventoryTableModalState: {index, type}});
  },

  _closeInventoryTableInsertModal() {
    this.setState?.({inventoryTableModalState: null});
  },

  async _insertFromLegacyTransferTableInsertModal(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {containerSchema, parentStorableIsGrid}: any,
    selectorsById: {[selectorId: string]: SchemaFieldSelector}
  ) {
    const {index, type} = this.state!.inventoryTableModalState!;
    const name = excess.util.uniqueTableName(this.props!.usedTableNames!(), `${containerSchema.name} `);
    let newItem = makeDefaultItem(NOTE_LINKED_OBJECT);
    if (type === ModelTypeConstants.TRANSFER_TABLE) {
      this._closeInventoryTableInsertModal();

      const transferTable = await TransferTableActions.createTransferTable({
        name,
        containerSchemaId: containerSchema.id,
        parentStorableIsGrid,
        entryId: this.props!.fileId!,
      });
      const cidIdMap: CidIdMap = {};
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      TransferTableUtil.prepareForStore(transferTable as any, cidIdMap);

      newItem = reactUpdate(
        newItem,
        this.props!.setContent!(ModelTypeConstants.TRANSFER_TABLE, {item: transferTable})
      );
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.props!.registerObjects?.(cidIdMap as any);
      this.itemInsertHandler?.(index, newItem);
    } else {
      assert(type === ModelTypeConstants.TRANSFER_TABLE_CONFIG, 'Unexpected transfer table type');
      const transferTableConfig = TransferTableUtil.createTransferTableConfig({
        name,
        containerSchema,
        parentStorableIsGrid,
        selectorsById,
        fileId: this.props!.fileId!,
      });

      newItem = reactUpdate(
        newItem,
        this.props!.setContent!(ModelTypeConstants.TRANSFER_TABLE_CONFIG, {item: transferTableConfig})
      );
      this.itemInsertHandler?.(index, newItem);
      this._closeInventoryTableInsertModal();
    }
  },

  _insertFromTransferTableInsertModal(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {metadata, destinationContainerSchema, destinationPlateSchema}: any,
    selectorsById: {[selectorId: string]: SchemaFieldSelector}
  ) {
    const {index} = this.state!.inventoryTableModalState!;
    // If destination is a plate, render plate name, or else render container name
    const tableNameBase = destinationPlateSchema
      ? destinationPlateSchema.name
      : destinationContainerSchema.name;
    // If destination is a plate, include both container and plate schemas
    const schemaAndColumnGroups = [
      {...destinationContainerSchema, columnGroup: TransferTableColumnGroup.TARGET},
    ];
    if (destinationPlateSchema) {
      schemaAndColumnGroups.push({...destinationPlateSchema, columnGroup: TransferTableColumnGroup.TARGET});
    }

    this._insertStructuredTable(
      index,
      StructuredTableKind.TRANSFER,
      tableNameBase,
      schemaAndColumnGroups,
      metadata,
      selectorsById,
      {
        action_method: ActionMethod.NOTEBOOK_INSERT_MENU,
      }
    );
    this._closeInventoryTableInsertModal();
  },

  _insertUpdateContainersTableFromInventoryTableInsertModal(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {metadata, storableSchema, plateWellSchema}: any,
    selectorsById: {[selectorId: string]: SchemaFieldSelector}
  ) {
    const {index} = this.state!.inventoryTableModalState!;
    const tableNameBase = storableSchema
      ? storableSchema.name
      : metadata.storableSchemaType === ModelTypeConstants.PLATE_SCHEMA
        ? 'Any plate'
        : 'Any container';
    const schemaAndColumnGroups = [];
    if (storableSchema) {
      schemaAndColumnGroups.push({...storableSchema, columnGroup: TransferTableColumnGroup.SOURCE});
    }
    if (plateWellSchema) {
      schemaAndColumnGroups.push({...plateWellSchema, columnGroup: TransferTableColumnGroup.SOURCE});
    }

    this._insertStructuredTable(
      index,
      StructuredTableKind.INVENTORY,
      tableNameBase,
      schemaAndColumnGroups,
      metadata,
      selectorsById,
      {
        action_method: ActionMethod.NOTEBOOK_INSERT_MENU,
      }
    );

    this._closeInventoryTableInsertModal();
  },

  _insertFromInventoryTableInsertModal(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    insertionConfiguration: {[x: string]: any; tableType: any},
    selectorsById: {[selectorId: string]: SchemaFieldSelector}
  ) {
    const {tableType, ...configuration} = insertionConfiguration;
    if (tableType === InventoryTableInsertionTableType.TRANSFER) {
      const {metadata, destinationContainerSchema, destinationPlateSchema} = configuration;
      this._insertFromTransferTableInsertModal(
        {metadata, destinationContainerSchema, destinationPlateSchema},
        selectorsById
      );
    } else if (tableType === InventoryTableInsertionTableType.LEGACY_TRANSFER) {
      const {containerSchema, parentStorableIsGrid} = configuration;
      this._insertFromLegacyTransferTableInsertModal({containerSchema, parentStorableIsGrid}, selectorsById);
    } else if (tableType === InventoryTableInsertionTableType.UPDATE_CONTAINERS) {
      const {metadata, storableSchema, plateWellSchema} = configuration;
      this._insertUpdateContainersTableFromInventoryTableInsertModal(
        {metadata, storableSchema, plateWellSchema},
        selectorsById
      );
    }

    this._closeInventoryTableInsertModal();
  },

  renderInventoryTableInsertModal() {
    // We don't support the new transfer or inventory tables in Legacy Workflows
    const inventoryTableInsertModal =
      BenchlingConfig.ELN_ENABLE_INSERT_INVENTORY_TABLE && !this._inStageEntryOrTemplate() ? (
        <InventoryTableInsertModal
          onRequestSubmit={this._insertFromInventoryTableInsertModal}
          onRequestClose={this._closeInventoryTableInsertModal}
          trackingParams={{module: 'ELN', actionOrigin: ActionOrigin.NOTEBOOK, entryId: this.props!.fileId!}}
          structuredTableInsertionContext={this.props!.structuredTableInsertionContext}
        />
      ) : BenchlingConfig.ELN_ENABLE_INSERT_NEW_TRANSFER_TABLE && !this._inStageEntryOrTemplate() ? (
        <TransferTableInsertModal
          onRequestSubmit={this._insertFromTransferTableInsertModal}
          onRequestClose={this._closeInventoryTableInsertModal}
        />
      ) : (
        <LegacyTransferTableInsertModal
          onRequestSubmit={this._insertFromLegacyTransferTableInsertModal}
          onRequestClose={this._closeInventoryTableInsertModal}
        />
      );
    return (
      <ModalAnchor open={this.state!.inventoryTableModalState != null}>
        {this.state!.inventoryTableModalState != null && inventoryTableInsertModal}
      </ModalAnchor>
    );
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openGridCreationTableInsertModal(index: number, gridType: any) {
    this.setState?.({gridCreationModalState: {index, gridType}});
  },

  _closeGridCreationTableInsertModal(index: number) {
    this.setState?.({gridCreationModalState: null});
  },

  _insertFromGridCreationTableInsertModal({
    schema,
    shouldAutogenerateBarcode,
    requireCustomName,
    selectorsById,
  }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schema: any;
    shouldAutogenerateBarcode: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    requireCustomName: any;
    selectorsById: {[selectorId: string]: SchemaFieldSelector};
  }) {
    const {index, gridType} = this.state!.gridCreationModalState!;
    const metadata = {
      shouldAutogenerateBarcode,
      requireCustomName,
      parentStorableIsGrid: false,
    };
    const kind =
      gridType === GridType.PLATE ? StructuredTableKind.PLATE_CREATION : StructuredTableKind.BOX_CREATION;

    if (gridType === GridType.PLATE || gridType === GridType.BOX) {
      this._insertStructuredTable(
        index,
        kind,
        schema.name,
        [{...schema, columnGroup: null}],
        metadata,
        selectorsById,
        {
          action_method: ActionMethod.NOTEBOOK_INSERT_MENU,
        }
      );
    } else {
      throw new Error(`Unknown grid creation type: ${gridType}`);
    }
    this._closeGridCreationTableInsertModal();
  },

  renderGridCreationTableInsertModal() {
    if (!this.state!.gridCreationModalState) {
      return null;
    }

    return (
      <ModalAnchor open={true}>
        <GridCreationTableInsertModal
          gridType={this.state!.gridCreationModalState.gridType}
          onRequestSubmit={this._insertFromGridCreationTableInsertModal}
          onRequestClose={this._closeGridCreationTableInsertModal}
          structuredTableInsertionContext={this.props!.structuredTableInsertionContext}
        />
      </ModalAnchor>
    );
  },
  // NOTE LINKED APP CANVAS
  _openAppCanvasInsertModal(index: number) {
    this.setState?.({appCanvasInsertModalState: {open: true, index}});
  },

  _closeAppCanvasInsertModal() {
    this.setState?.({appCanvasInsertModalState: {open: false}});
  },

  _insertNoteLinkedAppCanvas(appInstallationApiId: string, featureId: string) {
    const item = NoteLinkedAppCanvasUtil.createEmptyNoteLinkedAppCanvas(appInstallationApiId, featureId);
    const newItem = reactUpdate(
      makeDefaultItem(NOTE_LINKED_OBJECT),
      this.props!.setContent!(NoteConstants.NOTE_LINKED_APP_CANVAS, {item})
    );
    this.itemInsertHandler?.(this.state!.appCanvasInsertModalState!.index!, newItem);
    this._closeAppCanvasInsertModal();
  },

  renderAppCanvasInsertModal() {
    if (!this.state!.appCanvasInsertModalState?.open) {
      return null;
    }
    return (
      <ModalAnchor open={true}>
        <InsertNoteLinkedCanvasModal
          onClose={this._closeAppCanvasInsertModal}
          onSubmit={this._insertNoteLinkedAppCanvas}
        />
      </ModalAnchor>
    );
  },

  // LOOKUP TABLES
  _openLookupTableInsertModal(index: number) {
    this.setState?.({lookupTableInsertionInfo: {index, isLookupTableModalOpen: true}});
  },

  _closeLookupTableInsertModal(index: number) {
    this.setState?.({lookupTableInsertionInfo: {index: null, isLookupTableModalOpen: false}});
  },

  _insertFromLookupTableInsertModal({
    schema,
    selectorsById,
  }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schema: any;
    selectorsById: {[selectorId: string]: SchemaFieldSelector};
  }) {
    const index = this.state!.lookupTableInsertionInfo!.index!;
    this._insertStructuredTable(
      index,
      StructuredTableKind.LOOKUP,
      schema.name,
      [{...schema, columnGroup: null}],
      {},
      selectorsById,
      {
        action_method: ActionMethod.NOTEBOOK_INSERT_MENU,
      }
    );

    this._closeLookupTableInsertModal();
  },

  renderLookupTableInsertModal() {
    if (!this.state!.lookupTableInsertionInfo?.isLookupTableModalOpen) {
      return null;
    }

    return (
      <ModalAnchor open={true}>
        <LookupTableInsertModal
          onRequestSubmit={this._insertFromLookupTableInsertModal}
          onRequestClose={this._closeLookupTableInsertModal}
        />
      </ModalAnchor>
    );
  },

  // PARAMETER TABLES
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openParameterTableInsertModal(index: number, mode: any) {
    this.setState?.({parameterTableInsertionInfo: {index, mode}});
  },
  _closeParameterTableInsertModal() {
    this.setState?.({parameterTableInsertionInfo: null});
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _insertFromParameterTableInsertModal({parameters}: {parameters: any}) {
    const {index, mode} = this.state!.parameterTableInsertionInfo!;
    const schemasWithColumnGroups = getTableSchemasFromParameterInfos(parameters).map((schema) => ({
      ...schema,
      columnGroup: null,
    }));
    // Parameter Tables unfortunately have a ton of special casing here because they require adding values
    // immediately for delegate columns to populate. Otherwise, this is similar to _insertStructuredTable
    const name = excess.util.uniqueTableName(
      this.props!.usedTableNames!(),
      `${ParameterStructuredTableModeToName[mode]} `
    );
    const adapter = STRUCTURED_TABLE_PLUGIN.get(StructuredTableKind.PARAMETER);
    let structuredTable = adapter.createTable({
      name,
      schemas: schemasWithColumnGroups,
      entryId: this.props!.fileId!,
      metadata: {
        mode,
        isMultibatch: this.props!.isConfig
          ? undefined
          : this.props!.structuredTableInsertionContext?.isProcedureMultibatchExecution,
      },
      selectorsById: {},
      isConfig: this.props!.isConfig,
      structuredTableInsertionContext: this.props!.structuredTableInsertionContext,
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (adapter as any).addParametersToTable(
      structuredTable,
      parameters,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (rows: Array<TableConstants.Row>, rowMetadatas: any, delegatedColumns: any, tableData: any) => {
        const newStructuredTable = addRowsToTable(
          rows,
          structuredTable as AnyStructuredTable,
          adapter,
          rowMetadatas ?? null
        );
        if (newStructuredTable != null) {
          structuredTable = {
            ...newStructuredTable,
            ...tableData,
            delegatedColumns: [...newStructuredTable.delegatedColumns, ...(delegatedColumns ?? [])],
          };
        }
      }
    );
    const cidIdMap: CidIdMap = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    StructuredTableStoreTransforms.prepareForStore(structuredTable as any, cidIdMap);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.props!.registerObjects?.(cidIdMap as any);
    const newItem = reactUpdate(
      makeDefaultItem(NOTE_LINKED_OBJECT),
      this.props!.setContent!(ModelTypeConstants.STRUCTURED_TABLE, {item: structuredTable})
    );
    this.itemInsertHandler?.(index, newItem);
    this._fireStructuredTableInsertionAnalyticsEvent(structuredTable, StructuredTableKind.PARAMETER, false, {
      action_method: ActionMethod.NOTEBOOK_INSERT_MENU,
    });
    // after creating the table, close the modal
    this._closeParameterTableInsertModal();
  },
  renderParameterTableInsertModal() {
    if (!this.state!.parameterTableInsertionInfo) {
      return null;
    }
    const {mode} = this.state!.parameterTableInsertionInfo;
    const {parameterSettings, parameterUsages} = this.props!.procedureStepConfigEditorContext ?? {
      parameterSettings: undefined,
      parameterUsages: undefined,
    };
    const sessionId = analytics.makeAnalyticsEventId();
    return (
      <ModalAnchor open={true}>
        <ParameterStructuredTableParameterSelectionModal
          sessionId={sessionId}
          onRequestSubmit={this._insertFromParameterTableInsertModal}
          onRequestClose={this._closeParameterTableInsertModal}
          parameterTableMode={mode}
          parameterSettings={parameterSettings}
          parameterUsages={parameterUsages}
          fileId={this.props!.fileId}
          isConfig={this.props!.isConfig!}
        />
      </ModalAnchor>
    );
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _openMixturePrepGroupInsertModal(index: number, type: any) {
    this.setState?.({mixturePrepGroupModalState: {index, type}});
  },

  _closeMixturePrepGroupInsertModal() {
    this.setState?.({mixturePrepGroupModalState: null});
  },

  _insertFromMixturePrepGroupInsertModal(
    schema: BatchSchema | Schema,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    labelingStrategy: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parentLinkMixtureFieldId: any,
    selectorsById: {[selectorId: string]: SchemaFieldSelector}
  ) {
    const {index} = this.state!.mixturePrepGroupModalState!;
    const getNextUniqueName = excess.util.makeUniqueNameFactory(this.props!.usedTableNames!());
    const kind = NoteLinkedGroupKind.MIXTURE_GROUP;
    const group = NOTE_LINKED_GROUP_PLUGIN.get(kind).createGroup({
      name: getNextUniqueName(`${schema.name} `),
      kind,
      schemas: [schema],
      entryId: this.props!.fileId!,
      isConfig: Boolean(
        APIUtil.isEntryOrSubOrWorkflowTemplate(this.props!.fileId!) ||
          (APIUtil.isDocument(this.props!.fileId!) && this.props!.isConfig)
      ),
      groupMetadata: {},
      selectorsById,
      extras: {mixtureMetadataTableMetadata: {labelingStrategy, parentLinkMixtureFieldId}, getNextUniqueName},
    }) as unknown as FromServerNoteLinkedGroup<unknown>;

    const cidIdMap: CidIdMap = {};
    NoteLinkedGroupStoreTransforms.prepareForStore(group, cidIdMap);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.props!.registerObjects?.(cidIdMap as any);

    const groupNotePart = reactUpdate(
      makeDefaultItem(NOTE_LINKED_OBJECT),
      this.props!.setContent!(NoteLinkedObjectType.NOTE_LINKED_GROUP, {item: group})
    );
    this.itemInsertHandler?.(index, groupNotePart);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this._fireStructuredTableInsertionAnalyticsEvent(group.containedNoteParts[0].item! as any, kind, false);
    this._closeMixturePrepGroupInsertModal();
  },

  renderMixturePrepGroupInsertModal() {
    return (
      <ModalAnchor open={this.state!.mixturePrepGroupModalState != null}>
        <MixturePrepGroupInsertModal
          onRequestSubmit={(schema, labelingStrategy, parentLinkMixtureFieldId, selectorsById) => {
            this._insertFromMixturePrepGroupInsertModal(
              schema,
              labelingStrategy,
              parentLinkMixtureFieldId,
              selectorsById
            );
          }}
          onRequestClose={() => {
            this._closeMixturePrepGroupInsertModal();
          }}
        />
      </ModalAnchor>
    );
  },

  formatHandler(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {index, subIndex, startOffset, endOffset}: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e: {partition?: any; format?: string; data?: any}
  ) {
    let cols;
    let item;
    let rows;
    const {format, data} = e;
    const {rootFolderId: projectId, fileId, templateCollectionId} = this.props!.editorPropertiesContext;
    const fileAnalyticsParams = {projectId, fileId, templateCollectionId};

    // Attempt to acquire an editor lock prior to opening a modal for insertion. This is to defend against
    // the user losing their lock while entering the input fields on the modal.
    DocumentEditorLockUtil.forceAcquireLock(this.props!.fileId!);

    if (!index) {
      index = 0;
    }

    if (format === 'selector') {
      this.openManageSelectorsModal();
      return;
    }

    if (format === 'symbol') {
      item = this.atIndex!(index);
      this.openInsertSymbolModal(index, e.partition, item.formats);
      return;
    }

    if (format === 'saved-search') {
      if (this._shouldAllowInsertSavedSearch()) {
        item = this.atIndex!(index);
        this._openSavedSearchInsertModal(index, e.partition, item.formats);
        return;
      } else {
        return;
      }
    }

    if (format === 'subtemplate') {
      if (this._shouldAllowInsertSubtemplate()) {
        this._openSubtemplateInsertModal(index);
        return;
      } else {
        return;
      }
    }

    if (format === 'day') {
      if (this._shouldAllowInsertDay()) {
        this.insertDay(index + 1, '');
        this.setState?.({insertIndex: null});
        return;
      } else {
        return;
      }
    }

    if (format === 'section') {
      if (this._shouldAllowInsertSection()) {
        this._openEntryDayInsertModal(index + 1);
        return;
      } else {
        return;
      }
    }

    let multiRange = this.getSelectedRange!(index);
    assertAndContinue(multiRange != null, 'No range selected');
    if (index != null) {
      this.props!.storeState!({selection: selutil.getSelectionIndices()});
    } else {
      this.saveMultiSelect?.();
    }

    multiRange = multiRange!;
    if (format === 'attach') {
      item = makeFilePlaceholderItem();
      this.itemInsertHandler?.(index, item);
    } else if ([BULLET, NUMBER, CHECKBOX_UNCHECKED].includes(format! as ListType)) {
      this.noteListRangeHandler(multiRange.start, multiRange.end, format! as ListType);
    } else if ([HEADER_1, HEADER_2, SUBHEADER_1, PARAGRAPH].includes(format!)) {
      this.headerFormatRangeHandler(multiRange.start, multiRange.end, format);
      this.setSelection?.(selutil.getSelectionIndices());
    } else if (format === FormattersConstants.CYCLE_HEADER) {
      this.cycleHeaderFormatRangeHandler(multiRange.start, multiRange.end);
    } else if (format === 'delete') {
      if (index != null && subIndex === 'item') {
        this.deleteItem(index);
      } else {
        this.deleteRangeHandler(multiRange);
      }
    } else if (format === 'important') {
      this.importantFormatRangeHandler(multiRange.start, multiRange.end);

      // TODO(T7328): These cases should be handled by the NoteToolbar
    } else if (format === 'table') {
      [rows, cols] = TableConstants.DEFAULT_TABLE_SIZE;
      this._insertTableOrWellPlate(index, rows, cols, false);
    } else if (format === 'well-plate') {
      [rows, cols] = TableConstants.DEFAULT_PLATE_SIZE;
      this._insertTableOrWellPlate(index, rows, cols, true);
    } else if (format === 'code') {
      this.insertItemHandler(index, format);
    } else if (format === NOTE_FILL_IN_TEXT_BOX) {
      analytics.trackEvent(
        ELN_ANALYTICS_ACTIONS.INSERT_TEXT_BOX,
        getFileAnalyticsMetadata(fileAnalyticsParams)!
      );
      const textBoxNames = this.getTextBoxNames!();
      this.itemInsertHandler?.(index, makeTextBoxItem(textBoxNames));
    } else if (['left', 'center', 'right'].includes(format!)) {
      this.alignmentFormatHandler(index, format);
    } else if (
      [ModelTypeConstants.DATA_TABLE, ModelTypeConstants.DATA_TABLE_CONFIG].includes(
        format! as ModelTypeConstants
      )
    ) {
      this._openResultsTableInsertModal(index, format);
    } else if (
      [ModelTypeConstants.REGISTRATION_TABLE, ModelTypeConstants.REGISTRATION_TABLE_CONFIG].includes(
        format! as ModelTypeConstants
      )
    ) {
      this._openRegistrationTableInsertModal(index, format);
    } else if (
      [ModelTypeConstants.TRANSFER_TABLE, ModelTypeConstants.TRANSFER_TABLE_CONFIG].includes(
        format! as ModelTypeConstants
      )
    ) {
      this._openInventoryTableInsertModal(index, format);
    } else if (format === ModelTypeConstants.ASSAY_RUN) {
      this._openRunInsertModal(index);
    } else if (format === MIXTURE_PREP_GROUP) {
      this._openMixturePrepGroupInsertModal(index, format);
    } else if (format === PLATE_CREATION_TABLE) {
      this._openGridCreationTableInsertModal(index, GridType.PLATE);
    } else if (format === BOX_CREATION_TABLE) {
      this._openGridCreationTableInsertModal(index, GridType.BOX);
    } else if (format === ModelTypeConstants.LOOKUP_TABLE) {
      this._openLookupTableInsertModal(index);
    } else if (Object.values(ParameterStructuredTableMode).includes(format as ParameterStructuredTableMode)) {
      this._openParameterTableInsertModal(index, format);
    } else if (format === ModelTypeConstants.MOLECULE) {
      this._openChemicalStructureInsertModal(index);
    } else if (format === FIXED_PLATE_EDITOR) {
      this.openFixedPlateEditorModal(index);
    } else if (format === AI_CONTENT) {
      this._openAIContentInsertModal(index);
    } else if (format === AI_CHECKS) {
      this._openAICheckerPanel();
    } else if (format === AI_DATA_ENTRY) {
      this.addAIDataEntryRowsUsingAI();
    } else if (this.hasMultiSelection?.()) {
      this.formatRangeHandler?.({start: multiRange.start, end: multiRange.end, format: format!, data});
    } else if (format === ModelTypeConstants.NOTE_LINKED_APP_CANVAS) {
      item = this.atIndex!(index);
      this._openAppCanvasInsertModal(index);
    } else {
      this.textItemFormatHandler(index, e);
    }
  },

  _getAIDataEntryStructuredTableNoteParts(): Array<{
    notePart: NotePart;
    index: number;
    table: StructuredTable<unknown, unknown>;
    adapter: StructuredTableAdapter<unknown, unknown>;
  }> {
    const structuredTableNoteParts: Array<{
      notePart: NotePart;
      index: number;
      table: StructuredTable<unknown, unknown>;
      adapter: StructuredTableAdapter<unknown, unknown>;
    }> = [];
    this.props!.getItems(this.props!.getRoot()).forEach((notePart, index) => {
      if (
        this.props!.getType(notePart) === ModelTypeConstants.STRUCTURED_TABLE &&
        SUPPORTED_TABLE_KINDS_FOR_AI_DATA_ENTRY.includes(
          (notePart.item as StructuredTable<unknown, unknown>).kind
        )
      ) {
        const table = notePart.item as StructuredTable<unknown, unknown>;
        structuredTableNoteParts.push({
          notePart,
          index,
          table,
          adapter: STRUCTURED_TABLE_PLUGIN.get(table.kind),
        });
      }
    });
    return structuredTableNoteParts;
  },

  _addAIDataEntryRows(
    result: AddStructuredTableRowsUsingAIResult | null,
    structuredTable?: StructuredTable<unknown, unknown>
  ) {
    if (result) {
      this.props?.storeState?.();
      let lastTableIndex: number | null = null;
      const structuredTableNoteParts = this._getAIDataEntryStructuredTableNoteParts();
      structuredTableNoteParts.forEach(({notePart, index, table, adapter}, i) => {
        const rows = result.newRows[table.name];
        if (rows && rows.length > 0) {
          if (lastTableIndex == null || index > lastTableIndex) {
            lastTableIndex = index;
          }
          // If the structured table is provided, use it to add rows to the table. Otherwise, add rows to the first table.
          // This is specifically used in StructuredTableView to pass the latest table state from a ref.
          const newTable = addRowsToTable(
            rows,
            table.name === structuredTable?.name ? structuredTable : table,
            adapter,
            null
          );
          const newNotePart = {...notePart, item: newTable};
          const root = this._itemUpdateHelper!(index, newNotePart);
          this.props!.updateRoot(root);
        }
      });
      if (result.noteParts && result.noteParts.length > 0) {
        if (result.cidIdMap) {
          this.props!.registerObjects?.(result.cidIdMap);
        }
        this.itemInsertHandler!(lastTableIndex != null ? lastTableIndex : 0, ...result.noteParts);
      }
    }
  },

  async addAIDataEntryRowsUsingAI(
    initialPromptText?: string,
    initialSelectedTableName?: string,
    structuredTable?: StructuredTable<unknown, unknown>,
    result?: AddStructuredTableRowsUsingAIResult | null
  ) {
    const structuredTableNoteParts = this._getAIDataEntryStructuredTableNoteParts();
    // If the result is not provided, launch the AI modal to get a result. Otherwise, use the result to add rows to the table.
    if (!result) {
      result = await addStructuredTableRowsUsingAI(
        this.props!.fileId!,
        structuredTableNoteParts.map(({table}) => table),
        initialPromptText,
        initialSelectedTableName
      );
    }
    this._addAIDataEntryRows(result, structuredTable);
  },

  _insertTableOrWellPlate(index: number, rows: number, cols: number, isWellPlate: boolean) {
    const tableItem = this.createDefaultableItem!(
      this.tableType,
      this.getPluginByType!(this.tableType).component.default!.call(
        this as EditorMixinInterfaceBase,
        rows,
        cols,
        {isWellPlate}
      )
    );
    this.itemInsertHandler?.(index, tableItem);
    const fileIdKey = getEntryOrFileIdKey(this.props?.fileId);
    analytics.track('lab_notebook', 'edited_entry', {
      [fileIdKey]: this.props!.fileId!,
      is_tutorial_entry: ONBOARDING_ENTRY_NAMES.indexOf(this.props!.title!) !== -1,

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      is_entry_creator: (this.props!.note!.creator as any).handle === EntityStore.currentUser().handle,
      action: 'added_table',
    });
  },

  insertTableWithDimensions(rows: number, cols: number) {
    this._insertTableOrWellPlate(this.state!.selected.index!, rows, cols, false);
  },

  insertWellPlateWithDimensions(rows: number, cols: number) {
    analytics.deprecatedTrackEvent(ELN_ANALYTICS_ACTIONS.CREATED_WELL_PLATE_TABLE_IN_NOTEBOOK_ENTRY, {
      size: rows * cols,
    });
    this._insertTableOrWellPlate(this.state!.selected.index!, rows, cols, true);
  },

  deleteItem(index: number) {
    this.itemDeleteHandler?.(index);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  moveHandler(index: number, e: {up: any; beginning: any}) {
    const {up, beginning} = e;
    const dir = up ? -1 : 1;

    if (index === 0 && up && !this.props!.hideTitle) {
      const pos = beginning ? 0 : this.props!.title!.length;
      this.props!.requestSelection?.({selection: {cid: TitleEditorCID, start: pos, end: pos}});
      return;
    }

    const newIndex = index + dir;
    const lastItem = this.atIndex!(this.lastIndex!());
    // When attempting to move down off the bottom of the page, if current line is not a line of empty text,
    // create a new line at the bottom and move to it.
    if (
      newIndex > this.lastIndex!() &&
      !(
        (lastItem != null ? lastItem.type : undefined) === NoteConstants.TEXT &&
        !(lastItem != null ? lastItem.text : undefined)
      )
    ) {
      this.insertDefaultableItemHandler?.(this.lastIndex!(), NoteConstants.TEXT);
    }

    const item = this.atIndex!(newIndex);
    if (item != null) {
      this.props!.getCid(item);
      if (!this.itemHasText(item) && this.hasSelectionAll!(item)) {
        // If item does not have text to select, select the whole item
        this.props!.requestSelection?.(this.selectionAll!(item));
      } else {
        const selection = beginning ? this.selectionAtStart!(item) : this.selectionAtEnd!(item);
        this.props!.requestSelection?.(selection);
      }
    }
  },

  titleMoveHandler({up, beginning}: {up: boolean; beginning: boolean}) {
    if (!up) {
      const item = this.atIndex!(0);
      const selection = beginning ? this.selectionAtStart!(item) : this.selectionAtEnd!(item);
      this.props!.requestSelection?.(selection);
    }
  },

  getComputedTables(root: Note) {
    return root.noteRuntimeSnapshot.evaluationSnapshot;
  },

  getValidationErrorSnapshot() {
    return this.props!.note?.noteRuntimeSnapshot?.validationErrorSnapshot ?? {};
  },

  isVirtualizationSupported() {
    return APIUtil.isNotebookEntryOrTemplate(this.props!.fileId!) || this.props!.isVirtualizationEnabled!;
  },

  _catcherSetInsertIndex(index: number) {
    this.setState?.({insertIndex: index});
  },

  _catcherInsertFile(index: number, linkedItem: LinkedItem) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const type = APIUtil.apiIdToType(linkedItem.id as any);
    const newItem = this.withAttachedItem(this.makeItem(type), type, linkedItem.id!, linkedItem);
    this.itemInsertHandler?.(index, newItem);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertPlaceholders(index: number, taskIdAndDeferreds: Array<any>) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newItems = taskIdAndDeferreds.map((taskIdAndDeferred: any) =>
      this.createFilePlaceholderForTask(taskIdAndDeferred)
    );
    this.itemInsertHandler?.(index, ...newItems);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _catcherInsertFilePlaceholder(index: number, taskIdAndDeferreds: any) {
    this.insertPlaceholders(index, taskIdAndDeferreds);
  },

  onMouseDownCatcher(e: {target: string | Element | Text | null; preventDefault: () => void; pageY: number}) {
    assert(!this.props!.locked, 'NoteEditor is locked');
    if (
      e.target !== ReactDOM.findDOMNode(this.refs.catcher) &&
      !$(e.target!).attr('data-mediocre-item-whitespace')
    ) {
      return true;
    }

    // Don't let the active element change. Otherwise, keydown handlers
    // (like backspace) don't get fired on the new selection.
    e.preventDefault();

    // Find the closest text item to the click event.
    // TODO how do we handle caption items?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const $textItems = $(ReactDOM.findDOMNode(this.refs.editor) as any).find('.mediocre-item.is-text');
    let bestIndex = null;
    let minDistance = Infinity;
    let maxTextItemY = 0;
    // Changing the following to an arrow function causes errors
    $textItems.each(function () {
      // @ts-expect-error
      const {top} = $(this).offset();
      // @ts-expect-error
      const bottom = top + $(this).height();
      maxTextItemY = Math.max(bottom, maxTextItemY);
      const distance = Math.min(Math.abs(top - e.pageY), Math.abs(bottom - e.pageY));
      if (distance < minDistance) {
        minDistance = distance;
        // @ts-expect-error
        bestIndex = $(this).find('[data-index]').attr('data-index');
      }
    });

    if (e.pageY > maxTextItemY) {
      // If the user clicks below the last text item, then move the cursor to the last
      // note part if it's empty, otherwise create a new note part.
      const lastItem = this.atIndex!(this.lastIndex!());
      if (
        (lastItem != null ? lastItem.type : undefined) === NoteConstants.TEXT &&
        !(lastItem != null ? lastItem.text : undefined)
      ) {
        return this.props!.requestSelection?.(this.selectionAtStart!(lastItem));
      } else {
        return this.insertDefaultableItemHandler?.(this.lastIndex!(), NoteConstants.TEXT);
      }
    } else {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const item = this.atIndex!(bestIndex as any);
      if (assertAndContinue(Boolean(item), 'Expected to find a nearest text item on mouse down.')) {
        return true;
      }
      return this.props!.requestSelection?.(this.selectionAtStart!(item));
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _editorSizerThrottledHandleResize: throttle(function boundResize(this: any) {
    return this._editorSizerHandleResize();
  }, 250),

  _editorSizerHandleResize() {
    if (this._isMounted && isBrowser && !isHeadlessChrome()) {
      // In we did not guard against the non-browser environment, we'd set editorWidth to 0,
      // which results in undesired behavior when performing exports.

      const $container = $(ReactDOM.findDOMNode(this.refs.container)!);
      const containerWidth = $container.width();
      const containerHeight = $container.height();

      let editorWidth = $(ReactDOM.findDOMNode(this.refs.editor)!).width();
      editorWidth -= this.props!.showTimestamps ? TIMESTAMP_WIDTH : 0;

      if (
        editorWidth !== this.state!.editorWidth ||
        containerWidth !== this.state!.containerWidth ||
        containerHeight !== this.state!.containerHeight
      ) {
        this.setState?.({editorWidth, containerWidth, containerHeight});
      }
    }
  },

  componentDidMount() {
    this._isMounted = true;
    if (!this.props!.locked) {
      _.defer(() => {
        let selection;
        if (!this.props!.hideTitle && this.props!.title! === 'Untitled') {
          // Select the title if the user should be renaming this note ...
          selection = {selection: {cid: TitleEditorCID, start: 0, end: this.props!.title.length}};
        } else {
          // ... otherwise just put the cursor at the beginning of the note.
          selection = this.selectionAtStart!(this.atIndex!(0));
        }
        this.props!.requestSelection?.(selection);
      });
    }
    _.defer(() => this.props!.onLoad?.());
    this._isMounted = true;

    // For virtualized content, the initial render will have all skeletons, so we defer by one tick to
    // properly capture the user-experienced delay.
    _.defer(() => {
      datadogRum.addTiming('notebook.NoteEditor.rendered');
    });

    window.addEventListener('resize', this._editorSizerThrottledHandleResize);
    if (BenchlingConfig.ENABLE_NUE_MODULES) {
      OnboardingActions.fetchOnboardingTasks();
    }

    // Fetch live data for stale indicators
    Promise.all([fetchLiveDataOnEntryMount(this.props!.note!.noteRuntimeSnapshot.queryResolutions)]).then(
      () => {
        // We want to ensure that all children that use `useHydratedStructuredTableData` re-render, as those
        // children rely on this component to call fetchLiveDataOnEntryMount. Ideally, such components are
        // responsible for queuing up and listening for the data they need, but as a quick performance win,
        // the logic was collected here (#31889).
        //
        // this.forceUpdate() on NoteEditor does /not/ guarantee that the StructuredTableView will re-render:
        // > Calling forceUpdate() will cause render() to be called on the component, skipping
        // > shouldComponentUpdate(). This will trigger the normal lifecycle methods for child components,
        // > including the shouldComponentUpdate() method of each child.
        // (from https://reactjs.org/docs/react-component.html#forceupdate)
        //
        // In particular, <MediocreItem> implements a `shouldComponentUpdate()` that will return false,
        // as no props have changed. This means that its child, <StructuredTableView>, will not re-render.
        //
        // Instead, we introduce an incrementing state `forceLiveness` that is threaded down to
        // <StructuredTableView> via getTableItemProps, ensuring that regardless of what PureComponent-like
        // implementation any parent may have, that we expect it to re-render.
        this.setState?.({forceLiveness: this.state!.forceLiveness + 1});
      }
    );
  },

  onSetFocusedTable(
    focusedTableProvenanceUuid: string | null,
    focusedTableViewMode: TableConstants.FocusedTableViewMode
  ) {
    // If a table is being focused, persist the scroll position.
    if (focusedTableProvenanceUuid && this._getNoteEditorContainer()) {
      this._saveEditorScrollPosition();
    }
    if (
      APIUtil.isNotebookEntryOrTemplate(this.props!.fileId!) ||
      APIUtil.isBasicFolderItem(this.props!.fileId!) ||
      APIUtil.isDocument(this.props!.fileId!)
    ) {
      EntryActions.setFocusedTable(this.props!.fileId!, focusedTableProvenanceUuid, focusedTableViewMode);
    }
  },

  componentDidUpdate(prevProps: NoteEditorProps, prevState: NoteEditorState) {
    this._editorSizerHandleResize();
    const manageSelectorsModalProps = {
      initialSelectorId: this.state!.initialSelectorId!,
      locked: this.props!.locked!,
      parentType: this.props!.parentType!,
      selectorsLink: {
        value: this.props!.getRoot().selectors,
        requestChange: this.props!.updateSelectors!,
        selectorUsageCounts: this.props!.selectorCounts!,
      },
      onRequestClose: this.closeManageSelectorsModal,
    };
    this.toggleManageSelectorsModal(prevState, this.state!, manageSelectorsModalProps);
    this.toggleNotebookPerformanceModal(prevState, this.state!);

    // If maximized table was closed or changed to split screen, restore the scroll position.
    if (
      (prevState.focusedTableProvenanceUuid !== this.state!.focusedTableProvenanceUuid &&
        !this.state!.focusedTableProvenanceUuid) ||
      (prevState.focusedTableViewMode !== this.state!.focusedTableViewMode &&
        this.state!.focusedTableProvenanceUuid)
    ) {
      this._restoreEditorScrollPosition();
    }

    maybeUpdatePrintWarningForContentWidth(this.state!.containerWidth!, this.props!.displayOptions!);

    if (BenchlingConfig.ELN_ENABLE_ENTRY_SECTIONS) {
      this._updateFileSectionState(prevState.openVersionId);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _updateFileSectionState(prevOpenVersionId: any) {
    // All entry sections will default to open if the entry version being viewed is an older version.
    // Check for updates to the currently viewed item version to avoid unnecessary re-renders.
    const currentVersionId = this._getVersionId(this.props!.fileId!, this.props!.fileType);
    if (currentVersionId !== prevOpenVersionId) {
      const fileSectionState = this._isViewingOldVersion()
        ? {}
        : getEntryPersistentStorage().getFileSectionState(this.props!.fileId!, this.props!.note!.days!);

      this.setState?.({
        fileSectionState,
        openVersionId: currentVersionId,
      });
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _getVersionId(fileId: any, fileType: any) {
    let store;
    switch (fileType) {
      case ModelTypeConstants.ENTRY:
        store = EntryStore;
        break;
      case ModelTypeConstants.TEMPLATE:
        store = TemplateStore;
        break;
      case ModelTypeConstants.DOCUMENT:
        store = DocumentStore;
        break;
      default:
        store = null;
    }
    return store ? store.getVersionState(fileId).openVersionId : undefined;
  },

  _getNoteEditorContainer() {
    return this.scrollContainerNode || null;
  },

  _saveEditorScrollPosition() {
    const noteEditorContainer = this._getNoteEditorContainer();
    this._savedEditorScrollTop = noteEditorContainer ? noteEditorContainer.scrollTop : null;
  },

  _restoreEditorScrollPosition() {
    const noteEditorContainer = this._getNoteEditorContainer();
    if (noteEditorContainer && this._savedEditorScrollTop != null) {
      noteEditorContainer.scrollTop = this._savedEditorScrollTop;
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _scrollToNotePart(provenanceUuid: any) {
    const noteEditorContainer = this._getNoteEditorContainer();
    const notePart = this.props!.note!.noteParts.find(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (currentNotePart: any) => this._getProvenanceUuidForTable!(currentNotePart) === provenanceUuid
    );
    if (notePart && noteEditorContainer) {
      const notePartContainer = noteEditorContainer.querySelector(`[data-scroll-id="${notePart.cid}"]`);
      if (notePartContainer) {
        notePartContainer.scrollIntoView({block: 'center'});
        this._saveEditorScrollPosition();
      }
    }
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this._editorSizerThrottledHandleResize);
    DocumentEditorLockUtil.releaseLock(this.props!.fileId!);
    this._isMounted = false;
  },

  getDocumentVersionCid() {
    return this.props!.note!.cid;
  },

  getTextForDate(date: moment.MomentInput) {
    if (APIUtil.isEntryOrSubOrWorkflowTemplate(this.props!.fileId!)) {
      return getTemplateReadableDate(date);
    }
    return getNoteReadableDate(date);
  },

  _renderBeforeEditable(index: number, startIndex: number) {
    if (this.props!.note!.days! == null) {
      return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const day = (NoteEditor as any).getRenderedDayOfNotePart(index, startIndex, this.props!.note!.days);
    if (day == null) {
      return null;
    }

    // day.index is the index in the array of note parts at which to insert the day
    // dayIndex is the index of the day in this.props!.note!.days!
    // eslint-disable-next-line no-restricted-syntax
    const dayIndex = _.findIndex(this.props!.note!.days, {index: day.index});
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (dayIndex === 0 && (this.props!.sectionConfiguration as any)?.allows?.preamble) {
      return null;
    }

    let previousDate;
    let nextDate;
    if (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      !(this.props!.sectionConfiguration as any)?.allows?.date ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.props!.sectionConfiguration as any)?.allows?.title
    ) {
      ({previousDate, nextDate} = EntryDayOps.getPreviousAndNextDateFromIndex({
        // @ts-expect-error(2322): EntryDayOps expects an EntryNote but we are passing it a Note
        note: this.props!.note,
        notePartIndex: index,
        nextDayOffset: 1,
      }));
    } else {
      previousDate = this.props!.note!.days[dayIndex - 1]?.date;
      nextDate = this.props!.note!.days[dayIndex + 1]?.date;
    }

    return (
      <DaySeparator
        day={day}
        getTextForDate={this.getTextForDate}
        key={`day-separator-${day.cid}`}
        forTemplate={APIUtil.isEntryOrSubOrWorkflowTemplate(this.props!.fileId!)}
        isDateChangeable={!this.props!.locked && Boolean(day.date)}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isDateAllowed={(this.props!.sectionConfiguration as any)?.allows?.date}
        onDelete={!this.props!.locked && day.index !== 0 ? this.deleteDay : undefined}
        previousDate={previousDate}
        nextDate={nextDate}
        isProtected={this.isProtectedAgainstEdit() || this.props!.locked}
        title={day.title}
        onTitleChange={this.updateTitle}
        getDateBoundaries={this._getDatesBetweenIndex}
        onDayChange={this.updateDay}
        onColorChange={this.updateColor}
        isDayOnly={this._isDayOnly()}
      />
    );
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _handleSectionToggle(index: number, isOpen: any, puuid: string | number) {
    // convert fileSectionState list to sectionState dictionary
    const fileId = this.props!.fileId;

    // update sectionState in component state, session storage, local storage,
    let updatedFileSectionState = {...this.state!.fileSectionState};

    if (updatedFileSectionState.hasOwnProperty(puuid)) {
      updatedFileSectionState[puuid].isOpen = isOpen;
    } else {
      // set the puuid to isOpen if it does not exist yet
      updatedFileSectionState[puuid] = {isOpen};
    }

    // (un)collapsing sections in older version will not affect the section state storage
    if (!this._isViewingOldVersion()) {
      // filter out PUUID's that don't exist anymore in this.props!.note!.days!
      const updatedFileSectionStateCopy = {...updatedFileSectionState};
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const validPuuids = this.props!.note!.days!.map((day: {provenanceUuid: any}) => day.provenanceUuid);

      const filteredFileSectionState = Object.keys(updatedFileSectionStateCopy)
        .filter((puuidKey) => validPuuids.includes(puuidKey))
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((obj: {[key: string]: any}, key) => {
          obj[key] = updatedFileSectionStateCopy[key];
          return obj;
        }, {});

      updatedFileSectionState = filteredFileSectionState;

      getEntryPersistentStorage().setFileSectionState(fileId!, updatedFileSectionState);
    } else {
      // Track when the user opens or closes a section in an older version.
      // was_closed_in_newest_version is true if the section that was toggled was already
      // closed in the newest version, false otherwise or if the section does not exist
      // in the newest version.
      let sectionWasClosedInNewestVersion = false;
      if (this.state!.latestFileSectionState.hasOwnProperty(puuid)) {
        sectionWasClosedInNewestVersion = !this.state!.latestFileSectionState[puuid].isOpen;
      }

      analytics.trackEvent(ELN_ANALYTICS_ACTIONS.TOGGLED_ENTRY_SECTION_IN_NON_LATEST_ENTRY_VERSION, {
        fileId,
        puuid,
        is_open: isOpen,
        was_closed_in_newest_version: sectionWasClosedInNewestVersion,
      });
    }

    this.setState?.({
      fileSectionState: updatedFileSectionState,
    });
  },

  _isDayOnly() {
    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.props!.sectionConfiguration as any)?.allows?.date &&
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      !(this.props!.sectionConfiguration as any)?.allows?.title
    );
  },

  getSearchableItems(note: Note) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.props!.sectionConfiguration as any)?.allows?.collapse) {
      return getUncollapsedNoteParts(this.props!.getItems(note), this.state!.fileSectionState, note.days!);
    }
    return this.props!.getItems(note);
  },

  postProcessRenderedItems(indexSlice: {start: number; end: number}, renderedItems: Array<JSX.Element>) {
    // If renderCanvas prop is provided, return the list of renderedItems as-is. All rendering post-processing
    // should be handled within the Canvas component itself
    if (this.props!.renderCanvas) {
      return renderedItems;
    } else if (
      this.props!.note!.days! != null &&
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.props!.sectionConfiguration as any)?.allows?.collapse
    ) {
      // Only render sections for notes that have days
      return renderSections(
        indexSlice,
        renderedItems,
        this._renderBeforeEditable,
        this._handleSectionToggle,
        this.state!.fileSectionState
      );
    } else {
      return renderedItems.reduce((prev, cur, index) => {
        const beforeItem = this._renderBeforeEditable(
          index + Math.max(indexSlice.start, 0),
          indexSlice.start
        );
        return beforeItem ? [...prev, beforeItem, cur] : [...prev, cur];
      }, []);
    }
  },

  _shouldAllowInsertSavedSearch() {
    return (
      BenchlingConfig.ELN_ENABLE_INSERT_SEARCH &&
      (this.props!.fileType === ModelTypeConstants.ENTRY ||
        this.props!.fileType === ModelTypeConstants.TEMPLATE ||
        this.props!.fileType === ModelTypeConstants.SUBTEMPLATE)
    );
  },

  _shouldAllowInsertSubtemplate() {
    return (
      this.props!.fileType === ModelTypeConstants.ENTRY ||
      this.props!.fileType === ModelTypeConstants.TEMPLATE ||
      this.props!.fileType === ModelTypeConstants.DOCUMENT
    );
  },

  _shouldAllowInsertDay() {
    const {allows} = this.props!.sectionConfiguration!;
    return allows.date && !allows.title && allows.insertion && this.props!.note!.days! != null;
  },

  _shouldAllowInsertSection() {
    const {allows} = this.props!.sectionConfiguration!;
    return allows.insertion && this.props!.note!.days! != null && !this._shouldAllowInsertDay();
  },

  _isViewingOldVersion() {
    switch (this.props!.fileType) {
      case ModelTypeConstants.ENTRY:
        return !EntryStore.getVersionState(this.props!.fileId!)?.isLatest;
      case ModelTypeConstants.TEMPLATE:
        return !TemplateStore.getVersionState(this.props!.fileId!)?.isLatest;
      case ModelTypeConstants.DOCUMENT:
        return !DocumentStore.getVersionState(this.props!.fileId!)?.isLatest;
      default:
        // We only check whether Entries or Templates are the latest versions for the purpose of
        // the NoteProtectionIndicatorToggle component for fill-in templates
        return false;
    }
  },

  setProtected(isProtected: boolean) {
    if (
      APIUtil.isEntryTemplate(this.props!.fileId!) ||
      (APIUtil.isDocument(this.props!.fileId!) && this.props!.isConfig)
    ) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.props!.updateNote!({...this.props!.note, isProtected} as any);
      analytics.deprecatedTrackEvent(ELN_ANALYTICS_ACTIONS.TOGGLED_FILL_IN_TEMPLATE, {
        setting: isProtected ? 'fill_in_only' : 'modifiable',
        template_id: this.props!.fileId!,
      });
    }
  },

  getToolBarProps() {
    const {subIndex, index, hasNonEmptyTextSelection} = this.state!.selected;
    const range = this.getSelectedRange!(index!);
    const subList = range != null ? this.subList!(range.start, range.end) : undefined;
    const selectedItem = this.atIndex!(index!);

    // When in a procedure config context, filter down the insertableStructuredTableTypes based on the
    // step group type; material output tables are not allowed in POST_RUN steps. This option is filtered
    // out here so that it applies to all the possible toolbars, slash search dropdown, etc.
    const {currentStepGroup} = this.props!.procedureStepConfigEditorContext ?? {currentStepGroup: undefined};
    const baseInsertableTypes = this.props!.customInsertableTables ?? [];
    const insertableStructuredTableTypes =
      currentStepGroup === ProcedureStepGroupType.POST_RUN
        ? baseInsertableTypes.filter(
            (tableType: ParameterStructuredTableMode) =>
              tableType !== ParameterStructuredTableMode.MATERIAL_OUTPUT_CONFIRMATION
          )
        : baseInsertableTypes;

    return {
      fileId: this.props!.fileId!,
      locked: this.props!.locked,
      isProtected: this.isProtectedAgainstEdit(),
      minimal: this.props!.minimalToolbar,
      rangeHasText: subList != null && subList.some((item: NotePart) => this.itemHasText(item)),
      rangeHasTextType:
        subList != null && subList.some((item: NotePart) => this.props!.getType(item) === TEXT),
      hasSelection: Boolean(index != null || this.props!.renderCanvas),
      hasNonEmptyTextSelection: hasNonEmptyTextSelection || false,
      hasMultiSelection: this.hasMultiSelection!(),
      formatState: this.state!.formatState,
      rangeHeaderType: subList != null ? this.rangeHeaderTypes(subList) : null,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      allImportant: subList != null && subList.every((item: {important: any}) => item.important),
      allNumbers: range != null && this.isRangeListType(range.start, range.end, NUMBER),
      allBullets: range != null && this.isRangeListType(range.start, range.end, BULLET),
      allCheckboxes:
        range != null && this.isRangeListType(range.start, range.end, CHECKBOX_CHECKED, CHECKBOX_UNCHECKED),
      itemOnPart: selectedItem?.item != null || false,
      itemLeft: selectedItem?.alignment === 'left',
      itemRight: selectedItem?.alignment === 'right',
      itemCenter: selectedItem?.alignment === 'center',
      itemSelected: subIndex != null,
      itemAlignable: (selectedItem != null && this.getPluginByItem!(selectedItem).alignable) || false,
      showInsertSavedSearch: this._shouldAllowInsertSavedSearch(),
      showInsertSubtemplate: this._shouldAllowInsertSubtemplate(),
      showInsertDay: this._shouldAllowInsertDay(),
      showInsertSection: this._shouldAllowInsertSection(),
      formatHandler: this._toolbarFormatHandler,
      insertTableWithDimensions: this.insertTableWithDimensions,
      insertWellPlateWithDimensions: this.insertWellPlateWithDimensions,
      insertHandler: this._toolbarInsertItemHandler,
      colorHandler: this._colorHandler,
      mouseOverHandler: this._toolbarMouseOverHandler,
      mouseOutHandler: this._toolbarMouseOutHandler,
      printOptions: this.props!.printOptions,
      printHandler: this.selectionPrintHandler,
      undoHandler: this.props!.undoState,
      redoHandler: this.props!.redoState,
      isConfig: this.props!.isConfig ?? false,
      insertableStructuredTableTypes,
      dataEntryStructuredTableNoteParts: this._getAIDataEntryStructuredTableNoteParts(),
    };
  },

  renderToolbar() {
    return (
      <BufferOptions
        key="toolbar"
        fullScreen={this.props!.fullScreen}
        leftChildren={React.createElement(
          BufferOptionsItem,
          null,
          <NoteToolbar {...this.getToolBarProps()} />
        )}
        banner={this.props!.banner}
        rightChildren={[
          showNotebookPerformanceMonitorToggle() ? (
            <NotebookPerformanceMonitorToggle
              key="notebook-performance-monitor-toggle"
              note={this.props!.note!}
              openModal={() => {
                this.openNotebookPerformanceModal();
              }}
            />
          ) : null,
          BenchlingConfig.ELN_ENABLE_FILL_IN_TEMPLATES ? (
            <NoteProtectionIndicatorToggle
              key="note-protection-indicator-toggle"
              isEditable={Boolean(
                this.props!.fileType === ModelTypeConstants.TEMPLATE ||
                  (this.props!.fileType === ModelTypeConstants.DOCUMENT &&
                    this.props!.isConfig &&
                    !this.props!.locked)
              )}
              isDisplayOnly={Boolean(
                this.props!.fileType === ModelTypeConstants.ENTRY ||
                  (this.props!.fileType === ModelTypeConstants.DOCUMENT &&
                    (!this.props!.isConfig || this.props!.locked))
              )}
              // Don't use isProtectedAgainstEdit() here, as we want to know whether it's protected agnostic
              // to whether we're editable or not
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              isProtected={(this.props!.note as any)?.isProtected}
              isViewingOldVersion={this._isViewingOldVersion()}
              isViewingPublishedVersion={this.props!.isViewingPublishedVersion}
              setProtected={this.setProtected}
            />
          ) : null,
          this.props!.fileType === ModelTypeConstants.SUBTEMPLATE ? (
            <BufferOptionsItem key="subtemplate-icon">
              <BenchlingIcon icon={ModelTypeConstants.SUBTEMPLATE} />
              &nbsp;Sub-Template
            </BufferOptionsItem>
          ) : null,
          this.props!.displayOptions != null ? (
            <BufferOptionsItem className="u-vertical-center-items" key="display-options">
              <DisplayOptions dropLeft={true} options={this.props!.displayOptions} />
            </BufferOptionsItem>
          ) : undefined,
        ]}
      />
    );
  },
  _showCollectibleBanner() {
    return (
      BenchlingConfig.ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE &&
      TemplateCollectionUtil.isTemplateCollectibleModelType(this.props!.fileType || '')
    );
  },
  renderCollectibleBanner() {
    return (
      <CollectibleBanner
        key="collectible-banner"
        fullScreen={this.props!.fullScreen}
        type={this.props!.fileType || undefined}
        isLocked={this.props!.locked!}
      />
    );
  },

  _getSelectedIndexSlice() {
    let indices;
    if (this.hasMultiSelection?.()) {
      indices = [this.state!.multiStartIndex, this.state!.multiEndIndex];
    } else {
      const {index} = this.state!.selected;
      if (index != null) {
        indices = [index];
      }
    }
    if (indices == null) {
      return null;
    }
    return {
      // This sorting is necessary because multiStartIndex is the point where the selection started
      // but not necessarily that with the smallest index.
      start: _.min(indices)!,
      // multiStartIndex and multiEndIndex are both inclusive,
      // but end in indexSlice (passed to the printHandler is exclusive)
      // This necessitates adding 1 to the end index.
      end: _.max(indices)! + 1,
    };
  },

  selectionPrintHandler(type: PRINT_OPTION) {
    let indexSlice = null;
    if (type === PRINT_OPTION.SELECTION) {
      indexSlice = this._getSelectedIndexSlice();
      // In case somehow the user triggered print selection without a selection, fallback to a full print.
      if (indexSlice == null) {
        type = PRINT_OPTION.NOTE;
      }
    }
    return this.props!.printHandler?.(type, indexSlice);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChangeSelected(value: any) {
    this.setState?.({selected: value});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChangeFormatState(value: any) {
    this.setState?.({formatState: value});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChangeAtSignState(value: any) {
    this.setState?.({atSignState: value});
  },

  handleChangeSlashSignState(value: SignState) {
    if (
      // If the slash macro view was not being shown before and will now be shown, attempt to force acquire the
      // realtime lock. This is to prevent the user from accidentally losing the lock while trying to search
      // for the appropriate slash macro option.
      (value && !this.state!.slashSignState && !value.hidden) ||
      (!value?.hidden && this.state!.slashSignState?.hidden)
    ) {
      DocumentEditorLockUtil.forceAcquireLock(this.props!.fileId!);
    }
    this.setState?.({slashSignState: value});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChangeHyperlinkState(value: any) {
    this.setState?.({hyperlinkState: value});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChangeNonEmptySelectionState(value: any) {
    this.setState?.({nonEmptySelectionState: value});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSlashSelect(id: any) {
    // get text and replace it with empty
    const {query} = this.state!.slashSignState!;
    const {text: oldText, formats: oldFormats} = this.getText!(this.atIndex!(this.state!.selected.index!));

    const before = oldText.slice(0, query.start);
    const selected = oldText.slice(query.start, query.end);
    const after = oldText.slice(query.end);
    const {formats, text, end} = formatters.replaceText(oldFormats, {before, after, selected}, '');
    this.updateFormattedText({start: end, end, formats, text}, this.state!.selected.index!);
    // add a new line to split the text at the /, unless we're inserting a symbol
    if (after.length > 0 && id !== DropdownFormat.SYMBOL) {
      this.noteSplitHandler(this.state!.selected.index!, {before, after, selected});
    }
    _.defer(() => {
      this._toolbarFormatHandler(id, undefined);
    });
  },

  render() {
    return (
      <div
        className={classNames('noteEditor mediocre', {
          slashText: BenchlingConfig.ENABLE_SLASH_MACRO_FOR_NOTEBOOK,
        })}
      >
        {this.renderModals()}
        {!this.allowSplitScreen!() && this.shouldRenderMaximizedTable!()
          ? this.renderFocusedTable!()
          : this.renderFocusedEditor()}
        {this.renderOnboardingModule()}
      </div>
    );
  },

  renderFocusedEditor() {
    const toolbarProps = this.getToolBarProps();
    return (
      <div style={{display: 'flex', flexDirection: 'column', height: '100%', width: '100%'}}>
        <ResizableContainer enabled={this.allowSplitScreen!()} style={{flexGrow: 1, minHeight: '285px'}}>
          <ResizablePanel
            enabled={this.allowSplitScreen!()}
            index={0}
            minSize={15}
            isRendered={!this.shouldRenderMaximizedTable!()}
            onCollapse={() => {
              this.setMaximizedTable!(this.state!.focusedTableProvenanceUuid!);
            }}
            onExpand={() => {
              this.setSplitScreenTable!(this.state!.focusedTableProvenanceUuid!);
            }}
          >
            <div style={{display: 'flex', flexDirection: 'column', height: '100%', width: '100%'}}>
              {(() => {
                if (this.state!.attachIndex == null) {
                  return null;
                }
                // TODO(saif): This should be an extension point for the molbio preview plugins
                const pluginsForFile =
                  PLUGINS_BY_FILE_TYPE[this.props!.fileType as keyof typeof PLUGINS_BY_FILE_TYPE] || [];
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filePlugins = this.plugins.filter((plugin: {type: any}) =>
                  pluginsForFile.includes(plugin.type)
                );
                const part = this.atIndex!(this.state!.attachIndex);
                return (
                  <AttachModal
                    key="attach-modal"
                    options={filePlugins}
                    closeModalHandler={this.closeAttachFeatureModal}
                    insertItemHandler={this.noteAttachItemHandler.bind(this, this.state!.attachIndex)}
                    itemDetachHandler={this.itemDetachHandler.bind(this, this.state!.attachIndex)}
                    fileId={this.props!.fileId!}
                    attached={
                      part.item ? {type: part.type, item_id: part.item.id, item: part.item} : undefined
                    }
                  />
                );
              })()}
              {this.props!.renderCanvasTitle &&
                this.props!.renderCanvasTitle({
                  updateTitle: this.props!.updateTitle!,
                  title: this.props!.title!,
                  fileId: this.props!.fileId!,
                  titleDisabled: this.props!.locked,
                })}
              {!this.props!.disableFormatting ? this.renderToolbar() : undefined}
              {this._showCollectibleBanner() ? this.renderCollectibleBanner() : undefined}
              {this.props!.renderCanvas
                ? this.props!.renderCanvas({
                    renderedItems: this.getRenderedItems!(this.props!.getItems(this.props!.getRoot())),
                    updateNote: this.props!.updateNote,
                    note: this.props!.note,
                    fileId: this.props!.fileId!,
                    toolbarProps,
                    insertables: getInsertGroupDropdownSections()
                      .flat()
                      .filter(
                        (insertable) =>
                          (insertable.enabled ? insertable.enabled(toolbarProps) : true) &&
                          (insertable.visible ? insertable.visible(toolbarProps) : true)
                      ),
                    insertFormat: this._toolbarFormatHandler,
                    replaceItems: this.replaceItems,
                    itemAtIndex: this.atIndex,
                  })
                : this.renderEditorContainer()}
            </div>
          </ResizablePanel>

          {this.allowSplitScreen!() && (
            <ResizablePanel
              index={1}
              minSize={15}
              defaultSize={this.shouldRenderMaximizedTable!() ? 100 : 50}
              isRendered={this.shouldRenderSplitScreenTable!() || this.shouldRenderMaximizedTable!()}
              onCollapse={() => {
                this.setMaximizedTable!(null);
              }}
              onExpand={() => {
                this._scrollToNotePart(this.state!.focusedTableProvenanceUuid);
              }}
            >
              {(this.shouldRenderSplitScreenTable!() || this.shouldRenderMaximizedTable!()) &&
                this.renderFocusedTable!()}
            </ResizablePanel>
          )}
        </ResizableContainer>
      </div>
    );
  },

  renderEditorContainer() {
    const insertIndex = this.state!.selected.index != null ? this.state!.selected.index : this.lastIndex!();
    return (
      <div
        ref="container"
        key="noteEditor-container"
        className={classNames(
          'noteEditor-container',
          css(styles.minHeight),
          {'is-printLayout': this.props!.printLayout},
          {[css(styles.fullScreen)]: this.props!.fullScreen},
          {
            'with-collectible-banner': this._showCollectibleBanner(),
          }
        )}
      >
        <div
          ref={this.setScrollContainerRef}
          className={classNames('noteEditor-scrollContainer', {
            'is-tableOfContents-open': this.props!.showTableOfContents,
          })}
        >
          {BenchlingConfig.ENABLE_SLASH_MACRO_FOR_NOTEBOOK &&
          this.state!.slashSignState != null &&
          !this.state!.slashSignState.hidden ? (
            <SlashSearchDropdown
              // @ts-expect-error: TODO convert this to a React.createRef
              ref="attachSlashDropdown"
              query={this.state!.slashSignState.query.text}
              selectAttachment={this.handleSlashSelect}
              close={this.closeSlashSearchDropdown}
              slashSignBox={this.state!.slashSignState.box}
              containerWidth={this.state!.containerWidth!}
              containerHeight={this.state!.containerHeight!}
              containerIsFullScreen={this.props!.fullScreen!}
              fileId={this.props!.fileId!}
              toolbarProps={this.getToolBarProps()}
            />
          ) : undefined}
          {this.state!.atSignState != null && !this.state!.atSignState.hidden ? (
            <PositionedLinkSearchDropdown
              emptyQueryMessage={<LinkSearchDefaultQueryMessage />}
              ref="attachDropdown"
              fileId={this.props!.fileId!}
              query={this.state!.atSignState.query.text}
              selectAttachment={(id, name, url, linkedItem, internalLink) => {
                this.insertInternalLink(id, linkedItem, internalLink);
              }}
              close={this.closeLinkSearchDropdown}
              atSignBox={{
                top: this.state!.atSignState.box.top,
                left: this.state!.atSignState.box.left,
                bottom: this.state!.atSignState.box.bottom,
              }}
              containerWidth={this.state!.containerWidth!}
              containerHeight={this.state!.containerHeight!}
              containerIsFullScreen={this.props!.fullScreen!}
              shouldSearchEntities={true}
              shouldSearchStorables={true}
            />
          ) : undefined}
          {this.state!.hyperlinkState != null ? (
            <PositionedLinkPopover
              hyperlinkState={this.state!.hyperlinkState}
              onChange={() => {
                this._toolbarFormatHandler(FormattersConstants.LINK);
              }}
              onRemove={() => {
                this._toolbarFormatHandler(FormattersConstants.SET_LINK, {data: {url: null}});
              }}
              containerWidth={this.state!.containerWidth!}
            />
          ) : undefined}
          {BenchlingConfig.ENABLE_HOVERING_FORMAT_TOOLBAR && this.state!.nonEmptySelectionState && (
            <PositionedPopover
              className="u-position-absolute"
              top={this.state!.nonEmptySelectionState.box.top}
              left={this.state!.nonEmptySelectionState.box.left}
              width={HIGHLIGHT_TEXT_EDITOR_WIDTH}
              showArrow={false}
            >
              <NoteToolbar {...this.getToolBarProps()} minimal={true} />
            </PositionedPopover>
          )}
          <DatetimePickerContext.Provider value={{containerNodeSelector: '.noteEditor'}}>
            <NoteCatcher
              ref="catcher"
              fileId={this.props!.fileId!}
              fullScreen={this.props!.fullScreen!}
              fullHeight={this.props!.fullHeight}
              hideTitle={this.props!.hideTitle!}
              insertItemHandler={this._catcherInsertFile.bind(null, insertIndex)}
              insertFilePlaceholderHandler={this._catcherInsertFilePlaceholder.bind(null, insertIndex)}
              locked={this.props!.locked!}
              dirty={this.props!.dirty}
              isProtected={this.isProtectedAgainstEdit()}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onMouseDown={!this.props!.locked ? (this.onMouseDownCatcher as any) : undefined}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              selected={this.state!.selected as any}
              setInsertIndex={this._catcherSetInsertIndex}
            >
              <div
                ref="noteEditor-contentWrapper"
                className="noteEditor-contentWrapper"
                data-mediocre-item-whitespace="1"
              >
                {!this.props!.hideTitle ? (
                  <TitleEditor
                    key="title"
                    locked={this.props!.locked!}
                    updateTitle={this.props!.updateTitle}
                    humanId={this.props!.humanId!}
                    templateVersionId={this.props!.templateVersionId}
                    templateUrl={this.props!.templateUrl}
                    templateVersionTimestamp={this.props!.templateVersionTimestamp}
                    creator={this.props!.note!.creator as User}
                    title={this.props!.title!}
                    storeState={
                      this.props!.storeState! as (selectionData: {selection: SelectionRestoreData}) => void
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    restoreState={this.props!.restoreState! as any} // TODO: Is this being passed correctly? The parameter types don't line up
                    requestSelection={this.props!.requestSelection!}
                    moveHandler={this.titleMoveHandler}
                    badge={this.props!.titleBadge}
                    editorIcon={this.props!.editorIcon}
                  />
                ) : null}
                {this.props!.beforeEntry}
                {this.props!.showTableOfContents ? (
                  <TableOfContents
                    note={this.props!.note!}
                    getElementByScrollId={this.getElementByScrollId}
                    getTextForDate={this.getTextForDate}
                    locked={this.props!.locked!}
                    documentContainer={this.scrollContainerNode}
                    fileType={this.props!.fileType!}
                    sectionToggle={this._handleSectionToggle}
                  />
                ) : undefined}
                <SelectionReader
                  selected={this.state!.selected}
                  onChangeSelected={this.handleChangeSelected}
                  formatState={this.state!.formatState}
                  onChangeFormatState={this.handleChangeFormatState}
                  atSignState={this.state!.atSignState!}
                  onChangeAtSignState={this.handleChangeAtSignState}
                  hyperlinkState={this.state!.hyperlinkState!}
                  onChangeHyperlinkState={this.handleChangeHyperlinkState}
                  scrollableParentSelector=".noteEditor-scrollContainer"
                  slashSignState={this.state!.slashSignState!}
                  onChangeSlashSignState={this.handleChangeSlashSignState}
                  nonEmptySelectionState={this.state!.nonEmptySelectionState}
                  onChangeNonEmptySelectionState={this.handleChangeNonEmptySelectionState}
                >
                  {this.renderEditorSlice()}
                </SelectionReader>
                {this.props!.afterEntry}
                {this.props!.showPrintMargins ? (
                  <div>
                    <div className="mediocre-pageMargin mediocre-pageMargin--left" />
                    <div className="mediocre-pageMargin mediocre-pageMargin--right" />
                  </div>
                ) : undefined}
                {!this.props?.viewer ? (
                  <HashNavigationManager
                    noteDays={this.props?.note?.days ?? []}
                    documentContainer={this.scrollContainerNode}
                  />
                ) : undefined}
              </div>
            </NoteCatcher>
          </DatetimePickerContext.Provider>
        </div>
      </div>
    );
  },

  renderModals() {
    return (
      <div>
        {/* Use a DIV container to prevent modals's <noscript> from causing a large reflow */}
        {this.renderInsertSymbolModal()}
        <EditLinkModal
          fileId={this.props!.fileId!}
          showInsertLinkModal={this.state!.showInsertLinkModal}
          editingLinkState={this.state!.editingLinkState}
          closeInsertLinkModal={this.closeInsertLinkModal}
          updateFormattedText={this.updateFormattedText}
        />
        {this.renderSavedSearchInsertModal()}
        {this.renderSubtemplateInsertModal()}
        {this.renderResultsTableInsertModal()}
        {this.renderEntryDayInsertModal()}
        {this.renderRunInsertModal()}
        {this.renderChemicalStructureInsertModal()}
        {this.renderFixedPlateEditorModal()}
        {this.renderCreatePlateTemplateModal()}
        {this.renderAIContentInsertModal()}
        {this.renderRegistrationTableInsertModal()}
        {this.renderInventoryTableInsertModal()}
        {this.renderGridCreationTableInsertModal()}
        {this.renderMixturePrepGroupInsertModal()}
        {this.renderLookupTableInsertModal()}
        {this.renderParameterTableInsertModal()}
        {this.renderAppCanvasInsertModal()}
      </div>
    );
  },

  renderOnboardingModule() {
    return this.props!.parentType === 'Entry' ? (
      <div className="noteEditor-nueModuleContainer" style={{left: '16px'}}>
        <EntryNUEModule isSampleEntry={ONBOARDING_ENTRY_NAMES.includes(this.props!.title!)} />
      </div>
    ) : undefined;
  },

  getElementByScrollId(cid: string) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (ReactDOM.findDOMNode(this as any) as Element).querySelector(`[data-scroll-id='${cid}']`);
  },

  renderEditorSlice() {
    const indexSlice =
      this.props!.indexSlice != null
        ? this.props!.indexSlice
        : convertDateSliceToIndexSlice(this.props!.dateSlice!, this.props!.note!.days!);
    return this.renderEditor!(indexSlice);
  },

  formatAtIndexHandler(
    index: number,
    args: {
      format: string;
      partition: SelectionPartition;
    }
  ) {
    this.formatHandler({index}, args);
  },

  itemDetachHandler(index: number) {
    const newPart = {
      ...this.atIndex!(index), // old part
      alignment: null,
      table: null,
      item: null,
      item_id: null,
      itemWidth: null,
      type: TEXT,
      placeholder: false,
    };
    this.props!.requestSelection?.({selection: selutil.getSelectionIndices()});
    this.replaceItems(index, 1, newPart);
    this.setState?.({highlightIndex: null});
    this.closeAttachFeatureModal();
  },

  // Required by note plugin

  captionSplitHandler(index: number, e: {shiftKey?: boolean; before?: string; after?: string}) {
    const item = this.atIndex!(index);
    const cid = this.props!.getCid(item);
    const {before, after} = e;
    const fmtText = this.getText!(item);
    let formats = formatters.splitFormats(fmtText.formats, before!.length);

    if (e.shiftKey) {
      const pos = before!.length + 1;
      formats = formatters.joinFormats(formats.before, formats.after, pos);
      const text = `${before}\n${after}`;
      const selection = {cid, start: pos, end: pos};
      this.updateItemText!(index, {text, formats});
      this.props!.requestSelection?.({selection});
    } else {
      const replacePart = this.withUpdatedText!(item, {text: before!, formats: formats.before});
      let newPart = this.makeItem(this.textType);
      newPart = this.withUpdatedText!(newPart, {text: after!, formats: formats.after});
      newPart = this.withUpdatedListStyle(newPart, {
        indentation: this.getIndentation(item),
        listType: this.getListType(item),
      });
      this.replaceItems(index, 1, replacePart, newPart);
      this.props!.requestSelection?.({selection: {cid: newPart.cid, start: 0, end: 0}});
    }
  },

  noteSplitHandler(
    index: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e: {before: string; after: string; selected: any; afterPoint: any; shiftKey: boolean}
  ) {
    const {before, after, selected, afterPoint, shiftKey} = e;
    let currentPart = this.atIndex!(index);

    // If we enter on an empty numbered or bulleted part, unindent (and remove list type if necessary)
    if ((before + selected + after).length === 0 && this.getListType(currentPart) != null) {
      const curIndentation = this.getIndentation(currentPart);
      currentPart = this.withUpdatedListStyle(currentPart, {
        indentation: curIndentation - 1,
        listType: curIndentation === 1 ? null : this.getListType(currentPart),
      });
      this.replaceItems(index, 1, currentPart);
      return;
    }

    const {formats} = this.getText!(currentPart);
    let splitFormats = formatters.splitFormats(formats, before.length, afterPoint);
    const replacePart = this.withUpdatedText!(currentPart, {text: before, formats: splitFormats.before});

    let newPart = this.makeItem(TEXT);
    splitFormats = formatters.splitFormats(formats, before.length + selected.length, afterPoint);
    newPart = this.withUpdatedText!(newPart, {text: after, formats: splitFormats.after});

    let listType = shiftKey ? null : this.getListType(currentPart);
    if (listType === CHECKBOX_CHECKED) {
      listType = CHECKBOX_UNCHECKED; // Never insert an already checked checkbox
    }
    const headerType = !shiftKey && after.length === 0 ? PARAGRAPH : this.getHeaderType(currentPart);
    newPart = {...newPart, indentation: this.getIndentation(currentPart), listType, headerType};

    this.replaceItems(index, 1, replacePart, newPart);
    this.props!.requestSelection?.({selection: {cid: newPart.cid, start: 0, end: 0}});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateItemCode(index: number, code: any) {
    this.itemUpdateHandler!(index, {code});
  },

  // Used to insert special characters (tab, newline, etc)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _codeInsertHandler(index: number, e: {before: string; after: string}, toInsert: string | Array<any>) {
    const item = this.atIndex!(index);
    const cid = this.props!.getCid(item);
    const {before, after} = e;
    let {code} = this.props!.getContent(item) as {code: string};
    const pos = before.length + toInsert.length;
    code = before + toInsert + after;
    const selection = {cid, start: pos, end: pos};
    this.updateItemCode(index, code);
    this.props!.requestSelection?.({selection});
  },

  // This helper is used to insert special characters (tab, newline, etc) into the textBox note part.
  // We cannot mimic the TextPlugin since it, on a newline, splits the note part in 2 instead of inserting
  // a newline. This function also preserves / updates formatting accordingly.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _textInsertHandler(index: number, e: any, toInsert: any) {
    const item = this.atIndex!(index);
    const cid = this.props!.getCid(item);
    const oldFormats = (this.props!.getContent(item) as {formats?: Format}).formats;
    const {formats: newFormats, text, start, end: oldEnd} = formatters.replaceText(oldFormats, e, toInsert);
    const {end} = formatters.getSelectionIndicesFromFormatIndices(newFormats, start, oldEnd);
    this.updateFormattedText({text, start: end, end, formats: newFormats}, index);
    const selection = {cid, start: end, end};
    this.props!.requestSelection?.({selection});
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  codeSplitHandler(index: number, e: any) {
    this._codeInsertHandler(index, e, '\n');
  },

  codeTabHandler(index: number, e: {partition: {before: string; after: string}}) {
    if (e.partition == null) {
      return;
    }
    this._codeInsertHandler(index, e.partition, CODE_TAB);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  textSplitHandler(index: number, e: any) {
    this._textInsertHandler(index, e, '\n');
  },

  // Input boxes (code or text) should never merge with non-input, the only merge function should be delete
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputBoxDeleteHandler(index: number, param: any | null) {
    if (param == null) {
      param = false;
    }
    const {alwaysDelete} = param;
    const {blockText} = this.props!.getContent(this.atIndex!(index)) as {blockText: string};
    if (alwaysDelete || blockText.trim().length <= 0) {
      this.replaceItems(index, 1);
      if (index > 0) {
        const aboveItem = this.atIndex!(index - 1);
        this.props!.requestSelection?.(this.selectionAtEnd!(aboveItem));
      } else {
        // This code path is currently never hit since the first note part in every entry is a text note part.
        // Keeping logic for future use cases - i.e filling out an entry via an api such that first note part isn't a
        // text note part.
        const belowItem = this.atIndex!(index + 1);
        this.props!.requestSelection?.(this.selectionAtStart!(belowItem));
      }
    }
  },

  codeUpdateHandler(index: number, {text}: {text: string}) {
    this.props!.requestSelection?.({selection: selutil.getSelectionIndices()});
    this.itemUpdateHandler!(index, {code: text});
  },

  inputBoxCursorHandler(index: number, {position}: {position: string}) {
    const item = this.atIndex!(index);
    const cid = this.props!.getCid(item);
    const {blockText} = this.props!.getContent(item);
    const start = position === 'start' ? 0 : blockText.length;
    this.props!.requestSelection?.({selection: {cid, start, end: start}});
  },

  /**
   * Determine whether editing should be restricted based on `note.isProtected`, and whether this file is an
   * entry or document.
   */
  isProtectedAgainstEdit() {
    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.props!.note as any)!.isProtected === true &&
      (APIUtil.apiIdToType(this.props!.fileId!) === ModelTypeConstants.ENTRY ||
        (APIUtil.apiIdToType(this.props!.fileId!) === ModelTypeConstants.DOCUMENT && !this.props!.isConfig))
    );
  },

  isLockedWithEditWarn() {
    const isEditingDisabled = this.props!.locked || this.isProtectedAgainstEdit();
    if (isEditingDisabled) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      notifications.warn(this.props!.banner != null ? (this.props!.banner as any) : 'Editing is disabled.', {
        id: 'NoteEditor.isLockedWithEditWarn',
      });
    }

    return isEditingDisabled;
  },

  tabRangeHandler({start, end, shiftKey}: {start: number; end: number; shiftKey: boolean}) {
    assert(start <= end, 'Start must be less than or equal to end.');
    const indentShift = shiftKey ? -1 : 1;
    const noteParts = [];
    for (let index = start; index <= end; index++) {
      let notePart = this.atIndex!(index);
      const minIndentation = notePart.listType == null ? 0 : 1;
      notePart = {
        ...notePart,
        indentation: clamp(minIndentation, MAX_INDENTATION, notePart.indentation + indentShift),
      };
      noteParts.push(notePart);
    }
    this.replaceItems(start, end - start + 1, ...noteParts);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tabHandler(index: number, e: {partition: SelectionPartition; shiftKey: any}) {
    const {partition, shiftKey} = e;
    if (partition != null && partition.before !== '') {
      const currentPart = this.atIndex!(index);
      const {formats: oldFormats} = this.getText!(currentPart);
      // Replace selected characters with ASCII tab
      const {formats, text, end} = formatters.replaceText(oldFormats, partition, TAB);
      // After insert, place cursor at end of range
      this.updateFormattedText({text, start: end, end, formats}, index);
    } else {
      this.tabRangeHandler({start: index, end: index, shiftKey});
    }
  },

  // Keep in sync with FormulaEditable._selectAttachment
  // so that at-mentions behave similarly in tables and paragraphs
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertInternalLink(id: string, linkedItem: any, internalLink?: MediocreConstants.InternalLink) {
    assert(Boolean(internalLink), 'Unable to insert link for search result', {id});
    const {query} = this.state!.atSignState!;
    const {text: oldText, formats: oldFormats} = this.getText!(this.atIndex!(this.state!.selected.index!));

    const before = oldText.slice(0, query.start);
    const selected = oldText.slice(query.start, query.end);
    const after = oldText.slice(query.end);
    // Where to insert the chip in the array of point elements (because they're rendered in array order)
    const pointIndex = selutil.getSelectionIndices().start - query.end;
    const {formats, text, end} = formatters.replaceWithInternalLink(
      oldFormats,
      {before, after, selected},
      internalLink,
      pointIndex
    );
    trackInternalLink(this.props!.fileId!, id, linkedItem, ActionOrigin.NOTEBOOK);
    this.updateFormattedText({start: end, end, formats, text}, this.state!.selected.index!);
    if (APIUtil.isNucleotideSequence(id)) {
      OnboardingActions.completeOnboardingTask(
        OnboardingConstants.MODULES.ENTRY,
        OnboardingConstants.LINK_SEQUENCE
      );
    }
  },

  closeLinkSearchDropdown() {
    assert(this.state!.atSignState != null, 'Cannot close link search dropdown when it is not open');
    this.setState?.({atSignState: reactUpdate(this.state!.atSignState, {hidden: {$set: true}})});
  },

  closeSlashSearchDropdown() {
    assert(this.state!.slashSignState != null, 'Cannot close slash search dropdown when it is not open');
    this.setState?.({slashSignState: reactUpdate(this.state!.slashSignState, {hidden: {$set: true}})});
  },

  // Required for attach feature modal
  closeAttachFeatureModal() {
    this.setAttachFeatureIndex(null);
    this.setState?.({highlightIndex: null});
  },

  setAttachFeatureIndex(index: number) {
    // eslint-disable-next-line benchlint/no-eqeqeq-null
    if (index === null) {
      if (this.state!.attachSelection != null) {
        this.props!.requestSelection?.({selection: this.state!.attachSelection});
      }
      this.setState?.({attachIndex: null});
    } else {
      this.setState?.({attachIndex: index, attachSelection: selutil.getSelectionIndices()});
    }
  },

  insertExcerptsHandler(
    index: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    excerpts: Array<any>,
    {replace}: {replace?: boolean} = {replace: false}
  ) {
    if (excerpts.length === 0) {
      return;
    }
    const currentItem = this.atIndex!(index);
    const oldNoteLinkedFile = currentItem.item!;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const oldNoteLinkedFileId = this.props!.getIdFromCid!((oldNoteLinkedFile as any).cid);
    const cidIdMap: CidIdMap = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = excerpts.map((excerpt: any, i: any) => {
      const cid = _.uniqueId('note-linked-object');
      cidIdMap[cid] = oldNoteLinkedFileId!;
      let item = this.makeItem(currentItem.type);
      item = this.withAttachedItem(item, currentItem.type, currentItem.item_id, {
        ...oldNoteLinkedFile,
        cid,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any);
      return reactUpdate(item, {
        item: {
          $merge: {
            externalFileExcerpt: excerpt,
            // This `item` notePart will sync when the external file attached to the `currentItem` notePart
            // changes, which happens via TFI sync with the corresponding `currentItem.item.tfiFileMeta`;
            // and so, there's no reason to redundantly store this TFI reference on the excerpt.
            tfiFileMeta: null,
          },
        },
      });
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.props!.registerObjects?.(cidIdMap as any);
    if (replace) {
      this.replaceItems(index, 1, ...items);
    } else {
      this.replaceItems(index + 1, 0, ...items);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateNoteLinkedObject(index: number, updates: any) {
    const currentItem = this.atIndex!(index);
    const newItem = reactUpdate(currentItem, {item: {$merge: updates}});
    this.replaceItems(index, 1, newItem);
    // At minimum, renames should appear in undo/redo history
    if (Object.hasOwn(updates, 'name')) {
      this.props!.storeState!();
    }
  },

  storeStateForNoteLinkedObject(notePart: NotePart) {
    this.props!.storeState!({
      selection: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        cid: CaptionEditableClass.getAttachmentCid((notePart as any).cid),
        start: 0,
        end: 0,
      },
    });
  },

  /**
   * Attach (replace) a NoteLinkedObject on a notePart
   */
  replaceExistingNoteLinkedObject(
    cid: string,
    noteLinkedObject: NoteLinkedFile | FromServerNoteLinkedFile,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options?: {itemWidth?: any}
  ) {
    const {id} = noteLinkedObject;
    const {itemWidth} = options || {};
    const index = this.getIndex!(cid);
    const currentItem = this.atIndex!(index);
    if (!currentItem || !currentItem.item) {
      return;
    }
    this.storeStateForNoteLinkedObject(currentItem);
    const newItem = {
      ...this.withAttachedItem(currentItem, NOTE_LINKED_OBJECT, id!, noteLinkedObject),
      itemWidth,
    };

    // Registers a new cid for the new noteLinkedObject.
    const cidIdMap: CidIdMap = {};
    NoteStoreTransforms.prepareNLOForStore(newItem, cidIdMap);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.props!.registerObjects?.(cidIdMap as any);

    this.replaceItems(index, 1, newItem);
  },

  /**
   * Replace the noteLinkedFile on the notePart with the given `newNoteLinkedFile`.
   *
   * Also refresh all excerpts of the original noteLinkedFile's externalFile.
   */
  async setUpdatedNoteLinkedFile(index: number, newNoteLinkedFile: FromServerNoteLinkedFile) {
    const currentItem = this.atIndex!(index);
    this.storeStateForNoteLinkedObject(currentItem);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const externalFile = (currentItem.item as any).externalFile;
    // Fetch excerpts if necesssary
    const hasLinkedExcerpts = this.props!.getItems(this.props!.getRoot()).some((notePart: NotePart) =>
      NoteLinkedFileUtil.hasExcerptOfExternalFile(notePart, externalFile)
    );
    const hasExternalFileChanged = newNoteLinkedFile.externalFile !== externalFile;
    const excerpts =
      hasLinkedExcerpts && hasExternalFileChanged
        ? await withLoadingScreen(
            Promise.resolve(
              ExternalFileDAO.fetchExcerpts(
                newNoteLinkedFile.externalFile!.id,
                NoteLinkedFileUtil.getExcerptOffsets(
                  this.props!.getItems(this.props!.getRoot()),
                  externalFile
                ),
                true
              )
            ),
            'Updating excerpts...'
          )
        : null;

    // Replace old NLF / excerpts to point to the new NLF / excerpts.
    const cidIdMap: CidIdMap = {};
    const newRoot = reactUpdate(
      this.props!.getRoot(),
      this.props!.itemsAccessor({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $apply: (noteParts: Array<any>) =>
          noteParts.map((notePart: NotePart) =>
            NoteLinkedFileUtil.maybeReplaceExternalFile(
              notePart,
              currentItem,
              newNoteLinkedFile,
              excerpts,
              cidIdMap
            )
          ),
      })
    );
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.props!.registerObjects?.(cidIdMap as any);
    this.props!.updateRoot?.(newRoot);
  },

  insertNoteLinkedObject(index: number, noteLinkedObject: NotePart) {
    this.storeStateForNoteLinkedObject(noteLinkedObject);
    const newItem = this.withAttachedItem(
      makeDefaultItem(NOTE_LINKED_OBJECT),
      NOTE_LINKED_OBJECT,
      noteLinkedObject.id!,
      noteLinkedObject
    );
    const cidIdMap: CidIdMap = {};
    NoteStoreTransforms.prepareNLOForStore(newItem, cidIdMap);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.props!.registerObjects?.(cidIdMap as any);
    this.itemInsertHandler?.(index, newItem);
  },

  insertNoteLinkedFileFromS3Location(index: number, s3Location: string) {
    return withLoadingScreen(
      NoteLinkedFileDAO.create({
        location: s3Location,
      }).then((res) => {
        // Is the following cast correct? It seems like it should be a NoteLinkedFile but the other methods
        // that use insertNoteLinkedObject pass a NotePart?
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.insertNoteLinkedObject(index, res as any);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }) as any
    );
  },

  async setImageFromS3Location(
    cid: string,
    previewS3Location: string,
    itemWidth: number,
    name: string,
    edits?: string
  ) {
    const index = this.getIndex!(cid);
    const notePart = this.atIndex!(index);
    // This function is called asynchronously; when we get here, the item being replaced may no longer exist.
    if (notePart?.item_id == null) {
      return;
    }
    const newNoteLinkedObject = await NoteLinkedFileDAO.transform({
      uuid: notePart.item_id as string,
      previewLocation: previewS3Location,
      edits,
    });
    // Replace the existing NLO with the new transformed NLO with current name
    this.replaceExistingNoteLinkedObject(cid, {...newNoteLinkedObject, name} as NoteLinkedFile, {itemWidth});
  },

  async setNoteLinkedFileFromS3Location(cid: string, s3Location: string) {
    const index = this.getIndex!(cid);
    const notePart = this.atIndex!(index);
    // This function is called asynchronously; when we get here, the item being replaced may no longer exist.
    if (notePart?.item_id == null) {
      return;
    }
    await withLoadingScreen(
      NoteLinkedFileDAO.create({
        location: s3Location,
      }).then((res) => {
        this.replaceExistingNoteLinkedObject(cid, res!);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }) as any
    );
  },

  withAttachedItem(
    currentItem: NotePart,
    type: string,
    itemId: string | number | null,
    linkedItem: LinkedItem,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    param?: {externalFileExcerpt?: any}
  ) {
    if (param == null) {
      param = {};
    }
    const {externalFileExcerpt} = param;
    return {
      ...currentItem,
      item_id: itemId,
      type,
      item: linkedItem,
      itemWidth: null,
      externalFileExcerpt: externalFileExcerpt != null ? externalFileExcerpt : null,
      alignment: 'left',
      listType: null,
      placeholder: false,
    };
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replacePlaceholderWithFile(index: number, taskIdsAndDeferreds: string | Array<any>) {
    assert(
      taskIdsAndDeferreds.length === 1,
      `Expect to be processing only one file drag-and-dropped \
onto a placeholder`
    );
    const {taskId, fileUploadDeferred} = taskIdsAndDeferreds[0];
    const baseItem = this.atIndex!(index);
    const newItem = this.createFilePlaceholderForTask({taskId, fileUploadDeferred}, baseItem);
    this.replaceItems(index, 1, newItem);
  },

  replacePlaceholderWithBenchlingItem(index: number, item: NotePart) {
    // Call through to noteAttachItemHandler
    this.noteAttachItemHandler(index, APIUtil.apiIdToType(item.id!), item.id, item);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  uploadAndAttachToItem(index: number, file: any) {
    const [taskIdAndDeferred] = ExternalFileUpload.createTaskAndUploadFiles(this.props!.fileId!, [file]);
    this.replacePlaceholderWithFile(index, [taskIdAndDeferred]);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  noteAttachItemHandler(index: number, type: any, itemId: any, item: NotePart) {
    const currentItem = this.atIndex!(index);
    const newItem = this.withAttachedItem(currentItem, type, itemId, item);
    this.replaceItems(index, 1, newItem);
  },

  async insertSubtemplate(subtemplateId: string, indexOverride: number) {
    LoadingScreen.show();
    const cidMap: CidIdMap = {};
    const usedTableNames = this.props!.usedTableNames!();
    const {rootFolderId: projectId, fileId, templateCollectionId} = this.props!.editorPropertiesContext;
    const fileAnalyticsParams = {projectId, fileId, templateCollectionId};
    try {
      assert(this.props != null, 'NoteEditor props should not be null');
      const {fileId} = this.props;
      assert(fileId != null, 'A subtemplate should only be insertable in something with a fileId');
      const fetchedSubtemplate = await SubtemplateDAO.get(subtemplateId, true);

      const templateCollectionId = fetchedSubtemplate.templateCollection.id;
      const subtemplateNoteParts = fetchedSubtemplate.subtemplateVersion.noteVersion.noteParts.map(
        (notePart): NotePart => {
          NoteStoreTransforms.prepareNotePartForStore(notePart, cidMap);
          // prepareNotePartForStore adds a CID to the notePart
          return notePart as unknown as NotePart;
        }
      );
      const convertedNoteParts = this.convertItemsForPaste!(
        subtemplateNoteParts,
        fileId,
        usedTableNames,
        this.props.isConfig
      ).items;

      if (convertedNoteParts == null || convertedNoteParts.length === 0) {
        LoadingScreen.hide();
        return;
      }

      // Collect all tables being inserted to check for selectors.
      const tables = convertedNoteParts
        .filter((item) => item.type === this.tableType)
        .map((item) => item.table!.table);
      LoadingScreen.hide();
      // Resolve selectors from any tables that contain them; also handles conflicts between selectors.
      const selectors = (await resolveSelectorsFromPastedItems({
        pastedTables: tables,
        pastedSelectors: fetchedSubtemplate.subtemplateVersion.noteVersion.selectors,
        existingSelectors: this.getSelectors!(),
      })) as Array<Selector>;
      LoadingScreen.show();
      // Need to check for empty note parts again
      if (convertedNoteParts == null || convertedNoteParts.length === 0) {
        LoadingScreen.hide();
        notifications.warn('Cannot insert empty subtemplates.');
        return;
      }
      // If there are any selectors to add, update the editor's available selectors.
      if (selectors) {
        const finalSelectors = selectors.map((selector: Selector) =>
          SelectorDAO.prepareForStore(selector, cidMap)
        );
        this.props.updateSelectors!(finalSelectors);
      }
      this.props.registerObjects?.(cidMap);
      this.itemInsertHandler?.(indexOverride ?? this.state!.selected.index, ...convertedNoteParts);

      // Insert Table Mappings from the Subtemplate
      const subtemplateTableMappings =
        fetchedSubtemplate.subtemplateVersion.noteVersion.structuredTableMappings;
      if (subtemplateTableMappings?.length) {
        const changedStructuredTableUuids = getChangedStructuredTableUuids(
          getAllStructuredTablesFromNoteParts(subtemplateNoteParts),
          getAllStructuredTablesFromNoteParts(convertedNoteParts)
        );
        const convertedTableMappings = updateStructuredTableMappingUuids(
          subtemplateTableMappings,
          changedStructuredTableUuids
        );
        const existingTableMappings =
          StructuredTableMappingsGlobalState.getState(fileId).structuredTableMappings;
        // add the new table mappings from the Subtemplate to the main note
        this.props?.setStructuredTableMappings?.([...existingTableMappings, ...convertedTableMappings]);
      }

      // Move cursor to the initial index
      this.props.requestSelection?.(
        this.selectionAtStart!(this.atIndex!(indexOverride ?? this.state!.selected.index))
      );
      const entryAnalyticsData = getFileAnalyticsMetadata(fileAnalyticsParams);
      const subtemplateInsertionAnalyticsData = {
        ...entryAnalyticsData,
        subtemplate_id: subtemplateId,
        template_collection_id: templateCollectionId,
      };
      analytics.trackEvent(ELN_ANALYTICS_ACTIONS.INSERTED_SUBTEMPLATE, subtemplateInsertionAnalyticsData);
    } finally {
      LoadingScreen.hide();
    }
  },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default withSpreadsheetEvaluation(NoteEditor as any) as React.ComponentClass<NoteEditorProps>;

const styles = StyleSheet.create({
  fullScreen: {
    position: 'absolute',
  },
  minHeight: {
    minHeight: NOTE_EDITOR_MIN_HEIGHT,
  },
});
